import React, { useContext, useMemo, useState, useEffect, useRef } from 'react';
import styled, { css, ThemeContext, ThemeProvider } from 'styled-components';
import NumberFormat from 'react-number-format';
import { Helmet } from 'react-helmet';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

var img$o = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12.126' height='7.622' viewBox='0 0 12.126 7.622'%3e %3cpath id='angle_right_small' d='M4.954%2c1.261l-.5.5-3.6%2c3.6a.548.548%2c0%2c0%2c1-.722%2c0%2c.548.548%2c0%2c0%2c1%2c0-.72l4.5-4.5a.547.547%2c0%2c0%2c1%2c.72%2c0l4.5%2c4.5a.547.547%2c0%2c0%2c1%2c0%2c.722.547.547%2c0%2c0%2c1-.72%2c0l-3.6-3.6Z' transform='translate(11.064 6.56) rotate(180)' fill='%230c0f14' stroke='%230c0f14' stroke-width='2'/%3e%3c/svg%3e";

var img$n = "data:image/svg+xml,%3csvg id='icon_md_sucesso' xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e %3ccircle id='Elipse_541' data-name='Elipse 541' cx='15' cy='15' r='15' fill='%234d993a'/%3e %3cg id='Grupo_6835' data-name='Grupo 6835' transform='translate(8.923 10.588)'%3e %3cpath id='Caminho_3302' data-name='Caminho 3302' d='M91.872%2c203.829a1.143%2c1.143%2c0%2c0%2c1%2c0%2c1.588l-.886.886a1.143%2c1.143%2c0%2c0%2c1-1.588%2c0l-3.878-3.909a1.143%2c1.143%2c0%2c0%2c1%2c0-1.588l.886-.886a1.143%2c1.143%2c0%2c0%2c1%2c1.588%2c0Z' transform='translate(-85.2 -196.76)' fill='white'/%3e %3cpath id='Caminho_3303' data-name='Caminho 3303' d='M171.438%2c125.521a1.143%2c1.143%2c0%2c0%2c1%2c1.588%2c0l.886.886a1.143%2c1.143%2c0%2c0%2c1%2c0%2c1.588l-6.718%2c6.687a1.143%2c1.143%2c0%2c0%2c1-1.588%2c0l-.886-.886a1.143%2c1.143%2c0%2c0%2c1%2c0-1.588Z' transform='translate(-161.377 -125.2)' fill='white'/%3e %3c/g%3e%3c/svg%3e";

var img$m = "data:image/svg+xml,%3csvg id='icon_sm_information' xmlns='http://www.w3.org/2000/svg' width='20' height='22.849' viewBox='0 0 20 22.849'%3e %3cpath id='Caminho_4613' data-name='Caminho 4613' d='M51.918%2c10a10%2c10%2c0%2c1%2c0-12.746%2c9.617%2c1.5%2c1.5%2c0%2c0%2c1%2c.893.692l1.27%2c2.2a.673.673%2c0%2c0%2c0%2c1.166%2c0l1.27-2.2a1.5%2c1.5%2c0%2c0%2c1%2c.893-.692A10%2c10%2c0%2c0%2c0%2c51.918%2c10Z' transform='translate(-31.918 0)' fill='%235490f9'/%3e %3cpath id='Caminho_4615' data-name='Caminho 4615' d='M224.829%2c92.06h.4a.968.968%2c0%2c0%2c1%2c.966.913l.281%2c4.985a1.447%2c1.447%2c0%2c1%2c1-2.889%2c0l.281-4.985A.968.968%2c0%2c0%2c1%2c224.829%2c92.06Z' transform='translate(-215.027 -84.43)' fill='white'/%3e %3cpath id='Caminho_4617' data-name='Caminho 4617' d='M233.193%2c293.03h.627a.737.737%2c0%2c0%2c1%2c.737.737v.505a.737.737%2c0%2c0%2c1-.737.737h-.627a.737.737%2c0%2c0%2c1-.737-.737v-.505A.737.737%2c0%2c0%2c1%2c233.193%2c293.03Z' transform='translate(-223.507 -288.921)' fill='white'/%3e%3c/svg%3e";

var img$l = "data:image/svg+xml,%3csvg id='icon_sm_attention' xmlns='http://www.w3.org/2000/svg' width='20' height='20.001' viewBox='0 0 20 20.001'%3e %3cpath id='Caminho_4624' data-name='Caminho 4624' d='M147.49%2c127.085a10%2c10%2c0%2c1%2c1-10-10A10.012%2c10.012%2c0%2c0%2c1%2c147.49%2c127.085Z' transform='translate(-127.49 -117.085)' fill='%23f80404'/%3e %3cg id='Grupo_7893' data-name='Grupo 7893' transform='translate(8.827 4.515)'%3e %3cpath id='Caminho_4626' data-name='Caminho 4626' d='M243.254%2c176.273v4.975a1.167%2c1.167%2c0%2c0%2c1-1.162%2c1.167h-.005a1.167%2c1.167%2c0%2c0%2c1-1.167-1.167v-4.975a1.167%2c1.167%2c0%2c0%2c1%2c1.167-1.167h.005A1.167%2c1.167%2c0%2c0%2c1%2c243.254%2c176.273Z' transform='translate(-240.919 -175.106)' fill='white'/%3e %3cpath id='Caminho_4627' data-name='Caminho 4627' d='M243.255%2c287.267a1.136%2c1.136%2c0%2c0%2c1-.005.115c0%2c.037-.01.075-.017.113s-.017.075-.028.111-.024.072-.039.107-.031.07-.049.1-.037.066-.058.1a1.112%2c1.112%2c0%2c0%2c1-.068.092c-.024.03-.051.058-.077.086s-.056.053-.086.077-.061.047-.092.068-.065.041-.1.059-.068.034-.1.048a1.109%2c1.109%2c0%2c0%2c1-.107.039c-.037.011-.074.02-.111.028a1.134%2c1.134%2c0%2c0%2c1-.113.017%2c1.04%2c1.04%2c0%2c0%2c1-.11.005h-.005a1.11%2c1.11%2c0%2c0%2c1-.228-.023c-.037-.008-.075-.017-.111-.028a1.115%2c1.115%2c0%2c0%2c1-.107-.039c-.035-.014-.07-.031-.1-.048a1.149%2c1.149%2c0%2c0%2c1-.1-.059c-.031-.021-.062-.044-.092-.068s-.058-.051-.086-.077-.053-.056-.077-.086a1.119%2c1.119%2c0%2c0%2c1-.068-.092q-.031-.048-.058-.1c-.018-.033-.034-.068-.049-.1s-.027-.072-.039-.107-.02-.074-.028-.111-.013-.076-.017-.113a1.136%2c1.136%2c0%2c0%2c1-.005-.115%2c1.121%2c1.121%2c0%2c0%2c1%2c.005-.114c0-.038.01-.076.017-.114s.017-.075.028-.111.024-.072.039-.108.031-.069.049-.1a1.213%2c1.213%2c0%2c0%2c1%2c.126-.191c.024-.03.051-.058.077-.085a1.151%2c1.151%2c0%2c0%2c1%2c.086-.077c.03-.024.061-.047.092-.068a1.141%2c1.141%2c0%2c0%2c1%2c.1-.058q.05-.027.1-.049c.035-.015.072-.027.107-.039s.074-.02.111-.028.076-.013.113-.016a1.221%2c1.221%2c0%2c0%2c1%2c.23%2c0c.037%2c0%2c.075.009.113.016s.075.017.111.028.072.024.107.039.069.031.1.049a1.146%2c1.146%2c0%2c0%2c1%2c.1.058c.031.021.062.044.092.068a1.151%2c1.151%2c0%2c0%2c1%2c.086.077c.026.026.053.055.077.085a1.213%2c1.213%2c0%2c0%2c1%2c.126.191q.027.05.049.1c.015.036.027.072.039.108s.02.073.028.111.013.076.017.114A1.121%2c1.121%2c0%2c0%2c1%2c243.255%2c287.267Z' transform='translate(-240.921 -277.463)' fill='white'/%3e %3c/g%3e%3c/svg%3e";

var img$k = "data:image/svg+xml,%3csvg id='icon_md_attention' xmlns='http://www.w3.org/2000/svg' width='30' height='30.001' viewBox='0 0 30 30.001'%3e %3cpath id='Caminho_4624' data-name='Caminho 4624' d='M157.49%2c132.086a15%2c15%2c0%2c1%2c1-15-15A15.018%2c15.018%2c0%2c0%2c1%2c157.49%2c132.086Z' transform='translate(-127.49 -117.085)' fill='%23ffb64c'/%3e %3cg id='Grupo_7893' data-name='Grupo 7893' transform='translate(13.24 6.774)'%3e %3cpath id='Caminho_4626' data-name='Caminho 4626' d='M244.421%2c176.857v7.462a1.751%2c1.751%2c0%2c0%2c1-1.743%2c1.751h-.008a1.751%2c1.751%2c0%2c0%2c1-1.751-1.751v-7.462a1.751%2c1.751%2c0%2c0%2c1%2c1.751-1.751h.008A1.751%2c1.751%2c0%2c0%2c1%2c244.421%2c176.857Z' transform='translate(-240.919 -175.106)' fill='white'/%3e %3cpath id='Caminho_4627' data-name='Caminho 4627' d='M244.423%2c287.85a1.705%2c1.705%2c0%2c0%2c1-.008.173c-.006.056-.015.113-.026.169s-.026.112-.042.167-.036.109-.058.161-.047.105-.074.155-.056.1-.088.147a1.664%2c1.664%2c0%2c0%2c1-.1.138c-.036.044-.076.088-.116.128s-.084.079-.128.116-.091.07-.138.1-.1.062-.148.089-.1.051-.154.072a1.666%2c1.666%2c0%2c0%2c1-.161.058c-.055.016-.111.03-.167.042a1.7%2c1.7%2c0%2c0%2c1-.169.026%2c1.564%2c1.564%2c0%2c0%2c1-.165.008h-.008a1.721%2c1.721%2c0%2c0%2c1-.173-.008%2c1.7%2c1.7%2c0%2c0%2c1-.169-.026c-.056-.012-.112-.026-.167-.042a1.675%2c1.675%2c0%2c0%2c1-.161-.058c-.052-.021-.105-.047-.154-.072s-.1-.057-.148-.089-.093-.065-.138-.1-.088-.076-.128-.116-.079-.084-.116-.128a1.678%2c1.678%2c0%2c0%2c1-.1-.138q-.047-.072-.088-.147c-.027-.05-.051-.1-.074-.155s-.041-.107-.058-.161-.03-.111-.042-.167-.02-.113-.026-.169a1.705%2c1.705%2c0%2c0%2c1-.008-.173%2c1.683%2c1.683%2c0%2c0%2c1%2c.008-.172c.006-.057.015-.114.026-.17s.026-.112.042-.166.036-.109.058-.162.047-.1.074-.154a1.7%2c1.7%2c0%2c0%2c1%2c.088-.147%2c1.676%2c1.676%2c0%2c0%2c1%2c.1-.139c.036-.044.076-.088.116-.127s.084-.079.128-.116.091-.071.138-.1a1.718%2c1.718%2c0%2c0%2c1%2c.148-.088q.075-.04.154-.074c.053-.022.107-.041.161-.058s.111-.03.167-.042.113-.02.169-.025a1.838%2c1.838%2c0%2c0%2c1%2c.345%2c0c.056%2c0%2c.113.014.169.025s.112.026.167.042.109.036.161.058.1.047.154.074.1.056.148.088.093.067.138.1.088.075.128.116.079.083.116.127a1.663%2c1.663%2c0%2c0%2c1%2c.1.139%2c1.686%2c1.686%2c0%2c0%2c1%2c.088.147q.04.075.074.154c.022.054.041.107.058.162s.03.11.042.166.02.113.026.17A1.683%2c1.683%2c0%2c0%2c1%2c244.423%2c287.85Z' transform='translate(-240.921 -273.145)' fill='white'/%3e %3c/g%3e%3c/svg%3e";

var img$j = "data:image/svg+xml,%3csvg id='Camada_1' data-name='Camada 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 330 43.13'%3e%3cdefs%3e%3cstyle%3e.cls-1%7bfill:%2315253d%3b%7d%3c/style%3e%3c/defs%3e%3cpath class='cls-1' d='M75.42%2c97.56a27.41%2c27.41%2c0%2c0%2c1-10.49%2c2%2c25.4%2c25.4%2c0%2c0%2c1-9.6-1.72%2c21.78%2c21.78%2c0%2c0%2c1-7.2-4.66%2c20%2c20%2c0%2c0%2c1-4.55-6.84A22.15%2c22.15%2c0%2c0%2c1%2c42%2c78a21.11%2c21.11%2c0%2c0%2c1%2c6.31-15.15%2c21.74%2c21.74%2c0%2c0%2c1%2c7.23-4.7%2c24.84%2c24.84%2c0%2c0%2c1%2c9.39-1.72%2c29.86%2c29.86%2c0%2c0%2c1%2c10.31%2c1.65%2c24.88%2c24.88%2c0%2c0%2c1%2c8.39%2c5.23l-5%2c6.52a20.55%2c20.55%2c0%2c0%2c0-6.34-4%2c20.43%2c20.43%2c0%2c0%2c0-7.34-1.25%2c14.66%2c14.66%2c0%2c0%2c0-5.7%2c1.07%2c14.07%2c14.07%2c0%2c0%2c0-4.4%2c2.91A12.52%2c12.52%2c0%2c0%2c0%2c52%2c72.77%2c13.57%2c13.57%2c0%2c0%2c0%2c51%2c78a13.88%2c13.88%2c0%2c0%2c0%2c1%2c5.27%2c12.58%2c12.58%2c0%2c0%2c0%2c2.87%2c4.3%2c13.6%2c13.6%2c0%2c0%2c0%2c4.4%2c2.86%2c15%2c15%2c0%2c0%2c0%2c5.7%2c1%2c18%2c18%2c0%2c0%2c0%2c7.63-1.54%2c22%2c22%2c0%2c0%2c0%2c6.27-4.48l5.51%2c6.24A28.14%2c28.14%2c0%2c0%2c1%2c75.42%2c97.56Z' transform='translate(-42 -56.43)'/%3e%3cpath class='cls-1' d='M89.25%2c76.42a15.47%2c15.47%2c0%2c0%2c1%2c3.69-5.19%2c16.52%2c16.52%2c0%2c0%2c1%2c5.59-3.37%2c21.47%2c21.47%2c0%2c0%2c1%2c14%2c0%2c16.52%2c16.52%2c0%2c0%2c1%2c5.59%2c3.37%2c15.47%2c15.47%2c0%2c0%2c1%2c3.69%2c5.19%2c17.37%2c17.37%2c0%2c0%2c1%2c0%2c13.33%2c15.27%2c15.27%2c0%2c0%2c1-3.69%2c5.19%2c16.52%2c16.52%2c0%2c0%2c1-5.59%2c3.37%2c21.47%2c21.47%2c0%2c0%2c1-14%2c0%2c16.52%2c16.52%2c0%2c0%2c1-5.59-3.37%2c15.27%2c15.27%2c0%2c0%2c1-3.69-5.19%2c17.49%2c17.49%2c0%2c0%2c1%2c0-13.33Zm22.79.29a9.5%2c9.5%2c0%2c0%2c0-6.49-2.29A10.88%2c10.88%2c0%2c0%2c0%2c102%2c75a7.89%2c7.89%2c0%2c0%2c0-4.8%2c4.41%2c9.82%2c9.82%2c0%2c0%2c0%2c0%2c7.38%2c7.91%2c7.91%2c0%2c0%2c0%2c4.8%2c4.4%2c10.63%2c10.63%2c0%2c0%2c0%2c3.58.58%2c9.51%2c9.51%2c0%2c0%2c0%2c6.49-2.3%2c8%2c8%2c0%2c0%2c0%2c2.61-6.37A8%2c8%2c0%2c0%2c0%2c112%2c76.71Z' transform='translate(-42 -56.43)'/%3e%3cpath class='cls-1' d='M138.87%2c76.93a9.79%2c9.79%2c0%2c0%2c0-2.3%2c6.87v15h-8.38V83.45a19%2c19%2c0%2c0%2c1%2c1.15-6.74%2c14.54%2c14.54%2c0%2c0%2c1%2c3.36-5.3%2c15.81%2c15.81%2c0%2c0%2c1%2c5.38-3.48%2c21.45%2c21.45%2c0%2c0%2c1%2c14.43%2c0%2c15.34%2c15.34%2c0%2c0%2c1%2c5.38%2c3.48%2c14.74%2c14.74%2c0%2c0%2c1%2c3.33%2c5.3%2c19.26%2c19.26%2c0%2c0%2c1%2c1.15%2c6.74v15.4H154v-15a9.78%2c9.78%2c0%2c0%2c0-2.29-6.87%2c8.28%2c8.28%2c0%2c0%2c0-6.45-2.51A8.16%2c8.16%2c0%2c0%2c0%2c138.87%2c76.93Z' transform='translate(-42 -56.43)'/%3e%3cpath class='cls-1' d='M202.92%2c57.15V81.8a20.07%2c20.07%2c0%2c0%2c1-1.36%2c7.66A15.61%2c15.61%2c0%2c0%2c1%2c197.83%2c95a15.9%2c15.9%2c0%2c0%2c1-5.59%2c3.37%2c20.72%2c20.72%2c0%2c0%2c1-7%2c1.14%2c20.36%2c20.36%2c0%2c0%2c1-6.91-1.14%2c16.42%2c16.42%2c0%2c0%2c1-5.56-3.3%2c15.59%2c15.59%2c0%2c0%2c1-3.72-5.16%2c16.26%2c16.26%2c0%2c0%2c1-1.36-6.8A17.68%2c17.68%2c0%2c0%2c1%2c169%2c76.42a14.89%2c14.89%2c0%2c0%2c1%2c3.48-5.16%2c16.07%2c16.07%2c0%2c0%2c1%2c5.45-3.36A19.84%2c19.84%2c0%2c0%2c1%2c185%2c66.68a15.13%2c15.13%2c0%2c0%2c1%2c5.16.93%2c10.3%2c10.3%2c0%2c0%2c1%2c4.37%2c3V57.15ZM177%2c86.78a8.14%2c8.14%2c0%2c0%2c0%2c1.93%2c2.72%2c8.24%2c8.24%2c0%2c0%2c0%2c2.87%2c1.68%2c10.42%2c10.42%2c0%2c0%2c0%2c3.51.58%2c9.77%2c9.77%2c0%2c0%2c0%2c6.49-2.4%2c7.91%2c7.91%2c0%2c0%2c0%2c2-2.73%2c8.71%2c8.71%2c0%2c0%2c0%2c.71-3.54%2c9.58%2c9.58%2c0%2c0%2c0-.71-3.8%2c7.43%2c7.43%2c0%2c0%2c0-2-2.72A8.47%2c8.47%2c0%2c0%2c0%2c188.87%2c75a11.73%2c11.73%2c0%2c0%2c0-3.58-.53%2c10.67%2c10.67%2c0%2c0%2c0-3.51.57%2c8.24%2c8.24%2c0%2c0%2c0-2.87%2c1.68A8.08%2c8.08%2c0%2c0%2c0%2c177%2c79.4a9.82%2c9.82%2c0%2c0%2c0%2c0%2c7.38Z' transform='translate(-42 -56.43)'/%3e%3cpath class='cls-1' d='M209.26%2c76.42A15.47%2c15.47%2c0%2c0%2c1%2c213%2c71.23a16.38%2c16.38%2c0%2c0%2c1%2c5.58-3.37%2c21.5%2c21.5%2c0%2c0%2c1%2c14.05%2c0%2c16.52%2c16.52%2c0%2c0%2c1%2c5.59%2c3.37%2c15.75%2c15.75%2c0%2c0%2c1%2c3.69%2c5.19%2c17.49%2c17.49%2c0%2c0%2c1%2c0%2c13.33%2c15.55%2c15.55%2c0%2c0%2c1-3.69%2c5.19%2c16.52%2c16.52%2c0%2c0%2c1-5.59%2c3.37%2c21.5%2c21.5%2c0%2c0%2c1-14.05%2c0A16.38%2c16.38%2c0%2c0%2c1%2c213%2c94.94a15.27%2c15.27%2c0%2c0%2c1-3.69-5.19%2c17.37%2c17.37%2c0%2c0%2c1%2c0-13.33Zm22.78.29a9.47%2c9.47%2c0%2c0%2c0-6.48-2.29A10.94%2c10.94%2c0%2c0%2c0%2c222%2c75a8%2c8%2c0%2c0%2c0-4.8%2c4.41%2c9.94%2c9.94%2c0%2c0%2c0%2c0%2c7.38%2c8%2c8%2c0%2c0%2c0%2c4.8%2c4.4%2c10.69%2c10.69%2c0%2c0%2c0%2c3.59.58%2c9.48%2c9.48%2c0%2c0%2c0%2c6.48-2.3%2c8%2c8%2c0%2c0%2c0%2c2.62-6.37A8%2c8%2c0%2c0%2c0%2c232%2c76.71Z' transform='translate(-42 -56.43)'/%3e%3cpath class='cls-1' d='M263.13%2c99.1a13.85%2c13.85%2c0%2c0%2c1-2.47.25%2c15.35%2c15.35%2c0%2c0%2c1-6.05-1%2c9.75%2c9.75%2c0%2c0%2c1-3.87-2.9%2c11.29%2c11.29%2c0%2c0%2c1-2.08-4.55%2c26.5%2c26.5%2c0%2c0%2c1-.61-5.91l.07-27.8h4.16l-.07%2c27.59q0%2c5.15%2c1.9%2c7.91t6.27%2c2.76a13.35%2c13.35%2c0%2c0%2c0%2c3.94-.5l1.29%2c3.58A18.37%2c18.37%2c0%2c0%2c1%2c263.13%2c99.1Z' transform='translate(-42 -56.43)'/%3e%3cpath class='cls-1' d='M273.34%2c62.09h-4.15V56.51h4.15Zm0%2c36.76h-4.15V67.32h4.15Z' transform='translate(-42 -56.43)'/%3e%3cpath class='cls-1' d='M300.75%2c92.65a16.51%2c16.51%2c0%2c0%2c0%2c3.8-3.94%2c19.13%2c19.13%2c0%2c0%2c0%2c2.4-5%2c18.28%2c18.28%2c0%2c0%2c0%2c.86-5.52V67.32H312V78.21a23.21%2c23.21%2c0%2c0%2c1-1.07%2c7%2c20.89%2c20.89%2c0%2c0%2c1-8.28%2c11%2c22.85%2c22.85%2c0%2c0%2c1-6.91%2c3.15%2c22.22%2c22.22%2c0%2c0%2c1-6.95-3.15%2c21.47%2c21.47%2c0%2c0%2c1-5.09-4.87%2c20.64%2c20.64%2c0%2c0%2c1-3.15-6.16%2c22.91%2c22.91%2c0%2c0%2c1-1.08-7V67.32h4.16V78.21a18.28%2c18.28%2c0%2c0%2c0%2c.86%2c5.52%2c18.51%2c18.51%2c0%2c0%2c0%2c2.4%2c5%2c16.32%2c16.32%2c0%2c0%2c0%2c3.8%2c3.94%2c16.56%2c16.56%2c0%2c0%2c0%2c5.05%2c2.55A16.79%2c16.79%2c0%2c0%2c0%2c300.75%2c92.65Z' transform='translate(-42 -56.43)'/%3e%3cpath class='cls-1' d='M324.28%2c74.2q-3.15%2c3.51-3.15%2c9.89V98.85H317V83.66a20.54%2c20.54%2c0%2c0%2c1%2c1.07-6.77%2c15.13%2c15.13%2c0%2c0%2c1%2c3.15-5.37A14.62%2c14.62%2c0%2c0%2c1%2c326.29%2c68a17.33%2c17.33%2c0%2c0%2c1%2c6.88-1.29%2c17.52%2c17.52%2c0%2c0%2c1%2c7.52%2c1.58l-1.86%2c3.79a11.37%2c11.37%2c0%2c0%2c0-5.59-1.36Q327.44%2c70.69%2c324.28%2c74.2Z' transform='translate(-42 -56.43)'/%3e%3cpath class='cls-1' d='M349%2c92.9a14.63%2c14.63%2c0%2c0%2c0%2c9%2c2.65%2c18.22%2c18.22%2c0%2c0%2c0%2c5.51-1%2c13.27%2c13.27%2c0%2c0%2c0%2c5-2.83l2.87%2c2.65a15.12%2c15.12%2c0%2c0%2c1-3.05%2c2.33%2c19%2c19%2c0%2c0%2c1-3.51%2c1.57%2c22.49%2c22.49%2c0%2c0%2c1-7.06%2c1.18%2c21.81%2c21.81%2c0%2c0%2c1-7.06-1.11%2c16.55%2c16.55%2c0%2c0%2c1-5.62-3.18%2c14.74%2c14.74%2c0%2c0%2c1-3.72-5.09A16.5%2c16.5%2c0%2c0%2c1%2c340%2c83.23a17.16%2c17.16%2c0%2c0%2c1%2c1.33-6.81A15%2c15%2c0%2c0%2c1%2c345%2c71.19a16.92%2c16.92%2c0%2c0%2c1%2c5.59-3.33%2c20.2%2c20.2%2c0%2c0%2c1%2c7-1.18%2c20.91%2c20.91%2c0%2c0%2c1%2c5.26.68%2c15.78%2c15.78%2c0%2c0%2c1%2c4.63%2c2%2c11%2c11%2c0%2c0%2c1%2c3.26%2c3.19A7.71%2c7.71%2c0%2c0%2c1%2c372%2c76.85a8.44%2c8.44%2c0%2c0%2c1-.9%2c4.09%2c6.87%2c6.87%2c0%2c0%2c1-2.54%2c2.65A11.48%2c11.48%2c0%2c0%2c1%2c364.62%2c85a27.39%2c27.39%2c0%2c0%2c1-5.09.43h-15A11.32%2c11.32%2c0%2c0%2c0%2c349%2c92.9Zm13.65-11.39a9.09%2c9.09%2c0%2c0%2c0%2c2.61-.61%2c3.84%2c3.84%2c0%2c0%2c0%2c1.8-1.43%2c4.68%2c4.68%2c0%2c0%2c0%2c.64-2.62%2c4.61%2c4.61%2c0%2c0%2c0-.89-2.83%2c7%2c7%2c0%2c0%2c0-2.33-1.93A12%2c12%2c0%2c0%2c0%2c361.22%2c71a18.75%2c18.75%2c0%2c0%2c0-3.62-.36%2c14.1%2c14.1%2c0%2c0%2c0-9%2c2.83%2c11.47%2c11.47%2c0%2c0%2c0-4.15%2c8.2h15.11A30.88%2c30.88%2c0%2c0%2c0%2c362.65%2c81.51Z' transform='translate(-42 -56.43)'/%3e%3c/svg%3e";

var img$i = "data:image/svg+xml,%3csvg id='Camada_1' data-name='Camada 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 330 43.13'%3e%3cdefs%3e%3cstyle%3e.cls-1%7bfill:white%3b%7d%3c/style%3e%3c/defs%3e%3cpath class='cls-1' d='M75.42%2c97.56a27.41%2c27.41%2c0%2c0%2c1-10.49%2c2%2c25.4%2c25.4%2c0%2c0%2c1-9.6-1.72%2c21.78%2c21.78%2c0%2c0%2c1-7.2-4.66%2c20%2c20%2c0%2c0%2c1-4.55-6.84A22.15%2c22.15%2c0%2c0%2c1%2c42%2c78a21.11%2c21.11%2c0%2c0%2c1%2c6.31-15.15%2c21.74%2c21.74%2c0%2c0%2c1%2c7.23-4.7%2c24.84%2c24.84%2c0%2c0%2c1%2c9.39-1.72%2c29.86%2c29.86%2c0%2c0%2c1%2c10.31%2c1.65%2c24.88%2c24.88%2c0%2c0%2c1%2c8.39%2c5.23l-5%2c6.52a20.55%2c20.55%2c0%2c0%2c0-6.34-4%2c20.43%2c20.43%2c0%2c0%2c0-7.34-1.25%2c14.66%2c14.66%2c0%2c0%2c0-5.7%2c1.07%2c14.07%2c14.07%2c0%2c0%2c0-4.4%2c2.91A12.52%2c12.52%2c0%2c0%2c0%2c52%2c72.77%2c13.57%2c13.57%2c0%2c0%2c0%2c51%2c78a13.88%2c13.88%2c0%2c0%2c0%2c1%2c5.27%2c12.58%2c12.58%2c0%2c0%2c0%2c2.87%2c4.3%2c13.6%2c13.6%2c0%2c0%2c0%2c4.4%2c2.86%2c15%2c15%2c0%2c0%2c0%2c5.7%2c1%2c18%2c18%2c0%2c0%2c0%2c7.63-1.54%2c22%2c22%2c0%2c0%2c0%2c6.27-4.48l5.51%2c6.24A28.14%2c28.14%2c0%2c0%2c1%2c75.42%2c97.56Z' transform='translate(-42 -56.43)'/%3e%3cpath class='cls-1' d='M89.25%2c76.42a15.47%2c15.47%2c0%2c0%2c1%2c3.69-5.19%2c16.52%2c16.52%2c0%2c0%2c1%2c5.59-3.37%2c21.47%2c21.47%2c0%2c0%2c1%2c14%2c0%2c16.52%2c16.52%2c0%2c0%2c1%2c5.59%2c3.37%2c15.47%2c15.47%2c0%2c0%2c1%2c3.69%2c5.19%2c17.37%2c17.37%2c0%2c0%2c1%2c0%2c13.33%2c15.27%2c15.27%2c0%2c0%2c1-3.69%2c5.19%2c16.52%2c16.52%2c0%2c0%2c1-5.59%2c3.37%2c21.47%2c21.47%2c0%2c0%2c1-14%2c0%2c16.52%2c16.52%2c0%2c0%2c1-5.59-3.37%2c15.27%2c15.27%2c0%2c0%2c1-3.69-5.19%2c17.49%2c17.49%2c0%2c0%2c1%2c0-13.33Zm22.79.29a9.5%2c9.5%2c0%2c0%2c0-6.49-2.29A10.88%2c10.88%2c0%2c0%2c0%2c102%2c75a7.89%2c7.89%2c0%2c0%2c0-4.8%2c4.41%2c9.82%2c9.82%2c0%2c0%2c0%2c0%2c7.38%2c7.91%2c7.91%2c0%2c0%2c0%2c4.8%2c4.4%2c10.63%2c10.63%2c0%2c0%2c0%2c3.58.58%2c9.51%2c9.51%2c0%2c0%2c0%2c6.49-2.3%2c8%2c8%2c0%2c0%2c0%2c2.61-6.37A8%2c8%2c0%2c0%2c0%2c112%2c76.71Z' transform='translate(-42 -56.43)'/%3e%3cpath class='cls-1' d='M138.87%2c76.93a9.79%2c9.79%2c0%2c0%2c0-2.3%2c6.87v15h-8.38V83.45a19%2c19%2c0%2c0%2c1%2c1.15-6.74%2c14.54%2c14.54%2c0%2c0%2c1%2c3.36-5.3%2c15.81%2c15.81%2c0%2c0%2c1%2c5.38-3.48%2c21.45%2c21.45%2c0%2c0%2c1%2c14.43%2c0%2c15.34%2c15.34%2c0%2c0%2c1%2c5.38%2c3.48%2c14.74%2c14.74%2c0%2c0%2c1%2c3.33%2c5.3%2c19.26%2c19.26%2c0%2c0%2c1%2c1.15%2c6.74v15.4H154v-15a9.78%2c9.78%2c0%2c0%2c0-2.29-6.87%2c8.28%2c8.28%2c0%2c0%2c0-6.45-2.51A8.16%2c8.16%2c0%2c0%2c0%2c138.87%2c76.93Z' transform='translate(-42 -56.43)'/%3e%3cpath class='cls-1' d='M202.92%2c57.15V81.8a20.07%2c20.07%2c0%2c0%2c1-1.36%2c7.66A15.61%2c15.61%2c0%2c0%2c1%2c197.83%2c95a15.9%2c15.9%2c0%2c0%2c1-5.59%2c3.37%2c20.72%2c20.72%2c0%2c0%2c1-7%2c1.14%2c20.36%2c20.36%2c0%2c0%2c1-6.91-1.14%2c16.42%2c16.42%2c0%2c0%2c1-5.56-3.3%2c15.59%2c15.59%2c0%2c0%2c1-3.72-5.16%2c16.26%2c16.26%2c0%2c0%2c1-1.36-6.8A17.68%2c17.68%2c0%2c0%2c1%2c169%2c76.42a14.89%2c14.89%2c0%2c0%2c1%2c3.48-5.16%2c16.07%2c16.07%2c0%2c0%2c1%2c5.45-3.36A19.84%2c19.84%2c0%2c0%2c1%2c185%2c66.68a15.13%2c15.13%2c0%2c0%2c1%2c5.16.93%2c10.3%2c10.3%2c0%2c0%2c1%2c4.37%2c3V57.15ZM177%2c86.78a8.14%2c8.14%2c0%2c0%2c0%2c1.93%2c2.72%2c8.24%2c8.24%2c0%2c0%2c0%2c2.87%2c1.68%2c10.42%2c10.42%2c0%2c0%2c0%2c3.51.58%2c9.77%2c9.77%2c0%2c0%2c0%2c6.49-2.4%2c7.91%2c7.91%2c0%2c0%2c0%2c2-2.73%2c8.71%2c8.71%2c0%2c0%2c0%2c.71-3.54%2c9.58%2c9.58%2c0%2c0%2c0-.71-3.8%2c7.43%2c7.43%2c0%2c0%2c0-2-2.72A8.47%2c8.47%2c0%2c0%2c0%2c188.87%2c75a11.73%2c11.73%2c0%2c0%2c0-3.58-.53%2c10.67%2c10.67%2c0%2c0%2c0-3.51.57%2c8.24%2c8.24%2c0%2c0%2c0-2.87%2c1.68A8.08%2c8.08%2c0%2c0%2c0%2c177%2c79.4a9.82%2c9.82%2c0%2c0%2c0%2c0%2c7.38Z' transform='translate(-42 -56.43)'/%3e%3cpath class='cls-1' d='M209.26%2c76.42A15.47%2c15.47%2c0%2c0%2c1%2c213%2c71.23a16.38%2c16.38%2c0%2c0%2c1%2c5.58-3.37%2c21.5%2c21.5%2c0%2c0%2c1%2c14.05%2c0%2c16.52%2c16.52%2c0%2c0%2c1%2c5.59%2c3.37%2c15.75%2c15.75%2c0%2c0%2c1%2c3.69%2c5.19%2c17.49%2c17.49%2c0%2c0%2c1%2c0%2c13.33%2c15.55%2c15.55%2c0%2c0%2c1-3.69%2c5.19%2c16.52%2c16.52%2c0%2c0%2c1-5.59%2c3.37%2c21.5%2c21.5%2c0%2c0%2c1-14.05%2c0A16.38%2c16.38%2c0%2c0%2c1%2c213%2c94.94a15.27%2c15.27%2c0%2c0%2c1-3.69-5.19%2c17.37%2c17.37%2c0%2c0%2c1%2c0-13.33Zm22.78.29a9.47%2c9.47%2c0%2c0%2c0-6.48-2.29A10.94%2c10.94%2c0%2c0%2c0%2c222%2c75a8%2c8%2c0%2c0%2c0-4.8%2c4.41%2c9.94%2c9.94%2c0%2c0%2c0%2c0%2c7.38%2c8%2c8%2c0%2c0%2c0%2c4.8%2c4.4%2c10.69%2c10.69%2c0%2c0%2c0%2c3.59.58%2c9.48%2c9.48%2c0%2c0%2c0%2c6.48-2.3%2c8%2c8%2c0%2c0%2c0%2c2.62-6.37A8%2c8%2c0%2c0%2c0%2c232%2c76.71Z' transform='translate(-42 -56.43)'/%3e%3cpath class='cls-1' d='M263.13%2c99.1a13.85%2c13.85%2c0%2c0%2c1-2.47.25%2c15.35%2c15.35%2c0%2c0%2c1-6.05-1%2c9.75%2c9.75%2c0%2c0%2c1-3.87-2.9%2c11.29%2c11.29%2c0%2c0%2c1-2.08-4.55%2c26.5%2c26.5%2c0%2c0%2c1-.61-5.91l.07-27.8h4.16l-.07%2c27.59q0%2c5.15%2c1.9%2c7.91t6.27%2c2.76a13.35%2c13.35%2c0%2c0%2c0%2c3.94-.5l1.29%2c3.58A18.37%2c18.37%2c0%2c0%2c1%2c263.13%2c99.1Z' transform='translate(-42 -56.43)'/%3e%3cpath class='cls-1' d='M273.34%2c62.09h-4.15V56.51h4.15Zm0%2c36.76h-4.15V67.32h4.15Z' transform='translate(-42 -56.43)'/%3e%3cpath class='cls-1' d='M300.75%2c92.65a16.51%2c16.51%2c0%2c0%2c0%2c3.8-3.94%2c19.13%2c19.13%2c0%2c0%2c0%2c2.4-5%2c18.28%2c18.28%2c0%2c0%2c0%2c.86-5.52V67.32H312V78.21a23.21%2c23.21%2c0%2c0%2c1-1.07%2c7%2c20.89%2c20.89%2c0%2c0%2c1-8.28%2c11%2c22.85%2c22.85%2c0%2c0%2c1-6.91%2c3.15%2c22.22%2c22.22%2c0%2c0%2c1-6.95-3.15%2c21.47%2c21.47%2c0%2c0%2c1-5.09-4.87%2c20.64%2c20.64%2c0%2c0%2c1-3.15-6.16%2c22.91%2c22.91%2c0%2c0%2c1-1.08-7V67.32h4.16V78.21a18.28%2c18.28%2c0%2c0%2c0%2c.86%2c5.52%2c18.51%2c18.51%2c0%2c0%2c0%2c2.4%2c5%2c16.32%2c16.32%2c0%2c0%2c0%2c3.8%2c3.94%2c16.56%2c16.56%2c0%2c0%2c0%2c5.05%2c2.55A16.79%2c16.79%2c0%2c0%2c0%2c300.75%2c92.65Z' transform='translate(-42 -56.43)'/%3e%3cpath class='cls-1' d='M324.28%2c74.2q-3.15%2c3.51-3.15%2c9.89V98.85H317V83.66a20.54%2c20.54%2c0%2c0%2c1%2c1.07-6.77%2c15.13%2c15.13%2c0%2c0%2c1%2c3.15-5.37A14.62%2c14.62%2c0%2c0%2c1%2c326.29%2c68a17.33%2c17.33%2c0%2c0%2c1%2c6.88-1.29%2c17.52%2c17.52%2c0%2c0%2c1%2c7.52%2c1.58l-1.86%2c3.79a11.37%2c11.37%2c0%2c0%2c0-5.59-1.36Q327.44%2c70.69%2c324.28%2c74.2Z' transform='translate(-42 -56.43)'/%3e%3cpath class='cls-1' d='M349%2c92.9a14.63%2c14.63%2c0%2c0%2c0%2c9%2c2.65%2c18.22%2c18.22%2c0%2c0%2c0%2c5.51-1%2c13.27%2c13.27%2c0%2c0%2c0%2c5-2.83l2.87%2c2.65a15.12%2c15.12%2c0%2c0%2c1-3.05%2c2.33%2c19%2c19%2c0%2c0%2c1-3.51%2c1.57%2c22.49%2c22.49%2c0%2c0%2c1-7.06%2c1.18%2c21.81%2c21.81%2c0%2c0%2c1-7.06-1.11%2c16.55%2c16.55%2c0%2c0%2c1-5.62-3.18%2c14.74%2c14.74%2c0%2c0%2c1-3.72-5.09A16.5%2c16.5%2c0%2c0%2c1%2c340%2c83.23a17.16%2c17.16%2c0%2c0%2c1%2c1.33-6.81A15%2c15%2c0%2c0%2c1%2c345%2c71.19a16.92%2c16.92%2c0%2c0%2c1%2c5.59-3.33%2c20.2%2c20.2%2c0%2c0%2c1%2c7-1.18%2c20.91%2c20.91%2c0%2c0%2c1%2c5.26.68%2c15.78%2c15.78%2c0%2c0%2c1%2c4.63%2c2%2c11%2c11%2c0%2c0%2c1%2c3.26%2c3.19A7.71%2c7.71%2c0%2c0%2c1%2c372%2c76.85a8.44%2c8.44%2c0%2c0%2c1-.9%2c4.09%2c6.87%2c6.87%2c0%2c0%2c1-2.54%2c2.65A11.48%2c11.48%2c0%2c0%2c1%2c364.62%2c85a27.39%2c27.39%2c0%2c0%2c1-5.09.43h-15A11.32%2c11.32%2c0%2c0%2c0%2c349%2c92.9Zm13.65-11.39a9.09%2c9.09%2c0%2c0%2c0%2c2.61-.61%2c3.84%2c3.84%2c0%2c0%2c0%2c1.8-1.43%2c4.68%2c4.68%2c0%2c0%2c0%2c.64-2.62%2c4.61%2c4.61%2c0%2c0%2c0-.89-2.83%2c7%2c7%2c0%2c0%2c0-2.33-1.93A12%2c12%2c0%2c0%2c0%2c361.22%2c71a18.75%2c18.75%2c0%2c0%2c0-3.62-.36%2c14.1%2c14.1%2c0%2c0%2c0-9%2c2.83%2c11.47%2c11.47%2c0%2c0%2c0-4.15%2c8.2h15.11A30.88%2c30.88%2c0%2c0%2c0%2c362.65%2c81.51Z' transform='translate(-42 -56.43)'/%3e%3c/svg%3e";

var theme = {
    animation: {
        duration: {
            regular: '.5s'
        }
    },
    color: {
        blue_900: '#0242A2',
        blue_800: '#00398F',
        blue_700: '#0042A3',
        blue_600: '#0052CC',
        blue_500: '#4276DF',
        blue_300: '#6592E7',
        blue_200: '#2172EB',
        blue_50: '#D4E2FE',
        light_blue: '#1661CF',
        dark_blue: '#04398A',
        skyblue_900: '#0448AF',
        skyblue_800: '#093E7E',
        skyblue_700: '#1469CC',
        skyblue_600: '#2E8EFF',
        skyblue_500: '#58A5FF',
        skyblue_450: '#5BB2EC',
        skyblue_400: '#5E6BB5',
        skyblue_300: '#82BBFF',
        skyblue_50: '#DDECFF',
        turquoise_800: '#096274',
        turquoise_700: '#0E9DBA',
        turquoise_600: '#12C4E8',
        turquoise_550: '#5ECEF4',
        turquoise_500: '#41D0ED',
        turquoise_300: '#71DCF1',
        turquoise_50: '#E0F5FD',
        purple_800: '#4F3E85',
        purple_700: '#6A53B2',
        purple_600: '#8468DE',
        purple_500: '#9D86E5',
        purple_300: '#B5A4EB',
        purple_50: '#EEEAFA',
        green_800: '#22684A',
        green_700: '#36986C',
        green_600: '#36B37E',
        green_550: '#00DD7B',
        green_500: '#6CC79F',
        green_300: '#90D4B5',
        green_50: '#DBF2E8',
        lime_800: '#58750D',
        lime_700: '#769E12',
        lime_600: '#93C316',
        lime_500: '#A9CF45',
        lime_300: '#BEDB73',
        lime_50: '#E9F3D0',
        avocado_950: '#226212',
        avocado_900: '#1F750A',
        avocado_800: '#2B5421',
        avocado_700: '#3F822F',
        avocado_600: '#4D993A',
        avocado_500: '#5EB948',
        avocado_400: '#63C24B',
        avocado_300: '#85E36E',
        avocado_50: '#C5F9B8',
        yellow_800: '#D18101',
        yellow_700: '#E8AA00',
        yellow_600: '#FBCB00',
        yellow_550: '#FFD400',
        yellow_500: '#FFD41F',
        yellow_300: '#FFE267',
        yellow_50: '#FFF7D6',
        orange_800: '#9B4200',
        orange_700: '#D36609',
        orange_600: '#FA8700',
        orange_500: '#FB9F33',
        orange_300: '#FCB766',
        orange_50: '#FEE7CC',
        red_900: '#F80404',
        red_875: '#861717',
        red_850: '#B21E1E',
        red_800: '#AC2708',
        red_750: '#DB2828',
        red_725: '#FF4D4D',
        red_700: '#DB411C',
        red_600: '#FF5B34',
        red_500: '#FF7C5D',
        red_300: '#FF9D85',
        red_50: '#FFE5DE',
        pink_800: '#8B0B50',
        pink_700: '#CE3F79',
        pink_600: '#FC5995',
        pink_500: '#FD7AAA',
        pink_300: '#FD9BBF',
        pink_50: '#FFE3EE',
        black: '#0C0F14',
        black_pearl: '#192934',
        gray_900: '#262C36',
        gray_800: '#474E5E',
        gray_700: '#6D7688',
        gray_650: '#787B7D',
        gray_600: '#959FAF',
        gray_500: '#A9B4BF',
        gray_450: '#BFC7D4',
        gray_400: '#C8CFD6',
        gray_375: '#C2C8C8',
        gray_350: '#CACACC',
        gray_325: '#CCCACA',
        gray_300: '#DBE1E6',
        gray_290: '#D6D6D7',
        gray_275: '#E0E6E6',
        gray_250: '#EBEEF1',
        gray_200: '#ECF0F4',
        gray_150: '#EFF2F5',
        gray_100: '#F8F9FB',
        gray_50: '#C5CBCB',
        white: '#FFFFFF',
        disable_800: '#C8D2E1',
        disable_900: '#A5B0C1'
    },
    padding: {
        regular: '1rem',
        small: '1.2rem',
        s_1: '1.375rem',
        s_2: '2.5rem',
        v_6: '6rem',
        s_0_906: '0.90625rem',
        s_1_750: '1.75rem',
        s_2_500: '2.5rem'
    },
    margin: {
        s_0_937: '0.9375rem',
        v_4: '0.25rem',
        v_16: '1rem'
    },
    boxShadow: {
        regular: ' 0px 4px 20px #6D76884D',
        avatar: '0px 3px 20px #0000000D',
        dropdown: '0px 3px 5px #0000001A',
        switcher: '0px 1px 3px #0000001A'
    },
    border: {
        small: '1px solid',
        regular: '2px solid',
        medium: '3px solid'
    },
    radius: {
        regular: '0.75rem',
        small: '0.5rem',
        v_5: '0.3125rem',
        round: '50%'
    },
    font: {
        family: {
            regular: "'Montserrat', sans-serif",
            medium: "'Montserrat Medium', sans-serif",
            custom1: "'Source Sans Pro', sans-serif"
        },
        weight: {
            bold: 'bold',
            v_600: '600',
            v_500: '500',
            v_300: '300',
            v_200: '200',
            v_100: '100'
        },
        size: {
            v_10: '0.625rem',
            v_12: '0.75rem',
            v_14: '0.875rem',
            v_15: '0.9375rem',
            v_16: '1rem',
            v_18: '1.125rem',
            v_20: '1.25rem',
            v_21: '1.31rem',
            v_22: '1.375rem',
            v_24: '1.5rem',
            v_25: '1.5625rem',
            v_26: '1.625rem',
            v_28: '1.75rem',
            v_30: '1.875rem'
        }
    }
};
var input = {
    size: {
        small: {
            labelSize: 'v_10',
            fontSize: 'v_14',
            fontSizeNoLabel: 'v_16',
            height: '3rem',
            padding: '0.3rem 0',
            paddingInput: '0 1.125rem'
        },
        normal: {
            labelSize: 'v_12',
            fontSize: 'v_16',
            fontSizeNoLabel: 'v_18',
            height: '4rem',
            padding: '0.56rem 0 0.875rem 0',
            paddingInput: '0 1.125rem 0 1.125rem'
        }
    }
};
var button = {
    variant: {
        primary: {
            colors: {
                inherit: theme.color.blue_600,
                hover: theme.color.blue_200,
                active: theme.color.blue_900,
                disabled: theme.color.disable_800
            },
            colorsIcon: {
                inherit: theme.color.skyblue_900,
                hover: theme.color.light_blue,
                active: theme.color.dark_blue,
                disabled: theme.color.disable_900
            },
            text: {
                color: theme.color.white
            }
        },
        secondary: {
            colors: {
                inherit: theme.color.gray_250,
                hover: theme.color.gray_150,
                active: theme.color.gray_450
            },
            text: {
                color: theme.color.gray_900,
                disabled_color: theme.color.gray_600
            }
        },
        ghost: {
            border: {
                inherit: theme.border.regular + " " + theme.color.white,
                hover: theme.border.regular + " " + theme.color.skyblue_450,
                active: theme.border.medium + " " + theme.color.white,
                disabled: theme.border.regular + " " + theme.color.skyblue_400
            },
            text: {
                color: theme.color.white,
                hover_color: theme.color.skyblue_450,
                disabled_color: theme.color.skyblue_400
            }
        },
        cta: {
            colors: {
                inherit: theme.color.avocado_600,
                hover: theme.color.avocado_400,
                active: theme.color.avocado_900,
                disabled: theme.color.disable_800
            },
            colorsIcon: {
                inherit: theme.color.avocado_700,
                hover: theme.color.avocado_500,
                active: theme.color.avocado_950,
                disabled: theme.color.disable_900
            },
            text: {
                color: theme.color.white
            }
        },
        link: {
            colors: {
                inherit: 'transparent',
                hover: 'transparent',
                active: 'transparent',
                disabled: 'transparent'
            },
            colorsIcon: {
                inherit: 'transparent'
            },
            text: {
                color: theme.color.blue_600
            }
        },
        cancel: {
            colors: {
                inherit: theme.color.red_750,
                hover: theme.color.red_600,
                active: theme.color.red_800,
                disabled: theme.color.disable_800
            },
            colorsIcon: {
                inherit: theme.color.red_850,
                hover: theme.color.red_700,
                active: theme.color.red_875,
                disabled: theme.color.disable_900
            },
            text: {
                color: theme.color.white
            }
        },
        upload: {
            colors: {
                inherit: theme.color.yellow_700,
                hover: theme.color.yellow_600,
                active: theme.color.yellow_600,
                disabled: theme.color.disable_800
            },
            colorsIcon: {
                inherit: theme.color.yellow_800,
                hover: theme.color.yellow_700,
                active: theme.color.yellow_700,
                disabled: theme.color.disable_900
            },
            text: {
                color: theme.color.white
            }
        }
    },
    size: {
        mini: {
            padding: '0 1rem',
            height: '1.875rem',
            font_size: '0.75rem'
        },
        small: {
            padding: '0 1.5rem',
            height: '2.5rem',
            font_size: '0.875rem'
        },
        normal: {
            padding: '0 2rem',
            height: '3.125rem',
            font_size: '1rem'
        },
        large: {
            padding: '0 2.25rem',
            height: '3.75rem',
            font_size: '1.25rem'
        },
        huge: {
            padding: '0 2.375rem',
            height: '4.375rem',
            font_size: '1.375rem'
        },
        massive: {
            padding: '0 2.625rem',
            height: '5rem',
            font_size: '1.5rem'
        }
    },
    icon: {
        size: {
            mini: {
                width: '1.825rem',
                padding: {
                    right: '0 0.25rem 0 0.4675rem',
                    left: '0 0.4675rem 0 0.25rem'
                }
            },
            small: {
                width: '2.4375rem',
                padding: {
                    right: '0 0.5rem 0 0.9375rem',
                    left: '0 0.9375rem 0 0.5rem'
                }
            },
            normal: {
                width: '3.045rem',
                padding: {
                    right: '0 0.75rem 0 1.405rem',
                    left: '0 1.405rem 0 0.75rem'
                }
            },
            large: {
                width: '3.65rem',
                padding: {
                    right: '0 0.875rem 0 1.65rem',
                    left: '0 1.65rem 0 0.875rem'
                }
            },
            huge: {
                width: '4.265rem',
                padding: {
                    right: '0 0.9375rem 0 1.75rem',
                    left: '0 1.75rem 0 0.9375rem'
                }
            },
            massive: {
                width: '4.875rem',
                padding: {
                    right: '0 1.0625rem 0 1.9875rem',
                    left: '0 1.9875rem 0 1.0625rem'
                }
            }
        },
        radius: {
            right: '0 0.5rem 0.5rem 0',
            left: '0.5rem 0 0 0.5rem'
        }
    }
};
var tab = {
    variant: {
        primary: {
            colors: {
                textColor: theme.color.gray_700,
                textSelected: theme.color.black,
                borderSelected: theme.color.blue_600
            }
        },
        secondary: {
            colors: {
                textColor: theme.color.gray_700,
                textSelected: theme.color.black,
                borderSelected: theme.color.yellow_50
            }
        }
    },
    type: {
        default: {
            orientation: 'row',
            borderBaseline: "1px solid " + theme.color.gray_50
        },
        menu: {
            orientation: 'column',
            borderBaseline: 'none'
        }
    }
};
var dropdown = {
    defaultIcon: img$o,
    size: {
        small: {
            labelSize: 'v_10',
            fontSize: 'v_14',
            fontSizeNoLabel: 'v_16',
            height: '3rem',
            padding: '0.3rem 1.125rem',
            paddingOption: '0rem 1.125rem'
        },
        normal: {
            labelSize: 'v_12',
            fontSize: 'v_16',
            fontSizeNoLabel: 'v_18',
            height: '4rem',
            padding: '0.56rem 1.125rem 0.875rem 1.125rem',
            paddingOption: '0rem 1.125rem'
        }
    },
    variant: {
        light: {
            hoverBackgroundColor: '#DDE7F4',
            fieldBackgroundColor: theme.color.white
        },
        dark: {
            hoverBackgroundColor: '#DDE7F4',
            fieldBackgroundColor: theme.color.gray_100
        }
    }
};
var sidebar = {
    variant: {
        supply: {
            textColor: 'white',
            separatorLineColor: 'purple_600',
            backgroundColor: '#2D164A',
            backgroundActiveMenu: '#785AB8',
            backgroundSubMenu: 'purple_500'
        }
    }
};
var fixedmenu = {
    variant: {
        collaborator: {
            textColor: 'white',
            separatorLineColor: 'purple_600',
            backgroundColor: '#161D4A',
            backgroundActiveMenu: '#4865D9'
        }
    }
};
var logo = {
    variant: {
        primary: {
            image: img$j
        },
        blue: {
            image: img$j
        },
        white: {
            image: img$i
        }
    }
};
var gauge = {
    width: '3.125rem',
    state: {
        low: {
            color: theme.color.red_725
        },
        medium: {
            color: theme.color.yellow_550
        },
        high: {
            color: theme.color.turquoise_550
        },
        highest: {
            color: theme.color.green_550
        }
    }
};
var table = {
    variant: {
        default: {
            rowsPadding: ['1rem', '1.625rem', '1rem', '1.625rem'],
            rowsGap: '0.5rem',
            columnGap: '0.5rem',
            header: {
                fontFamily: 'regular',
                fontSize: 'v_12',
                backgroundColor: 'gray_800',
                textColor: 'white',
                radius: 'regular'
            },
            data: {
                fontFamily: 'regular',
                fontSize: 'v_14',
                backgroundColor: 'white',
                hoverBackground: '#EEF0F5',
                boxShadow: 'regular',
                textColor: 'black',
                disabledBackgroundColor: 'gray_200',
                radius: 'regular'
            }
        },
        simple: {
            rowsPadding: ['1.625rem', '0', '1.625rem', '0'],
            rowsGap: '0rem',
            columnGap: '0.5rem',
            header: {
                fontFamily: 'regular',
                fontSize: 'v_12',
                fontWeight: 'bold',
                textColor: 'black',
                borderBottom: '2px solid #DBE1E6'
            },
            data: {
                fontFamily: 'regular',
                fontSize: 'v_14',
                textColor: 'black',
                borderBottom: '1px solid #DBE1E6'
            }
        }
    }
};
var progressStep = {
    alignment: {
        horizontal: {
            center: {
                step: { alignItems: 'center' },
                content: { alignItems: 'center' },
                marker: { alignItems: 'center', display: 'flex' }
            }
        }
    },
    size: {
        small: {
            circle: { width: '1rem', height: '1rem', radius: '100%' },
            square: { width: '0.625rem', height: '1.125rem', radius: '0.25rem' },
            icon: { width: '1rem', height: '1rem' }
        },
        normal: {
            circle: { width: '1.625rem', height: '1.625rem', radius: '100%' },
            icon: { width: '1.625rem', height: '1.625rem' }
        },
        large: {
            circle: { width: '2.175rem', height: '2.175rem', radius: '100%' },
            icon: { width: '2.175rem', height: '2.175rem' }
        }
    }
};
var switcher = {
    size: {
        small: ['26px', '14px'],
        normal: ['49px', '22px']
    },
    state: {
        disabled: {
            backgroundColor: '#F5F5F7'
        },
        active: {
            backgroundColor: 'blue_600'
        },
        off: {
            backgroundColor: '#E0E3EE'
        }
    }
};
var alert = {
    variant: {
        info: {
            textColor: 'black',
            icon: img$m,
            backgroundColor: 'skyblue_50'
        },
        warning: {
            textColor: 'black',
            icon: img$k,
            backgroundColor: 'orange_50'
        },
        error: {
            textColor: 'black',
            icon: img$l,
            backgroundColor: 'red_50'
        },
        success: {
            textColor: 'black',
            icon: img$n,
            backgroundColor: '#DEF3D0'
        }
    }
};
var userBadge = {
    size: {
        normal: {
            avatar: {
                size: '4.375rem',
                fontSize: 'v_24',
                lineHeight: 'v_15'
            },
            name: {
                fontSize: 'v_18',
                lineHeight: 'v_15'
            },
            description: {
                fontSize: 'v_14',
                lineHeight: 'v_16'
            }
        },
        small: {
            avatar: {
                size: '43px',
                fontSize: 'v_18',
                lineHeight: 'v_15'
            },
            name: {
                fontSize: 'v_16',
                lineHeight: 'v_15'
            },
            description: {
                fontSize: 'v_14',
                lineHeight: 'v_16'
            }
        }
    }
};
var appBar = {
    variant: {
        supply: {
            header: {
                backgroundColor: '#200C39'
            },
            appBar: {
                backgroundColor: '#2D164A'
            }
        }
    }
};
var themeDefault = __assign(__assign({}, theme), { appBar: appBar, button: button, input: input, tab: tab, logo: logo, dropdown: dropdown, switcher: switcher, sidebar: sidebar, fixedmenu: fixedmenu, gauge: gauge, table: table, progressStep: progressStep, alert: alert, userBadge: userBadge });

var StyledIcon = styled.img(templateObject_1$m || (templateObject_1$m = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var ContainerIcon = styled.i(templateObject_2$j || (templateObject_2$j = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var templateObject_1$m, templateObject_2$j;

var Icon = function (_a) {
    var icon = _a.icon, props = __rest(_a, ["icon"]);
    return (React.createElement(ContainerIcon, __assign({ "data-testid": props.id, className: props.name, onClick: props.onClick }, props),
        React.createElement(StyledIcon, { src: icon })));
};

var ButtonContentWrapper = styled.div(templateObject_2$i || (templateObject_2$i = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  flex-direction: ", ";\n  height: inherit;\n  \n  ", "\n"], ["\n  display: flex;\n  align-items: center;\n  flex-direction: ", ";\n  height: inherit;\n  \n  ", "\n"])), function (props) { return props.iconPos === 'right' && 'row-reverse'; }, function (_a) {
    var $sizeIcon = _a.$sizeIcon, icon = _a.icon, iconPos = _a.iconPos;
    return icon && css(templateObject_1$l || (templateObject_1$l = __makeTemplateObject(["\n      span {\n        padding: ", ";\n      }\n    "], ["\n      span {\n        padding: ", ";\n      }\n    "])), iconPos === 'left' ? $sizeIcon.padding.left : $sizeIcon.padding.right);
});
var ButtonIconWrapper = styled.div(templateObject_5$b || (templateObject_5$b = __makeTemplateObject(["\n  background: ", ";\n  border-radius: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: inherit;\n  transition-duration: .3s;\n  ", "\n"], ["\n  background: ", ";\n  border-radius: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: inherit;\n  transition-duration: .3s;\n  ", "\n"])), function (props) { var _a; return (_a = props.$variant.colorsIcon) === null || _a === void 0 ? void 0 : _a.inherit; }, button.icon.radius.left, function (_a) {
    var $sizeIcon = _a.$sizeIcon, iconPos = _a.iconPos;
    return css(templateObject_4$e || (templateObject_4$e = __makeTemplateObject(["\n    width: ", ";\n    ", "\n  "], ["\n    width: ", ";\n    ", "\n  "])), $sizeIcon.width, iconPos && iconPos === 'right' && css(templateObject_3$g || (templateObject_3$g = __makeTemplateObject(["\n      border-radius: ", ";\n    "], ["\n      border-radius: ", ";\n    "])), button.icon.radius.right));
});
var ButtonIcon = styled(Icon)(templateObject_6$8 || (templateObject_6$8 = __makeTemplateObject(["\n  height: fit-content;\n"], ["\n  height: fit-content;\n"])));
var StyledButton = styled('button')(templateObject_10$3 || (templateObject_10$3 = __makeTemplateObject(["\n    border-radius: ", ";\n    background: ", ";\n    padding: ", ";\n    color:", ";\n    font-family:", ";\n    font-size: ", ";\n    font-weight:", ";\n    transition-duration: ", ";\n    transition-timing-function: ease;\n    border:none;\n    height: ", ";\n  \n    ", "\n    ", "\n\n    &:hover {\n        cursor:pointer;\n    }\n\n    ", "\n};"], ["\n    border-radius: ", ";\n    background: ", ";\n    padding: ", ";\n    color:", ";\n    font-family:", ";\n    font-size: ", ";\n    font-weight:", ";\n    transition-duration: ", ";\n    transition-timing-function: ease;\n    border:none;\n    height: ", ";\n  \n    ", "\n    ", "\n\n    &:hover {\n        cursor:pointer;\n    }\n\n    ", "\n};"])), theme.radius.small, theme.color.black, button.size.normal.padding, theme.color.white, theme.font.family.regular, button.size.normal.font_size, theme.font.weight.bold, theme.animation.duration.regular, button.size.normal.height, function (props) { return props.block && css(templateObject_7$7 || (templateObject_7$7 = __makeTemplateObject(["\n      width: 100%;\n      span {\n        width: 100%;\n      }\n    "], ["\n      width: 100%;\n      span {\n        width: 100%;\n      }\n    "]))); }, function (_a) {
    var $size = _a.$size, icon = _a.icon;
    return css(templateObject_8$5 || (templateObject_8$5 = __makeTemplateObject(["\n      padding: ", ";\n      font-size: ", ";\n      height: ", ";\n    "], ["\n      padding: ", ";\n      font-size: ", ";\n      height: ", ";\n    "])), icon ? '0' : $size.padding, $size.font_size, $size.height);
}, function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    var $variant = _a.$variant;
    return css(templateObject_9$5 || (templateObject_9$5 = __makeTemplateObject(["\n      background: ", ";\n      border: ", ";\n      color: ", ";\n      &:hover, &.hover {\n        background: ", ";\n        border: ", ";\n        color: ", ";\n        ", "{\n          background: ", ";\n        }\n      }\n    \n      &:active, &.active {\n        background: ", ";\n        border: ", ";\n        color: ", ";\n        ", "{\n          background: ", ";\n        }\n      }\n    \n      &:disabled {\n        background: ", ";\n        border: ", ";\n        color: ", ";\n        ", "{\n         background: ", ";\n        }\n      }"], ["\n      background: ", ";\n      border: ", ";\n      color: ", ";\n      &:hover, &.hover {\n        background: ", ";\n        border: ", ";\n        color: ", ";\n        ", "{\n          background: ", ";\n        }\n      }\n    \n      &:active, &.active {\n        background: ", ";\n        border: ", ";\n        color: ", ";\n        ", "{\n          background: ", ";\n        }\n      }\n    \n      &:disabled {\n        background: ", ";\n        border: ", ";\n        color: ", ";\n        ", "{\n         background: ", ";\n        }\n      }"])), (_b = $variant.colors) === null || _b === void 0 ? void 0 : _b.inherit, (_c = $variant.border) === null || _c === void 0 ? void 0 : _c.inherit, $variant.text.color, (_d = $variant.colors) === null || _d === void 0 ? void 0 : _d.hover, (_e = $variant.border) === null || _e === void 0 ? void 0 : _e.hover, $variant.text.hover_color, ButtonIconWrapper, (_f = $variant.colorsIcon) === null || _f === void 0 ? void 0 : _f.hover, (_g = $variant.colors) === null || _g === void 0 ? void 0 : _g.active, (_h = $variant.border) === null || _h === void 0 ? void 0 : _h.active, $variant.text.active_color, ButtonIconWrapper, (_j = $variant.colorsIcon) === null || _j === void 0 ? void 0 : _j.active, (_k = $variant.colors) === null || _k === void 0 ? void 0 : _k.disabled, (_l = $variant.border) === null || _l === void 0 ? void 0 : _l.disabled, $variant.text.disabled_color, ButtonIconWrapper, (_m = $variant.colorsIcon) === null || _m === void 0 ? void 0 : _m.disabled);
});
var templateObject_1$l, templateObject_2$i, templateObject_3$g, templateObject_4$e, templateObject_5$b, templateObject_6$8, templateObject_7$7, templateObject_8$5, templateObject_9$5, templateObject_10$3;

var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function getMergeFunction(key, options) {
	if (!options.customMerge) {
		return deepmerge
	}
	var customMerge = options.customMerge(key);
	return typeof customMerge === 'function' ? customMerge : deepmerge
}

function getEnumerableOwnPropertySymbols(target) {
	return Object.getOwnPropertySymbols
		? Object.getOwnPropertySymbols(target).filter(function(symbol) {
			return target.propertyIsEnumerable(symbol)
		})
		: []
}

function getKeys(target) {
	return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target))
}

function propertyIsOnObject(object, property) {
	try {
		return property in object
	} catch(_) {
		return false
	}
}

// Protects from prototype poisoning and unexpected merging up the prototype chain.
function propertyIsUnsafe(target, key) {
	return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
		&& !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
			&& Object.propertyIsEnumerable.call(target, key)) // and also unsafe if they're nonenumerable.
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		getKeys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	getKeys(source).forEach(function(key) {
		if (propertyIsUnsafe(target, key)) {
			return
		}

		if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
			destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
		} else {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;
	// cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
	// implementations can use it. The caller may not replace it.
	options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

var cjs = deepmerge_1;

function solveVariant(obj, variant, defaultVariant, useDeepmerge) {
    if (defaultVariant === void 0) { defaultVariant = 'primary'; }
    if (useDeepmerge === void 0) { useDeepmerge = true; }
    return useDeepmerge
        ? cjs(obj[defaultVariant] || {}, obj[variant] || {})
        : obj[variant] || obj[defaultVariant] || {};
}
function forwardPropsToChildren(children, props) {
    if (props === void 0) { props = {}; }
    return React.Children.map(children, function (child) {
        if (React.isValidElement(child)) {
            return React.cloneElement(child, __assign({}, props));
        }
        return child;
    });
}
function solveThemeValue(data, key, defaultValue) {
    if (defaultValue === void 0) { defaultValue = null; }
    if (key == null) {
        return defaultValue;
    }
    return data[key] ? data[key] : (defaultValue ? data[defaultValue] : key);
}

var solveDefaultValues = function (variant) {
    var _a, _b, _c;
    var defaultColor = ((_a = variant.colors) === null || _a === void 0 ? void 0 : _a.inherit) || 'transparent';
    var defaultColorIcon = ((_b = variant.colorsIcon) === null || _b === void 0 ? void 0 : _b.inherit) || 'transparent';
    var defaultBorder = (_c = variant.border) === null || _c === void 0 ? void 0 : _c.inherit;
    var defaultTextColor = variant.text.color;
    return cjs({
        colors: {
            inherit: 'transparent',
            active: defaultColor,
            hover: defaultColor,
            disabled: defaultColor
        },
        colorsIcon: {
            inherit: 'transparent',
            hover: defaultColorIcon,
            active: defaultColorIcon,
            disabled: defaultColorIcon
        },
        border: {
            active: defaultBorder,
            hover: defaultBorder,
            disabled: defaultBorder
        },
        text: {
            hover_color: defaultTextColor,
            active_color: defaultTextColor,
            disabled_color: defaultTextColor
        }
    }, variant);
};

var Button = function (_a) {
    var id = _a.id, variant = _a.variant, size = _a.size, props = __rest(_a, ["id", "variant", "size"]);
    if (props['data-testid'])
        id = props['data-testid'];
    var themeContext = useContext(ThemeContext);
    var sizeProps = useMemo(function () {
        return solveVariant(themeContext.button.size, size, 'normal', false);
    }, [size]);
    var iconSizeProps = useMemo(function () {
        return solveVariant(themeContext.button.icon.size, size, 'primary', false);
    }, [size]);
    var variantProps = useMemo(function () {
        return solveDefaultValues(solveVariant(themeContext.button.variant, variant, 'primary', false));
    }, [variant]);
    return (React.createElement(StyledButton, __assign({ "data-testid": id, "$size": sizeProps, "$variant": variantProps }, props),
        React.createElement(ButtonContentWrapper, { icon: props.icon, iconPos: props.iconPos, "$sizeIcon": iconSizeProps },
            props.icon && (React.createElement(ButtonIconWrapper, { "$variant": variantProps, "$size": sizeProps, "$sizeIcon": iconSizeProps, iconPos: props.iconPos, disabled: props.disabled },
                React.createElement(ButtonIcon, { "data-testid": "icon-" + id, icon: props.icon }))),
            React.createElement("span", { "data-testid": id + "-content" }, props.children))));
};
Button.defaultProps = {
    size: 'normal',
    variant: 'primary',
    iconPos: 'left',
    block: false
};

var StyledBox = styled.div(templateObject_1$k || (templateObject_1$k = __makeTemplateObject(["\n    border-radius: ", ";\n    background: ", ";\n    padding: 1.375rem 1.5rem;\n    box-shadow: ", ";\n;"], ["\n    border-radius: ", ";\n    background: ", ";\n    padding: 1.375rem 1.5rem;\n    box-shadow: ", ";\n;"])), theme.radius.regular, theme.color.white, theme.boxShadow.regular);
var templateObject_1$k;

var Box = function (props) {
    return React.createElement(StyledBox, __assign({}, props), props.children);
};

var img$h = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='15' height='23.756' viewBox='0 0 15 23.756'%3e %3cg id='icon_sm_lock' transform='translate(0.5 0.5)'%3e %3cg id='Grupo_7435' data-name='Grupo 7435'%3e %3cpath id='Caminho_4560' data-name='Caminho 4560' d='M110.4%2c10.762V4.9a4.9%2c4.9%2c0%2c0%2c0-9.8%2c0v5.862a7%2c7%2c0%2c1%2c0%2c9.8%2c0ZM101.934%2c4.9a3.566%2c3.566%2c0%2c1%2c1%2c7.133%2c0V9.735a6.984%2c6.984%2c0%2c0%2c0-7.133%2c0ZM105.5%2c21.422a5.667%2c5.667%2c0%2c1%2c1%2c5.667-5.667A5.673%2c5.673%2c0%2c0%2c1%2c105.5%2c21.422Z' transform='translate(-98.5 0)' fill='%23959faf' stroke='%23959faf' stroke-width='1'/%3e %3c/g%3e %3cg id='Grupo_7436' data-name='Grupo 7436' transform='translate(4.633 12.439)'%3e %3cpath id='Caminho_4561' data-name='Caminho 4561' d='M205.117%2c279.908a2.366%2c2.366%2c0%2c0%2c0-.667%2c4.637v1.343a.667.667%2c0%2c0%2c0%2c1.333%2c0v-1.343a2.366%2c2.366%2c0%2c0%2c0-.667-4.637Zm0%2c3.4a1.033%2c1.033%2c0%2c1%2c1%2c1.033-1.033A1.035%2c1.035%2c0%2c0%2c1%2c205.117%2c283.308Z' transform='translate(-202.75 -279.908)' fill='%23959faf' stroke='%23959faf' stroke-width='1'/%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var img$g = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='21.499' height='21.589' viewBox='0 0 21.499 21.589'%3e %3cg id='icon_sm_telefone__blue' transform='translate(0.749 0.75)'%3e %3cpath id='Caminho_3291' data-name='Caminho 3291' d='M17.181%2c39.381a2.1%2c2.1%2c0%2c0%2c0-1.521-.7%2c2.169%2c2.169%2c0%2c0%2c0-1.539.693L12.7%2c40.795c-.117-.063-.234-.122-.347-.18-.162-.081-.315-.158-.446-.239A15.456%2c15.456%2c0%2c0%2c1%2c8.2%2c37a9.119%2c9.119%2c0%2c0%2c1-1.215-1.917c.369-.338.711-.689%2c1.044-1.026.126-.126.252-.257.378-.383a2.065%2c2.065%2c0%2c0%2c0%2c0-3.114L7.181%2c29.332c-.14-.14-.284-.284-.419-.428-.27-.279-.554-.567-.846-.837a2.13%2c2.13%2c0%2c0%2c0-1.508-.662%2c2.2%2c2.2%2c0%2c0%2c0-1.53.662l-.009.009L1.34%2c29.62a3.292%2c3.292%2c0%2c0%2c0-.977%2c2.093%2c7.889%2c7.889%2c0%2c0%2c0%2c.576%2c3.339%2c19.377%2c19.377%2c0%2c0%2c0%2c3.443%2c5.742%2c21.178%2c21.178%2c0%2c0%2c0%2c7.052%2c5.522%2c10.987%2c10.987%2c0%2c0%2c0%2c3.96%2c1.17c.095%2c0%2c.194.009.284.009a3.391%2c3.391%2c0%2c0%2c0%2c2.6-1.116c0-.009.013-.014.018-.023a10.23%2c10.23%2c0%2c0%2c1%2c.788-.815c.194-.185.392-.378.585-.581a2.245%2c2.245%2c0%2c0%2c0%2c.68-1.557%2c2.163%2c2.163%2c0%2c0%2c0-.693-1.544Zm1.611%2c4.739s0%2c0%2c0%2c0c-.176.189-.356.36-.549.549a11.833%2c11.833%2c0%2c0%2c0-.869.9%2c2.17%2c2.17%2c0%2c0%2c1-1.692.716c-.068%2c0-.14%2c0-.207%2c0a9.761%2c9.761%2c0%2c0%2c1-3.51-1.053%2c19.991%2c19.991%2c0%2c0%2c1-6.642-5.2%2c18.27%2c18.27%2c0%2c0%2c1-3.24-5.4%2c6.426%2c6.426%2c0%2c0%2c1-.5-2.817A2.066%2c2.066%2c0%2c0%2c1%2c2.2%2c30.475l1.535-1.535a1.023%2c1.023%2c0%2c0%2c1%2c.684-.32.963.963%2c0%2c0%2c1%2c.657.315l.014.014c.275.257.536.522.81.806.14.144.284.288.428.437L7.555%2c31.42a.859.859%2c0%2c0%2c1%2c0%2c1.4c-.131.131-.257.261-.387.387-.378.387-.738.747-1.13%2c1.1-.009.009-.018.014-.023.022a.918.918%2c0%2c0%2c0-.234%2c1.022l.014.041a9.864%2c9.864%2c0%2c0%2c0%2c1.454%2c2.372l0%2c0a16.518%2c16.518%2c0%2c0%2c0%2c4%2c3.636%2c6.145%2c6.145%2c0%2c0%2c0%2c.554.3c.162.081.315.158.446.239.018.009.036.022.054.032a.976.976%2c0%2c0%2c0%2c.446.113.962.962%2c0%2c0%2c0%2c.684-.311l1.539-1.539a1.018%2c1.018%2c0%2c0%2c1%2c.68-.338.917.917%2c0%2c0%2c1%2c.648.329l.009.009%2c2.48%2c2.48A.89.89%2c0%2c0%2c1%2c18.792%2c44.12Z' transform='translate(-0.344 -27.406)' fill='%232e8eff' stroke='%232e8eff' stroke-width='1.5'/%3e %3c/g%3e%3c/svg%3e";

var img$f = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='20.505' height='20.5' viewBox='0 0 20.505 20.5'%3e %3cg id='icon_sm_whatsapp__blue' transform='translate(0.255 0.25)'%3e %3cpath id='XMLID_469_' d='M90.436%2c85.968c-.039-.019-1.5-.737-1.756-.83a1.009%2c1.009%2c0%2c0%2c0-.34-.075.578.578%2c0%2c0%2c0-.491.291c-.146.216-.587.732-.723.886-.018.02-.042.045-.057.045s-.239-.093-.307-.123a7.673%2c7.673%2c0%2c0%2c1-2.914-2.589.161.161%2c0%2c0%2c1-.024-.058.47.47%2c0%2c0%2c1%2c.085-.1c.079-.079.165-.182.249-.282.039-.047.079-.1.118-.14a1.571%2c1.571%2c0%2c0%2c0%2c.237-.376l.033-.066a.68.68%2c0%2c0%2c0-.02-.64c-.034-.069-.65-1.555-.716-1.711-.157-.377-.365-.552-.654-.552-.027%2c0%2c0%2c0-.112%2c0a3.5%2c3.5%2c0%2c0%2c0-1.212.312%2c2.538%2c2.538%2c0%2c0%2c0-.941%2c2.159A4.653%2c4.653%2c0%2c0%2c0%2c81.9%2c84.685l.041.06a9.5%2c9.5%2c0%2c0%2c0%2c4.074%2c3.537%2c6.626%2c6.626%2c0%2c0%2c0%2c2.461.629h0a3.846%2c3.846%2c0%2c0%2c0%2c.4-.024l.072-.007a2.587%2c2.587%2c0%2c0%2c0%2c1.8-1.276%2c2.018%2c2.018%2c0%2c0%2c0%2c.115-1.328A.92.92%2c0%2c0%2c0%2c90.436%2c85.968Z' transform='translate(-75.638 -74.476)' fill='%232e8eff' stroke='%232e8eff' stroke-width='0.5'/%3e %3cpath id='XMLID_470_' d='M10.178%2c0A9.8%2c9.8%2c0%2c0%2c0%2c.354%2c9.75%2c9.678%2c9.678%2c0%2c0%2c0%2c1.7%2c14.68L.014%2c19.657a.26.26%2c0%2c0%2c0%2c.325.331l5.19-1.649A9.839%2c9.839%2c0%2c0%2c0%2c20%2c9.75%2c9.8%2c9.8%2c0%2c0%2c0%2c10.178%2c0Zm0%2c17.467A7.782%2c7.782%2c0%2c0%2c1%2c5.9%2c16.191a.26.26%2c0%2c0%2c0-.221-.03l-2.6.826.839-2.476a.26.26%2c0%2c0%2c0-.036-.237A7.613%2c7.613%2c0%2c0%2c1%2c2.4%2c9.75a7.781%2c7.781%2c0%2c1%2c1%2c7.781%2c7.718Z' transform='translate(0)' fill='%232e8eff' stroke='%232e8eff' stroke-width='0.5'/%3e %3c/g%3e%3c/svg%3e";

var img$e = "data:image/svg+xml,%3csvg id='icon_sm_placeholder__blue' xmlns='http://www.w3.org/2000/svg' width='16' height='22.756' viewBox='0 0 16 22.756'%3e %3cpath id='Caminho_2506' data-name='Caminho 2506' d='M84%2c0a8.006%2c8.006%2c0%2c0%2c0-8%2c8%2c7.889%2c7.889%2c0%2c0%2c0%2c1.2%2c4.2l6.258%2c10.241a.632.632%2c0%2c0%2c0%2c.453.307.664.664%2c0%2c0%2c0%2c.68-.32l6.276-10.334A7.89%2c7.89%2c0%2c0%2c0%2c92%2c8%2c8.006%2c8.006%2c0%2c0%2c0%2c84%2c0Zm0%2c12a4%2c4%2c0%2c1%2c1%2c4-4A3.995%2c3.995%2c0%2c0%2c1%2c84%2c12Z' transform='translate(-76)' fill='%232e8eff'/%3e %3cpath id='Caminho_2507' data-name='Caminho 2507' d='M256%2c0V4a4%2c4%2c0%2c0%2c1%2c0%2c8V22.755a.66.66%2c0%2c0%2c0%2c.591-.328l6.276-10.334A7.889%2c7.889%2c0%2c0%2c0%2c264%2c8%2c8.006%2c8.006%2c0%2c0%2c0%2c256%2c0Z' transform='translate(-248)' fill='%232e8eff'/%3e%3c/svg%3e";

var img$d = "data:image/svg+xml,%3csvg id='icon_adicionar-favoritos' xmlns='http://www.w3.org/2000/svg' width='20' height='24.351' viewBox='0 0 20 24.351'%3e %3cpath id='Caminho_4603' data-name='Caminho 4603' d='M30.591%2c31.665H16.121a.552.552%2c0%2c0%2c0-.557.55V51.256c0%2c.3.216.424.473.264l6.846-4.132a.992.992%2c0%2c0%2c1%2c.946%2c0l6.839%2c4.132c.257.16.473.035.473-.264V32.215A.55.55%2c0%2c0%2c0%2c30.591%2c31.665Zm-3.847%2c8.474a.558.558%2c0%2c0%2c1-.556.556h-2v2a.557.557%2c0%2c0%2c1-.556.55h-.55a.551.551%2c0%2c0%2c1-.55-.55v-2H20.517a.557.557%2c0%2c0%2c1-.55-.556v-.55a.557.557%2c0%2c0%2c1%2c.55-.557h2.011v-2a.546.546%2c0%2c0%2c1%2c.55-.55h.55a.552.552%2c0%2c0%2c1%2c.556.55v2h2a.558.558%2c0%2c0%2c1%2c.556.557Z' transform='translate(-15.564 -27.239)' fill='%2320c4e8'/%3e %3cpath id='Caminho_4604' data-name='Caminho 4604' d='M62.247%2c0A.554.554%2c0%2c0%2c1%2c62.8.553V19.772c0%2c.3-.2.412-.455.239l-1.854-1.28a1.183%2c1.183%2c0%2c0%2c1-.455-.867V3.317a.554.554%2c0%2c0%2c0-.553-.553H47.777a.554.554%2c0%2c0%2c1-.553-.553V.553A.554.554%2c0%2c0%2c1%2c47.777%2c0Z' transform='translate(-42.799)' fill='%2320c4e8'/%3e%3c/svg%3e";

var img$c = "data:image/svg+xml,%3csvg id='icon_order_by' xmlns='http://www.w3.org/2000/svg' width='20' height='12.666' viewBox='0 0 20 12.666'%3e %3crect id='Ret%c3%a2ngulo_7217' data-name='Ret%c3%a2ngulo 7217' width='20' height='3.333' rx='1.667' fill='%230052cc'/%3e %3crect id='Ret%c3%a2ngulo_7218' data-name='Ret%c3%a2ngulo 7218' width='15.333' height='3.333' rx='1.667' transform='translate(0 4.667)' fill='%230052cc'/%3e %3crect id='Ret%c3%a2ngulo_7219' data-name='Ret%c3%a2ngulo 7219' width='7.333' height='3.333' rx='1.667' transform='translate(0 9.333)' fill='%230052cc'/%3e%3c/svg%3e";

var img$b = "data:image/svg+xml,%3csvg id='icon_search' xmlns='http://www.w3.org/2000/svg' width='14' height='14.206' viewBox='0 0 14 14.206'%3e %3cpath id='search' d='M65.332%2c63.092a1.373%2c1.373%2c0%2c0%2c1-1.941%2c1.941l-2.322-2.322a6.184%2c6.184%2c0%2c1%2c1%2c1.988-1.894Zm-7.422-2.255a3.431%2c3.431%2c0%2c1%2c0-3.431-3.431A3.435%2c3.435%2c0%2c0%2c0%2c57.911%2c60.838Z' transform='translate(-51.734 -51.23)' fill='%230052cc'/%3e%3c/svg%3e";

var img$a = "data:image/svg+xml,%3csvg id='bt_close' xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18'%3e %3ccircle id='Elipse_628' data-name='Elipse 628' cx='9' cy='9' r='9' transform='translate(18) rotate(90)' fill='white'/%3e %3cpath id='icon_close_white' d='M.089%2c5.551a.266.266%2c0%2c0%2c0-.013.383A.256.256%2c0%2c0%2c0%2c.272%2c6a.291.291%2c0%2c0%2c0%2c.2-.08L2.993%2c3.39%2c5.339%2c5.766a.256.256%2c0%2c0%2c0%2c.2.066.291.291%2c0%2c0%2c0%2c.2-.08.266.266%2c0%2c0%2c0%2c.013-.383L3.388%2c2.993%2c5.925.463a.33.33%2c0%2c0%2c0%2c.014-.4.326.326%2c0%2c0%2c0-.4.014L3.02%2c2.624.674.248A.263.263%2c0%2c0%2c0%2c.293.261.266.266%2c0%2c0%2c0%2c.279.644L2.625%2c3.02Z' transform='translate(12.5 6.5) rotate(90)' fill='%23262c36' stroke='%23262c36' stroke-width='1'/%3e%3c/svg%3e";

var img$9 = "data:image/svg+xml,%3csvg id='emoji_lg_erro' xmlns='http://www.w3.org/2000/svg' width='60' height='61.519' viewBox='0 0 60 61.519'%3e %3crect id='Ret%c3%a2ngulo_6688' data-name='Ret%c3%a2ngulo 6688' width='60' height='61.519' rx='20' fill='%23ff5b34'/%3e %3cg id='Grupo_7835' data-name='Grupo 7835' transform='translate(15.321 17.529)'%3e %3cpath id='Caminho_5039' data-name='Caminho 5039' d='M80.037%2c263.72a21.49%2c21.49%2c0%2c0%2c1%2c25.176%2c0%2c1.284%2c1.284%2c0%2c1%2c0%2c1.612-2%2c24.042%2c24.042%2c0%2c0%2c0-28.4%2c0%2c1.284%2c1.284%2c0%2c1%2c0%2c1.612%2c2Zm0%2c0' transform='translate(-77.946 -237.543)' fill='white'/%3e %3cpath id='Caminho_5040' data-name='Caminho 5040' d='M236.971%2c105.373a1.284%2c1.284%2c0%2c0%2c0-1.816%2c0l-2.9%2c2.9-2.9-2.9a1.284%2c1.284%2c0%2c1%2c0-1.816%2c1.816l2.9%2c2.9-2.9%2c2.9a1.284%2c1.284%2c0%2c1%2c0%2c1.816%2c1.816l2.9-2.9%2c2.9%2c2.9a1.284%2c1.284%2c0%2c0%2c0%2c1.816-1.816l-2.9-2.9%2c2.9-2.9A1.284%2c1.284%2c0%2c0%2c0%2c236.971%2c105.373Zm0%2c0' transform='translate(-207.99 -104.996)' fill='white'/%3e %3cpath id='Caminho_5041' data-name='Caminho 5041' d='M78.326%2c114.807a1.284%2c1.284%2c0%2c0%2c0%2c1.816%2c0l2.9-2.9%2c2.9%2c2.9a1.285%2c1.285%2c0%2c0%2c0%2c1.817-1.816l-2.9-2.9%2c2.9-2.9a1.285%2c1.285%2c0%2c0%2c0-1.817-1.816l-2.9%2c2.9-2.9-2.9a1.284%2c1.284%2c0%2c0%2c0-1.816%2c1.816l2.9%2c2.9-2.9%2c2.9A1.285%2c1.285%2c0%2c0%2c0%2c78.326%2c114.807Zm0%2c0' transform='translate(-77.948 -104.992)' fill='white'/%3e %3c/g%3e%3c/svg%3e";

var img$8 = "data:image/svg+xml,%3csvg id='emoji_lg_sucesso' xmlns='http://www.w3.org/2000/svg' width='60' height='61.739' viewBox='0 0 60 61.739'%3e %3crect id='Ret%c3%a2ngulo_6688' data-name='Ret%c3%a2ngulo 6688' width='60' height='61.739' rx='20' fill='%2393c316'/%3e %3cpath id='Caminho_5039' data-name='Caminho 5039' d='M102.176%2c257.331a19.1%2c19.1%2c0%2c0%2c1-22.372%2c0%2c1.141%2c1.141%2c0%2c1%2c0-1.432%2c1.778%2c21.365%2c21.365%2c0%2c0%2c0%2c25.236%2c0%2c1.141%2c1.141%2c0%2c1%2c0-1.432-1.778Zm0%2c0' transform='translate(-60.555 -219.859)' fill='white'/%3e %3cg id='Grupo_9703' data-name='Grupo 9703' transform='translate(19.13 21.738)'%3e %3cellipse id='Elipse_691' data-name='Elipse 691' cx='3.165' cy='3.006' rx='3.165' ry='3.006' fill='white'/%3e %3ccircle id='Elipse_692' data-name='Elipse 692' cx='3.006' cy='3.006' r='3.006' transform='translate(15.726)' fill='white'/%3e %3c/g%3e%3c/svg%3e";

var img$7 = "data:image/svg+xml,%3csvg id='emoji_lg_atencao' xmlns='http://www.w3.org/2000/svg' width='60' height='61.739' viewBox='0 0 60 61.739'%3e %3crect id='Ret%c3%a2ngulo_6688' data-name='Ret%c3%a2ngulo 6688' width='60' height='61.739' rx='20' fill='%23ffb64c'/%3e %3cg id='Grupo_9704' data-name='Grupo 9704' transform='translate(19.938 17.563)'%3e %3cpath id='Caminho_10010' data-name='Caminho 10010' d='M169.167%2c355h-8.333c-.46%2c0-.833-.672-.833-1.5s.373-1.5.833-1.5h8.333c.46%2c0%2c.833.672.833%2c1.5S169.627%2c355%2c169.167%2c355Z' transform='translate(-154.938 -330.125)' fill='white'/%3e %3c/g%3e %3cg id='Grupo_9705' data-name='Grupo 9705' transform='translate(19 21.738)'%3e %3cellipse id='Elipse_691' data-name='Elipse 691' cx='3.165' cy='3.006' rx='3.165' ry='3.006' fill='white'/%3e %3ccircle id='Elipse_692' data-name='Elipse 692' cx='3.006' cy='3.006' r='3.006' transform='translate(15.726)' fill='white'/%3e %3c/g%3e%3c/svg%3e";

var IconLock = function () {
    return React.createElement(Icon, { icon: img$h });
};
var IconSuccess = function () {
    return React.createElement(Icon, { icon: img$n });
};
var IconPhone = function () {
    return React.createElement(Icon, { icon: img$g });
};
var IconWhats = function () {
    return React.createElement(Icon, { icon: img$f });
};
var IconPlace = function () {
    return React.createElement(Icon, { icon: img$e });
};
var IconAngleDown = function (props) {
    if (props === void 0) { props = {}; }
    return React.createElement(Icon, __assign({ icon: img$o }, props));
};
var IconEmojiSuccess = function (props) {
    if (props === void 0) { props = {}; }
    return React.createElement(Icon, __assign({ icon: img$8 }, props));
};
var IconEmojiError = function (props) {
    if (props === void 0) { props = {}; }
    return React.createElement(Icon, __assign({ icon: img$9 }, props));
};
var IconEmojiWarning = function (props) {
    if (props === void 0) { props = {}; }
    return React.createElement(Icon, __assign({ icon: img$7 }, props));
};
var IconFav = function (props) {
    if (props === void 0) { props = {}; }
    return React.createElement(Icon, __assign({ icon: img$d }, props));
};
var IconOrderBy = function (props) {
    if (props === void 0) { props = {}; }
    return React.createElement(Icon, __assign({ icon: img$c }, props));
};
var IconSearch = function (props) {
    if (props === void 0) { props = {}; }
    return React.createElement(Icon, __assign({ icon: img$b }, props));
};
var IconClose = function (props) {
    if (props === void 0) { props = {}; }
    return React.createElement(Icon, __assign({ icon: img$a }, props));
};
var IconInformation = function (props) {
    if (props === void 0) { props = {}; }
    return React.createElement(Icon, __assign({ icon: img$m }, props));
};

var HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })(templateObject_1$j || (templateObject_1$j = __makeTemplateObject(["\n  border: 0;\n  clip: rect(0 0 0 0);\n  clippath: inset(50%);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n"], ["\n  border: 0;\n  clip: rect(0 0 0 0);\n  clippath: inset(50%);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n"])));
var CheckMark = styled(StyledIcon)(templateObject_2$h || (templateObject_2$h = __makeTemplateObject(["\n  margin: auto;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -o-user-select: none;\n  user-select: none;\n"], ["\n  margin: auto;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -o-user-select: none;\n  user-select: none;\n"])));
var StyledCheckbox = styled.div(templateObject_7$6 || (templateObject_7$6 = __makeTemplateObject(["\n  display: flex;\n  width: 18px;\n  height: 18px;\n  background: ", ";\n  border: ", " ", ";\n  border-radius: ", ";\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", " {\n    visibility: ", "\n  }\n"], ["\n  display: flex;\n  width: 18px;\n  height: 18px;\n  background: ", ";\n  border: ", " ", ";\n  border-radius: ", ";\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", " {\n    visibility: ", "\n  }\n"])), theme.color.white, theme.border.small, theme.color.gray_650, theme.radius.v_5, function (_a) {
    var checked = _a.checked;
    return checked && css(templateObject_3$f || (templateObject_3$f = __makeTemplateObject(["\n      background: ", ";\n      border: ", " ", ";\n    "], ["\n      background: ", ";\n      border: ", " ", ";\n    "])), theme.color.blue_600, theme.border.small, theme.color.blue_600);
}, function (_a) {
    var error = _a.error;
    return error && css(templateObject_4$d || (templateObject_4$d = __makeTemplateObject(["\n      border: ", " ", ";\n    "], ["\n      border: ", " ", ";\n    "])), theme.border.small, theme.color.red_900);
}, function (_a) {
    var checked = _a.checked, error = _a.error;
    return checked &&
        error && css(templateObject_5$a || (templateObject_5$a = __makeTemplateObject(["\n      background: ", ";\n    "], ["\n      background: ", ";\n    "])), theme.color.red_900);
}, function (_a) {
    var disabled = _a.disabled;
    return disabled && css(templateObject_6$7 || (templateObject_6$7 = __makeTemplateObject(["\n      background: ", ";\n      border: ", " ", ";\n    "], ["\n      background: ", ";\n      border: ", " ", ";\n    "])), theme.color.gray_275, theme.border.small, theme.color.gray_375);
}, CheckMark, function (props) { return props.checked ? 'visible' : 'hidden'; });
var StyledLabel = styled.label(templateObject_10$2 || (templateObject_10$2 = __makeTemplateObject(["\n  font-family: ", ";\n  font-size: ", ";\n  display: flex;\n  color: ", ";\n\n  ", "\n\n  ", "\n  \n  span {\n    margin-left: 0.5rem;\n  }\n"], ["\n  font-family: ", ";\n  font-size: ", ";\n  display: flex;\n  color: ", ";\n\n  ", "\n\n  ", "\n  \n  span {\n    margin-left: 0.5rem;\n  }\n"])), theme.font.family.regular, theme.font.size.v_14, function (_a) {
    var theme = _a.theme, color = _a.color;
    return solveThemeValue(theme.color, color, 'black');
}, function (_a) {
    var error = _a.error;
    return error && css(templateObject_8$4 || (templateObject_8$4 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), theme.color.red_900);
}, function (_a) {
    var disabled = _a.disabled;
    return disabled && css(templateObject_9$4 || (templateObject_9$4 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), theme.color.gray_375);
});
var templateObject_1$j, templateObject_2$h, templateObject_3$f, templateObject_4$d, templateObject_5$a, templateObject_6$7, templateObject_7$6, templateObject_8$4, templateObject_9$4, templateObject_10$2;

var img$6 = "data:image/svg+xml,%3csvg id='check-mark' xmlns='http://www.w3.org/2000/svg' width='9.198' height='6.857' viewBox='0 0 9.198 6.857'%3e %3cg id='Grupo_2133' data-name='Grupo 2133' transform='translate(0 0)'%3e %3cpath id='Caminho_2507' data-name='Caminho 2507' d='M4.163%2c12.358a1.068%2c1.068%2c0%2c0%2c1-1.51%2c0l-2.34-2.34a1.068%2c1.068%2c0%2c0%2c1%2c1.51-1.51L3.217%2c9.9a.27.27%2c0%2c0%2c0%2c.382%2c0L7.374%2c6.127a1.068%2c1.068%2c0%2c1%2c1%2c1.51%2c1.51Z' transform='translate(0 -5.814)' fill='white'/%3e %3c/g%3e%3c/svg%3e";

var InputCheckbox = function (_a) {
    var checked = _a.checked, disabled = _a.disabled, error = _a.error, id = _a.id, label = _a.label, containerClassName = _a.containerClassName, onChange = _a.onChange, color = _a.color, props = __rest(_a, ["checked", "disabled", "error", "id", "label", "containerClassName", "onChange", "color"]);
    var _b = useState(checked || false), localChecked = _b[0], setLocalChecked = _b[1];
    useEffect(function () {
        setLocalChecked(checked);
    }, [checked]);
    var handleCheckedChange = function (event) {
        setLocalChecked(event.target.checked);
        if (onChange) {
            onChange(event);
        }
    };
    return (React.createElement(StyledLabel, { checked: localChecked || false, disabled: disabled, error: error, color: color, className: containerClassName },
        React.createElement(HiddenCheckbox, __assign({ "data-testid": id, checked: localChecked || false, disabled: disabled, onChange: function (e) { return handleCheckedChange(e); } }, props)),
        React.createElement(StyledCheckbox, { "data-testid": "styled-" + id, checked: localChecked || false, disabled: disabled, error: error },
            React.createElement(CheckMark, { src: img$6 })),
        label && (React.createElement("span", { "data-testid": "label-" + id }, label))));
};
InputCheckbox.defaultProps = {
    color: 'black'
};

var StyledRadio = styled.input(templateObject_3$e || (templateObject_3$e = __makeTemplateObject(["\n  appearance: none;\n  background: ", ";\n  margin: 0;\n  width: 1rem;\n  height: 1rem;\n  border: ", " ", ";\n  border-radius: ", ";\n  display: grid;\n  place-content: center;\n\n  ::before {\n    content: \"\";\n    width: 0.5rem;\n    height: 0.5rem;\n    border-radius: ", ";\n    transform: scale(0);\n    transition: 120ms transform ease-in-out;\n  }\n\n  :checked {\n    border: ", " ", ";\n\n    ::before {\n      transform: scale(1);\n      box-shadow: inset 1rem 1rem ", ";\n    }\n  }\n\n  ", "\n\n  \n  ", "\n\n"], ["\n  appearance: none;\n  background: ", ";\n  margin: 0;\n  width: 1rem;\n  height: 1rem;\n  border: ", " ", ";\n  border-radius: ", ";\n  display: grid;\n  place-content: center;\n\n  ::before {\n    content: \"\";\n    width: 0.5rem;\n    height: 0.5rem;\n    border-radius: ", ";\n    transform: scale(0);\n    transition: 120ms transform ease-in-out;\n  }\n\n  :checked {\n    border: ", " ", ";\n\n    ::before {\n      transform: scale(1);\n      box-shadow: inset 1rem 1rem ", ";\n    }\n  }\n\n  ", "\n\n  \n  ", "\n\n"])), theme.color.white, theme.border.small, theme.color.gray_650, theme.radius.round, theme.radius.round, theme.border.small, theme.color.black_pearl, theme.color.blue_600, function (_a) {
    var error = _a.error;
    return error && css(templateObject_1$i || (templateObject_1$i = __makeTemplateObject(["\n      :checked {\n        border: ", " ", ";\n\n        ::before {\n          transform: scale(1);\n          box-shadow: inset 1rem 1rem ", ";\n        }\n      }\n    "], ["\n      :checked {\n        border: ", " ", ";\n\n        ::before {\n          transform: scale(1);\n          box-shadow: inset 1rem 1rem ", ";\n        }\n      }\n    "])), theme.border.small, theme.color.red_900, theme.color.red_900);
}, function (_a) {
    var disabled = _a.disabled;
    return disabled && css(templateObject_2$g || (templateObject_2$g = __makeTemplateObject(["\n      background: ", ";\n      border: ", " ", " !important;\n\n      ::before {\n        transform: scale(1);\n        box-shadow: inset 1rem 1rem ", " !important;\n      }\n    "], ["\n      background: ", ";\n      border: ", " ", " !important;\n\n      ::before {\n        transform: scale(1);\n        box-shadow: inset 1rem 1rem ", " !important;\n      }\n    "])), theme.color.gray_275, theme.border.regular, theme.color.gray_290, theme.color.gray_375);
});
var templateObject_1$i, templateObject_2$g, templateObject_3$e;

var InputRadio = function (_a) {
    var checked = _a.checked, disabled = _a.disabled, error = _a.error, id = _a.id, label = _a.label, containerClassName = _a.containerClassName, onChange = _a.onChange, color = _a.color, props = __rest(_a, ["checked", "disabled", "error", "id", "label", "containerClassName", "onChange", "color"]);
    var handleSelectChange = function (event) {
        if (onChange) {
            onChange(event);
        }
    };
    return (React.createElement(StyledLabel, { checked: checked, disabled: disabled, error: error, color: color, className: containerClassName },
        React.createElement(StyledRadio, __assign({ "data-testid": id, type: 'radio', disabled: disabled, error: error, defaultChecked: checked, onChange: function (e) { return handleSelectChange(e); } }, props)),
        label && (React.createElement("span", { "data-testid": "label-" + id }, label))));
};
InputRadio.defaultProps = {
    color: 'black'
};

var img$5 = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='16' height='11.637' viewBox='0 0 16 11.637'%3e %3cg id='icon_hide__on' transform='translate(0)'%3e %3cpath id='icon_hide__on-2' d='M359.673%2c365.313l-1.862-1.3A8.593%2c8.593%2c0%2c0%2c0%2c360%2c360.814a8.564%2c8.564%2c0%2c0%2c0-12.6-4.1l-2.254-1.58a.727.727%2c0%2c0%2c0-.833%2c1.192l1.876%2c1.315a8.593%2c8.593%2c0%2c0%2c0-2.17%2c3.177%2c8.567%2c8.567%2c0%2c0%2c0%2c12.584%2c4.121l2.24%2c1.569a.727.727%2c0%2c0%2c0%2c.833-1.192Zm-7.665-8.137a3.637%2c3.637%2c0%2c0%2c1%2c3.326%2c5.1l-1.231-.863a2.177%2c2.177%2c0%2c0%2c0-3.372-2.363l-1.23-.862A3.614%2c3.614%2c0%2c0%2c1%2c352.008%2c357.175Zm0%2c7.278a3.639%2c3.639%2c0%2c0%2c1-3.338-5.075l1.236.866a2.177%2c2.177%2c0%2c0%2c0%2c3.357%2c2.353l1.232.863A3.614%2c3.614%2c0%2c0%2c1%2c352.008%2c364.453Z' transform='translate(-344 -354.999)' fill='%230052cc'/%3e %3c/g%3e%3c/svg%3e";

var img$4 = "data:image/svg+xml,%3csvg id='icon_hide__off' xmlns='http://www.w3.org/2000/svg' width='17' height='10.134' viewBox='0 0 17 10.134'%3e %3cpath id='Caminho_4559' data-name='Caminho 4559' d='M8.5%2c98.725c-3.248%2c0-6.194%2c1.777-8.367%2c4.663a.673.673%2c0%2c0%2c0%2c0%2c.8c2.173%2c2.89%2c5.119%2c4.667%2c8.367%2c4.667s6.194-1.777%2c8.367-4.663a.673.673%2c0%2c0%2c0%2c0-.8C14.694%2c100.5%2c11.748%2c98.725%2c8.5%2c98.725Zm.233%2c8.635a3.576%2c3.576%2c0%2c1%2c1%2c3.335-3.335A3.578%2c3.578%2c0%2c0%2c1%2c8.733%2c107.36Zm-.108-1.648a1.925%2c1.925%2c0%2c1%2c1%2c1.8-1.8A1.922%2c1.922%2c0%2c0%2c1%2c8.625%2c105.711Z' transform='translate(0 -98.725)' fill='%230052cc'/%3e%3c/svg%3e";

var ContainerInput = styled.div(templateObject_1$h || (templateObject_1$h = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  .input__icon img {\n    width: 100%;\n  }\n"], ["\n  display: flex;\n  justify-content: space-between;\n  .input__icon img {\n    width: 100%;\n  }\n"])));
var ContainerLabel = styled.div(templateObject_2$f || (templateObject_2$f = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  width:98%;\n  padding: ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n  width:98%;\n  padding: ", ";\n"])), function (props) { return props.$size.padding; });
var StyledMessage = styled('span')(templateObject_3$d || (templateObject_3$d = __makeTemplateObject(["\n   color: ", ";\n   font-size: ", ";\n   font-family:", ";\n   padding: .5rem .2rem;\n   display:block;\n};"], ["\n   color: ", ";\n   font-size: ", ";\n   font-family:", ";\n   padding: .5rem .2rem;\n   display:block;\n};"])), function (props) {
    return props.error
        ? theme.color.red_900
        : props.disabled
            ? theme.color.gray_50
            : theme.color.black;
}, theme.font.size.v_12, theme.font.family.custom1);
var StyledInput = styled('div')(templateObject_6$6 || (templateObject_6$6 = __makeTemplateObject(["\n\n  input::-ms-reveal,\n  input::-ms-clear {\n    display: none;\n  }\n\n  ", "\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  background-color:", ";\n  font-family: ", ";\n  border-radius: ", ";\n  \n  label {\n    font-family: ", ";\n    font-size: ", ";\n    display:block;\n    margin-left: .1rem;\n    \n    margin-bottom: .2rem;\n    color: ", ";\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  input {\n    &, &::placeholder {\n      ", "\n    }\n    width:98%;\n    background:none;\n    border: none;\n    outline:none;\n    color:", ";\n\n\n    font-family: ", ";\n    font-weight: ", ";\n\n     &:focus {\n        border: none;\n        outline:none;\n     }\n\n     &:focus-visible {\n        border: none;\n        outline:none;\n     }\n  }\n\n  &:hover {\n     border: solid 1px ", ";\n  }\n;"], ["\n\n  input::-ms-reveal,\n  input::-ms-clear {\n    display: none;\n  }\n\n  ", "\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  background-color:", ";\n  font-family: ", ";\n  border-radius: ", ";\n  \n  label {\n    font-family: ", ";\n    font-size: ", ";\n    display:block;\n    margin-left: .1rem;\n    \n    margin-bottom: .2rem;\n    color: ", ";\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  input {\n    &, &::placeholder {\n      ", "\n    }\n    width:98%;\n    background:none;\n    border: none;\n    outline:none;\n    color:", ";\n\n\n    font-family: ", ";\n    font-weight: ", ";\n\n     &:focus {\n        border: none;\n        outline:none;\n     }\n\n     &:focus-visible {\n        border: none;\n        outline:none;\n     }\n  }\n\n  &:hover {\n     border: solid 1px ", ";\n  }\n;"])), function (_a) {
    var $size = _a.$size, label = _a.label, disabled = _a.disabled, error = _a.error;
    var color = error ? theme.color.red_900 : disabled ? theme.color.gray_50 : theme.color.black;
    return css(templateObject_4$c || (templateObject_4$c = __makeTemplateObject(["\n        font-size: ", ";\n        padding: ", ";\n        height: ", ";\n        border: solid 1px ", ";\n        opacity: 1;\n        color: ", ";\n        -webkit-text-fill-color: ", ";\n    "], ["\n        font-size: ", ";\n        padding: ", ";\n        height: ", ";\n        border: solid 1px ", ";\n        opacity: 1;\n        color: ", ";\n        -webkit-text-fill-color: ", ";\n    "])), solveThemeValue(theme.font.size, label ? $size.fontSize : $size.fontSizeNoLabel), $size.paddingInput, $size.height, error ? theme.color.red_900 : theme.color.gray_100, color, color);
}, theme.color.gray_100, theme.font.family.regular, theme.radius.small, theme.font.family.regular, function (_a) {
    var $size = _a.$size;
    return solveThemeValue(theme.font.size, $size.labelSize);
}, theme.color.gray_700, function (_a) {
    var $size = _a.$size, label = _a.label;
    return css(templateObject_5$9 || (templateObject_5$9 = __makeTemplateObject(["\n          font-size: ", ";\n        "], ["\n          font-size: ", ";\n        "])), solveThemeValue(theme.font.size, label ? $size.fontSize : $size.fontSizeNoLabel));
}, function (props) {
    return props.error
        ? theme.color.red_900
        : props.disabled
            ? theme.color.gray_50
            : theme.color.black;
}, theme.font.family.regular, theme.font.weight.v_600, function (props) {
    return props.error
        ? theme.color.red_900
        : props.disabled
            ? theme.color.gray_50
            : theme.color.blue_200;
});
var templateObject_1$h, templateObject_2$f, templateObject_3$d, templateObject_4$c, templateObject_5$9, templateObject_6$6;

var InputText = function (_a) {
    var containerClassName = _a.containerClassName, maskOptions = _a.maskOptions, onChange = _a.onChange, onClickIcon = _a.onClickIcon, fieldSize = _a.fieldSize, error = _a.error, errorMessage = _a.errorMessage, inputRef = _a.inputRef, icon = _a.icon, type = _a.type, numberType = _a.numberType, props = __rest(_a, ["containerClassName", "maskOptions", "onChange", "onClickIcon", "fieldSize", "error", "errorMessage", "inputRef", "icon", "type", "numberType"]);
    var themeContext = useContext(ThemeContext);
    var sizeVariant = useMemo(function () {
        return solveVariant(themeContext.input.size, fieldSize, 'normal');
    }, [fieldSize]);
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledInput, { "$size": sizeVariant, label: props.label, error: error, disabled: props.disabled, className: containerClassName },
            React.createElement(ContainerInput, null,
                React.createElement(ContainerLabel, { "$size": sizeVariant },
                    React.createElement("label", null, props.label),
                    !maskOptions ? (React.createElement("input", __assign({ type: numberType ? 'number' : type, ref: inputRef, onChange: onChange }, props, { "data-testid": props.id }))) : (React.createElement(NumberFormat, __assign({ ref: inputRef, onValueChange: onChange, "data-testid": props.id }, maskOptions, props)))),
                icon && React.createElement(Icon, { className: 'input__icon', id: props.id + "-icon", icon: icon, onClick: onClickIcon }))),
        React.createElement(StyledMessage, { error: error, disabled: props.disabled }, errorMessage)));
};
InputText.defaultProps = {
    fieldSize: 'normal',
    error: null,
    type: 'text',
    onChange: function () { },
    onClickIcon: function () { },
    disabled: false
};

var DEFAULT_THEME = 'default';
var KeyControl;
(function (KeyControl) {
    KeyControl[KeyControl["UP"] = 38] = "UP";
    KeyControl[KeyControl["DOWN"] = 40] = "DOWN";
    KeyControl[KeyControl["ENTER"] = 13] = "ENTER";
    KeyControl[KeyControl["ESCAPE"] = 27] = "ESCAPE";
})(KeyControl || (KeyControl = {}));
// Table
var CellTextAlignment = {
    left: 'flex-start',
    right: 'flex-end',
    center: 'center'
};
// Formatters
var DATE_MASK = '##/##/####';
var CPF_MASK = '###.###.###-##';
var CELLPHONE_MASK = '(##) #####-####';
var PHONE_MASK = '(##) ####-#####';
var CNPJ_MASK = '##.###.###/####-##';
var NUMBER_PUNCTUATION = {
    decimalSeparator: ',',
    fixedDecimalScale: true,
    thousandSeparator: '.'
};
var REAL_MASK = {
    decimalScale: 2,
    prefix: 'R$ ',
    decimalSeparator: ',',
    fixedDecimalScale: true,
    thousandSeparator: '.'
};

var CnpjInput = function (_a) {
    var props = __rest(_a, []);
    return React.createElement(InputText, __assign({}, props, { maskOptions: { displayType: 'input', format: CNPJ_MASK } }));
};

var CpfInput = function (_a) {
    var props = __rest(_a, []);
    return React.createElement(InputText, __assign({}, props, { maskOptions: { displayType: 'input', format: CPF_MASK } }));
};

var RealInput = function (props) {
    return React.createElement(InputText, __assign({}, props, { maskOptions: __assign({ displayType: 'input' }, REAL_MASK) }));
};

var NumberPCInput = function (_a) {
    var decimalScale = _a.decimalScale, prefix = _a.prefix, suffix = _a.suffix, props = __rest(_a, ["decimalScale", "prefix", "suffix"]);
    return React.createElement(InputText, __assign({}, props, { maskOptions: __assign(__assign({ displayType: 'input' }, NUMBER_PUNCTUATION), { decimalScale: decimalScale, prefix: prefix, suffix: suffix }) }));
};
NumberPCInput.defaultProps = {
    decimalScale: 2
};

var PhoneNumberInput = function (_a) {
    var props = __rest(_a, []);
    var valueNumber = props.value + '';
    return (React.createElement(React.Fragment, null,
        React.createElement(InputText, __assign({}, props, { maskOptions: {
                displayType: 'input',
                format: valueNumber.length < 11 ? PHONE_MASK : CELLPHONE_MASK
            } }))));
};

var LocalDateInput = function (_a) {
    var props = __rest(_a, []);
    return React.createElement(InputText, __assign({}, props, { maskOptions: { displayType: 'input', format: DATE_MASK } }));
};

var InputPassword = function (props) {
    var _a = useState(false), hidePass = _a[0], setHidePass = _a[1];
    var handlePass = function () {
        setHidePass(!hidePass);
    };
    return (React.createElement(InputText, __assign({}, props, { icon: hidePass ? img$4 : img$5, type: hidePass ? 'text' : 'password', onClickIcon: handlePass })));
};

var UserSelectNone = css(templateObject_1$g || (templateObject_1$g = __makeTemplateObject(["\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n"], ["\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n"])));
var ScrollBarCustom = css(templateObject_2$e || (templateObject_2$e = __makeTemplateObject(["\n  /* width */\n  &::-webkit-scrollbar {\n    width: 4px;\n  }\n\n  /* Track */\n  &::-webkit-scrollbar-track {\n    border-radius: 4px;\n  }\n\n  /* Handle */\n  &::-webkit-scrollbar-thumb {\n    background: ", ";\n    border-radius: 4px;\n  }\n"], ["\n  /* width */\n  &::-webkit-scrollbar {\n    width: 4px;\n  }\n\n  /* Track */\n  &::-webkit-scrollbar-track {\n    border-radius: 4px;\n  }\n\n  /* Handle */\n  &::-webkit-scrollbar-thumb {\n    background: ", ";\n    border-radius: 4px;\n  }\n"])), theme.color.gray_300);
var templateObject_1$g, templateObject_2$e;

var Message = styled.span(templateObject_1$f || (templateObject_1$f = __makeTemplateObject(["\n   color: ", ";\n   font-size: ", ";\n   font-family:", ";\n   padding: .5rem .2rem;\n   display:block;\n};"], ["\n   color: ", ";\n   font-size: ", ";\n   font-family:", ";\n   padding: .5rem .2rem;\n   display:block;\n};"])), function (props) {
    return props.error
        ? props.theme.color.red_900
        : props.disabled
            ? props.theme.color.gray_50
            : props.theme.color.black;
}, function (props) { return props.theme.font.size.v_12; }, function (props) { return props.theme.font.family.custom1; });
var Dropdown$1 = styled.div(templateObject_5$8 || (templateObject_5$8 = __makeTemplateObject(["\n\n  ", "\n  \n  ", " {\n    display: none;\n  }\n  \n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  cursor: pointer;\n  position: relative;\n  \n  ", " {\n    margin-bottom: 0;\n    \n    ", "\n    \n    ", "\n  }\n  \n  .dropdown-icon {\n    position: absolute;\n    right: 16px;\n  }\n\n  ", "\n;"], ["\n\n  ", "\n  \n  ", " {\n    display: none;\n  }\n  \n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  cursor: pointer;\n  position: relative;\n  \n  ", " {\n    margin-bottom: 0;\n    \n    ", "\n    \n    ", "\n  }\n  \n  .dropdown-icon {\n    position: absolute;\n    right: 16px;\n  }\n\n  ", "\n;"])), function (_a) {
    var $size = _a.$size, label = _a.label, theme = _a.theme;
    return css(templateObject_2$d || (templateObject_2$d = __makeTemplateObject(["\n      font-size: ", ";\n      font-family:", ";\n  "], ["\n      font-size: ", ";\n      font-family:", ";\n  "])), solveThemeValue(theme.font.size, label ? $size.fontSize : $size.fontSizeNoLabel), theme.font.family.regular);
}, StyledMessage, StyledInput, function (props) { return props.open && css(templateObject_3$c || (templateObject_3$c = __makeTemplateObject(["\n      border-radius: ", ";\n    "], ["\n      border-radius: ", ";\n    "])), props.theme.radius.small + " " + props.theme.radius.small + " 0px 0px"); }, function (props) { return !props.error && css(templateObject_4$b || (templateObject_4$b = __makeTemplateObject(["\n      &:hover {\n        border-color: transparent;\n      }\n    "], ["\n      &:hover {\n        border-color: transparent;\n      }\n    "]))); }, UserSelectNone);
var DropdownSelect = styled.div(templateObject_6$5 || (templateObject_6$5 = __makeTemplateObject(["\n  position: absolute;\n  top: 100%;\n  width: 100%;\n  background: ", ";\n  box-shadow: ", ";\n  border-radius: ", ";\n  z-index: 2;\n\n  /* Limiting the size and scroll*/\n  max-height: 165px;\n  overflow-y: scroll;\n  ", ";\n"], ["\n  position: absolute;\n  top: 100%;\n  width: 100%;\n  background: ", ";\n  box-shadow: ", ";\n  border-radius: ", ";\n  z-index: 2;\n\n  /* Limiting the size and scroll*/\n  max-height: 165px;\n  overflow-y: scroll;\n  ", ";\n"])), function (props) { return props.theme.color.white; }, function (props) { return props.theme.boxShadow.dropdown; }, function (props) { return "0px 0px " + props.theme.radius.small + " " + props.theme.radius.small; }, ScrollBarCustom);
var DropdownOption = styled.div(templateObject_7$5 || (templateObject_7$5 = __makeTemplateObject(["\n\n  ", "\n  height: 30px;\n  display: flex;\n  align-items: center;\n\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  \n  ", "\n"], ["\n\n  ", "\n  height: 30px;\n  display: flex;\n  align-items: center;\n\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  \n  ", "\n"])), function (_a) {
    var theme = _a.theme, $size = _a.$size;
    return ({
        fontSize: solveThemeValue(theme.font.size, $size.fontSize),
        padding: $size.paddingOption
    });
}, function (props) { return props.selected && {
    fontWeight: props.theme.font.weight.v_500,
    backgroundColor: props.$variantData.hoverBackgroundColor
}; });
var templateObject_1$f, templateObject_2$d, templateObject_3$c, templateObject_4$b, templateObject_5$8, templateObject_6$5, templateObject_7$5;

var useOnClickOutside = (function (ref, handler) {
    useEffect(function () {
        var listener = function (event) {
            // Do nothing if clicking ref's element or descendent elements
            if (!ref.current || ref.current.contains(event.target)) {
                return;
            }
            handler(event);
        };
        document.addEventListener('mousedown', listener);
        document.addEventListener('touchstart', listener);
        return function () {
            document.removeEventListener('mousedown', listener);
            document.removeEventListener('touchstart', listener);
        };
    }, [ref, handler]);
});

var getInitials = function (name) {
    var _a, _b;
    name = name.trim();
    if (!name.length) {
        return 'AA';
    }
    var namesArray = name.split(' ');
    var initials;
    if (namesArray.length === 1) {
        initials = name.substring(0, 2);
    }
    else {
        initials = ((_a = namesArray.shift()) === null || _a === void 0 ? void 0 : _a[0].charAt(0)) + ((_b = namesArray.pop()) === null || _b === void 0 ? void 0 : _b[0].charAt(0));
    }
    return initials.toUpperCase();
};
var deaccentString = function (text) {
    return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
};
var matchText = function (text1, text2) {
    // Maybe we can add Levenshtein distance if it's necessary
    return text1.toLowerCase().indexOf(text2.toLowerCase()) !== -1;
};

var Dropdown = function (_a) {
    var id = _a.id, children = _a.children, value = _a.value, itemText = _a.itemText, itemValue = _a.itemValue, items = _a.items, onChange = _a.onChange, variant = _a.variant, fieldSize = _a.fieldSize, errorMessage = _a.errorMessage, searchable = _a.searchable, onSearch = _a.onSearch, props = __rest(_a, ["id", "children", "value", "itemText", "itemValue", "items", "onChange", "variant", "fieldSize", "errorMessage", "searchable", "onSearch"]);
    // Compatibility Support
    if (props['data-testid'])
        id = props['data-testid'];
    var _b = useState(items), localItems = _b[0], setLocalItems = _b[1];
    var _c = useState(items), filteredItems = _c[0], setFilteredItems = _c[1];
    var _d = useState(null), localValue = _d[0], setLocalValue = _d[1];
    var _e = useState(false), hasFocus = _e[0], setHasFocus = _e[1];
    var _f = useState(''), searchText = _f[0], setSearchText = _f[1];
    var _g = useState(0), searchItemSelected = _g[0], setSearchItemSelected = _g[1];
    var ref = useRef();
    var inputRef = useRef();
    var themeContext = useContext(ThemeContext);
    var useFilteredList = hasFocus && searchable && !onSearch;
    var visibleItems = useFilteredList ? filteredItems : localItems;
    var isReadOnly = !searchable ? true : !hasFocus;
    var icon = props.icon || themeContext.dropdown.defaultIcon;
    var sizeVariant = useMemo(function () {
        return solveVariant(themeContext.dropdown.size, fieldSize, 'normal');
    }, [fieldSize]);
    var variantData = useMemo(function () {
        return solveVariant(themeContext.dropdown.variant, variant, 'dark');
    }, [variant]);
    var filterLocalItems = function (value) {
        var sanitizedValue = deaccentString(value);
        var newItems = sanitizedValue === ''
            ? localItems
            : localItems.filter(function (l) {
                return matchText(deaccentString(l[itemText]), sanitizedValue);
            });
        setFilteredItems(newItems);
    };
    var onClickField = function () {
        if (props.disabled)
            return;
        setHasFocus(!hasFocus);
        setSearchItemSelected(0);
        // Force focus on the field and select all content
        if (searchable && inputRef.current) {
            inputRef.current.focus();
            inputRef.current.select();
            setFilteredItems(localItems);
        }
    };
    var selectOption = function (item) {
        var value = item[itemValue];
        setLocalValue({
            text: item[itemText],
            value: value
        });
        setHasFocus(false);
        onChange(value);
        setSearchText(item[itemText]);
    };
    var onClickOption = function (item, e) {
        selectOption(item);
        // We need stop propagation to stop onClickField to
        // be executed
        e.stopPropagation();
    };
    var handleSearchInput = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var value;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    value = e.target.value;
                    setSearchText(e.target.value);
                    setSearchItemSelected(0);
                    if (!(onSearch !== null)) return [3 /*break*/, 2];
                    return [4 /*yield*/, onSearch(value)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    filterLocalItems(value);
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleKeyDownControls = function (e) {
        switch (e.which) {
            case KeyControl.UP:
                setSearchItemSelected(Math.max(0, searchItemSelected - 1));
                break;
            case KeyControl.DOWN:
                setSearchItemSelected(Math.min(visibleItems.length - 1, searchItemSelected + 1));
                break;
            case KeyControl.ESCAPE:
                // Roll backing the visible text if user don't select any option
                setHasFocus(false);
                if (localValue) {
                    setSearchText(localValue[itemText]);
                }
                break;
            case KeyControl.ENTER:
                if (!hasFocus) {
                    onClickField();
                }
                else if (visibleItems.length > 0) {
                    selectOption(visibleItems[searchItemSelected]);
                }
                break;
        }
    };
    // Handling changes in value prop
    // if value prop changed we need to look up
    // for the item which the current value is equal
    // and select it
    useEffect(function () {
        if (value || value === '') {
            var item = localItems.find(function (i) { return i[itemValue].toString() === value.toString(); });
            if (item) {
                setLocalValue({
                    text: item[itemText],
                    value: item[itemValue]
                });
            }
        }
    }, [value]);
    useEffect(function () {
        setSearchText(localValue ? localValue[itemText] : '');
    }, [localValue]);
    // Handling Children Options and Items Array
    useEffect(function () {
        var childItems = React.Children.map(children, function (child) {
            var _a;
            if (React.isValidElement(child)) {
                var _b = child.props, compValue = _b.value, children_1 = _b.children;
                return _a = {},
                    _a[itemText] = children_1,
                    _a[itemValue] = compValue,
                    _a;
            }
        }) || [];
        var newLocalItem = __spreadArray(__spreadArray([], childItems, true), items, true);
        for (var _i = 0, newLocalItem_1 = newLocalItem; _i < newLocalItem_1.length; _i++) {
            var item = newLocalItem_1[_i];
            if (localValue == null && value === item[itemValue]) {
                setLocalValue(item);
                break;
            }
        }
        setLocalItems(newLocalItem);
    }, [children, items]);
    // Always select first item if value is undefined
    useEffect(function () {
        if (localItems.length > 0 && localValue == null) {
            setLocalValue(localItems[0]);
            onChange(localItems[0][itemValue]);
        }
        setFilteredItems(localItems);
    }, [localItems]);
    useOnClickOutside(ref, function () {
        setHasFocus(false);
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(Dropdown$1, __assign({ ref: ref, onClick: onClickField, "$variantData": variantData, "$size": sizeVariant, open: hasFocus, "data-testid": id, onKeyDown: handleKeyDownControls }, props),
            React.createElement(InputText, { id: id + "-dropdown-input", label: props.label, icon: icon, inputRef: inputRef, fieldSize: fieldSize, error: props.error, onChange: handleSearchInput, readOnly: isReadOnly, value: searchText }),
            hasFocus && React.createElement(DropdownSelect, { "data-testid": id + "-dropdown-select" }, (visibleItems).map(function (item, index) {
                return (React.createElement(DropdownOption, { "$variantData": variantData, "$size": sizeVariant, "data-testid": id + "-opt_" + (item[itemValue] || index), key: "opt_" + (item[itemValue] || index), selected: searchItemSelected === index, onMouseEnter: function () { return setSearchItemSelected(index); }, onClick: function (e) { return onClickOption(item, e); } }, item[itemText]));
            }))),
        React.createElement(Message, { "data-testid": id + "-}dropdown-message", disabled: props.disabled, error: props.error }, errorMessage)));
};
Dropdown.defaultProps = {
    itemText: 'text',
    fieldSize: 'normal',
    items: [],
    searchable: false,
    variant: 'dark',
    onChange: function () { },
    onSearch: null,
    itemValue: 'value'
};

var Switcher$1 = styled.label(templateObject_4$a || (templateObject_4$a = __makeTemplateObject(["\n  position: relative;\n  display: inline-block;\n  ", "\n  \n  /* Hide default HTML checkbox */\n  input {\n    opacity: 0;\n    width: 0;\n    height: 0;\n  }\n  \n  & + * {\n    margin-left: 8px;\n  }\n  \n  .ds-switcher-slider {\n    position: absolute;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: ", ";\n    -webkit-transition: .4s;\n    transition: .4s;\n    border-radius: 20px;\n  \n    &:before {\n      position: absolute;\n      content: \"\";\n      border-radius: 50%;\n      left: 3px;\n      bottom: 3px;\n      background: white;\n      -webkit-transition: .4s;\n      box-shadow: ", ";\n      border: 1px solid #DEDFDF;\n      box-sizing: border-box;\n      transition: .4s;\n      ", "\n    }\n  }\n\n  input:checked + .ds-switcher-slider {\n    background-color: ", ";\n  }\n\n  input:checked + .ds-switcher-slider:before {\n    ", "\n  }\n"], ["\n  position: relative;\n  display: inline-block;\n  ", "\n  \n  /* Hide default HTML checkbox */\n  input {\n    opacity: 0;\n    width: 0;\n    height: 0;\n  }\n  \n  & + * {\n    margin-left: 8px;\n  }\n  \n  .ds-switcher-slider {\n    position: absolute;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: ", ";\n    -webkit-transition: .4s;\n    transition: .4s;\n    border-radius: 20px;\n  \n    &:before {\n      position: absolute;\n      content: \"\";\n      border-radius: 50%;\n      left: 3px;\n      bottom: 3px;\n      background: white;\n      -webkit-transition: .4s;\n      box-shadow: ", ";\n      border: 1px solid #DEDFDF;\n      box-sizing: border-box;\n      transition: .4s;\n      ", "\n    }\n  }\n\n  input:checked + .ds-switcher-slider {\n    background-color: ", ";\n  }\n\n  input:checked + .ds-switcher-slider:before {\n    ", "\n  }\n"])), function (_a) {
    var $size = _a.$size;
    return css(templateObject_1$e || (templateObject_1$e = __makeTemplateObject(["\n    width: ", ";\n    height: ", ";\n  "], ["\n    width: ", ";\n    height: ", ";\n  "])), $size[0], $size[1]);
}, function (props) { return props.$state.backgroundColor; }, function (props) { return props.theme.boxShadow.switcher; }, function (_a) {
    var $size = _a.$size;
    return css(templateObject_2$c || (templateObject_2$c = __makeTemplateObject(["\n        width: calc(", " - 6px);\n        height: calc(", " - 6px);\n      "], ["\n        width: calc(", " - 6px);\n        height: calc(", " - 6px);\n      "])), $size[1], $size[1]);
}, function (_a) {
    var theme = _a.theme, $state = _a.$state, color = _a.color;
    return solveThemeValue(theme.color, color || $state.backgroundColor);
}, function (_a) {
    var $size = _a.$size;
    return css(templateObject_3$b || (templateObject_3$b = __makeTemplateObject(["\n        transform: translateX(calc(", " - ", "));\n      "], ["\n        transform: translateX(calc(", " - ", "));\n      "])), $size[0], $size[1]);
});
var SwitcherContainer = styled.div(templateObject_5$7 || (templateObject_5$7 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  > * {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  > * {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n"])));
var templateObject_1$e, templateObject_2$c, templateObject_3$b, templateObject_4$a, templateObject_5$7;

var Switcher = function (_a) {
    var id = _a.id, size = _a.size, disabled = _a.disabled, color = _a.color, checked = _a.checked, children = _a.children, onChange = _a.onChange, props = __rest(_a, ["id", "size", "disabled", "color", "checked", "children", "onChange"]);
    var _b = useState(checked || false), localChecked = _b[0], setLocalChecked = _b[1];
    var state = disabled ? 'disabled' : (localChecked ? 'active' : 'off');
    useEffect(function () {
        setLocalChecked(checked);
    }, [checked]);
    var themeContext = useContext(ThemeContext);
    var sizeVariant = useMemo(function () {
        return (typeof size === 'string')
            ? solveVariant(themeContext.switcher.size, size, 'normal', false)
            : size;
    }, [size]);
    var stateVariant = useMemo(function () {
        return solveVariant(themeContext.switcher.state, state, 'off');
    }, [state]);
    var handleCheckedChange = function (event) {
        setLocalChecked(event.target.checked);
        if (onChange) {
            onChange(event);
        }
    };
    return (React.createElement(SwitcherContainer, __assign({ "data-testid": "switcher-container-" + id, disabled: disabled }, props),
        React.createElement(Switcher$1, { "$size": sizeVariant, "$state": stateVariant, color: color },
            React.createElement("input", { type: "checkbox", "data-testid": "switcher-input-" + id, checked: localChecked, onChange: handleCheckedChange, disabled: disabled }),
            React.createElement("div", { className: 'ds-switcher-slider', "data-testid": "switcher-slider-" + id })),
        children));
};
Switcher.defaultProps = {
    checked: false,
    disabled: false,
    size: 'normal'
};

var StyledTextArea = styled('div')(templateObject_3$a || (templateObject_3$a = __makeTemplateObject(["\n   \n  ", "\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  background-color:", ";\n  font-family: ", ";\n  border-radius: ", ";\n  border: solid 1px ", ";\n  color: ", ";\n\n  label {\n     font-family: ", ";\n     font-size: ", ";\n     display:block;\n     margin-left: .1rem;\n     margin-bottom: .2rem;\n    color: ", ";\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  textarea {\n    &, &::placeholder {\n      ", "\n    }\n    width:98%;\n    background:none;\n    border: none;\n    outline:none;\n    resize: none;\n    color:", ";\n\n      \n    font-family: ", ";\n    font-weight: ", ";\n\n     &:focus {\n        border: none;\n        outline:none;\n     }\n\n     &:focus-visible {\n        border: none;\n        outline:none;\n     }\n  }\n  \n  &:hover {\n     border: solid 1px ", ";\n  }\n;"], ["\n   \n  ", "\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  background-color:", ";\n  font-family: ", ";\n  border-radius: ", ";\n  border: solid 1px ", ";\n  color: ", ";\n\n  label {\n     font-family: ", ";\n     font-size: ", ";\n     display:block;\n     margin-left: .1rem;\n     margin-bottom: .2rem;\n    color: ", ";\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  textarea {\n    &, &::placeholder {\n      ", "\n    }\n    width:98%;\n    background:none;\n    border: none;\n    outline:none;\n    resize: none;\n    color:", ";\n\n      \n    font-family: ", ";\n    font-weight: ", ";\n\n     &:focus {\n        border: none;\n        outline:none;\n     }\n\n     &:focus-visible {\n        border: none;\n        outline:none;\n     }\n  }\n  \n  &:hover {\n     border: solid 1px ", ";\n  }\n;"])), function (_a) {
    var $size = _a.$size, label = _a.label;
    return css(templateObject_1$d || (templateObject_1$d = __makeTemplateObject(["\n      font-size: ", ";\n      padding: ", ";\n  "], ["\n      font-size: ", ";\n      padding: ", ";\n  "])), solveThemeValue(theme.font.size, label ? $size.fontSize : $size.fontSizeNoLabel), $size.padding);
}, theme.color.gray_100, theme.font.family.regular, theme.radius.small, function (props) {
    return props.error ? theme.color.red_900 : theme.color.gray_100;
}, function (props) {
    return props.error
        ? theme.color.red_900
        : props.disabled
            ? theme.color.gray_50
            : theme.color.black;
}, theme.font.family.regular, function (_a) {
    var $size = _a.$size;
    return solveThemeValue(theme.font.size, $size.labelSize);
}, theme.color.gray_700, function (_a) {
    var $size = _a.$size, label = _a.label;
    return css(templateObject_2$b || (templateObject_2$b = __makeTemplateObject(["\n          font-size: ", ";\n        "], ["\n          font-size: ", ";\n        "])), solveThemeValue(theme.font.size, label ? $size.fontSize : $size.fontSizeNoLabel));
}, function (props) {
    return props.error
        ? theme.color.red_900
        : props.disabled
            ? theme.color.gray_50
            : theme.color.black;
}, theme.font.family.regular, theme.font.weight.v_600, function (props) {
    return props.error
        ? theme.color.red_900
        : props.disabled
            ? theme.color.gray_50
            : theme.color.blue_200;
});
var templateObject_1$d, templateObject_2$b, templateObject_3$a;

var InputTextArea = function (_a) {
    var containerClassName = _a.containerClassName, errorMessage = _a.errorMessage, onChange = _a.onChange, fieldSize = _a.fieldSize, inputRef = _a.inputRef, props = __rest(_a, ["containerClassName", "errorMessage", "onChange", "fieldSize", "inputRef"]);
    var themeContext = useContext(ThemeContext);
    var sizeVariant = useMemo(function () {
        return solveVariant(themeContext.input.size, fieldSize, 'normal');
    }, [fieldSize]);
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledTextArea, { "$size": sizeVariant, label: props.label, error: props.error, disabled: props.disabled, className: containerClassName },
            React.createElement("label", null, props.label),
            React.createElement("textarea", __assign({ ref: inputRef, onChange: onChange }, props, { "data-testid": props.id }))),
        React.createElement(StyledMessage, { error: props.error, disabled: props.disabled }, errorMessage)));
};
InputTextArea.defaultProps = {
    fieldSize: 'normal',
    error: null,
    disabled: false
};

var ContainerUserBadge = styled.div(templateObject_1$c || (templateObject_1$c = __makeTemplateObject(["\n  display: flex;\n  ", "\n"], ["\n  display: flex;\n  ", "\n"])), UserSelectNone);
var ContainerUserInfo = styled.div(templateObject_2$a || (templateObject_2$a = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  max-width: 10rem;\n  margin-left: ", ";\n  justify-content: space-evenly;\n"], ["\n  display: flex;\n  flex-direction: column;\n  max-width: 10rem;\n  margin-left: ", ";\n  justify-content: space-evenly;\n"])), theme.margin.v_16);
var Avatar = styled.div(templateObject_5$6 || (templateObject_5$6 = __makeTemplateObject(["\n  display: flex;\n  border-radius: 50%;\n \n  background-color: ", ";\n\n  ", "\n\n  span {\n    color: ", ";\n    margin: auto;\n    text-align: left;\n    font-family: ", ";\n    font-weight: ", ";\n    ", "\n  }\n\n  img {\n    display: block;\n    border-radius: 50%;\n    width: 100%;\n    height: auto;\n    background-color: ", ";\n    box-shadow: ", ";\n  }\n"], ["\n  display: flex;\n  border-radius: 50%;\n \n  background-color: ", ";\n\n  ", "\n\n  span {\n    color: ", ";\n    margin: auto;\n    text-align: left;\n    font-family: ", ";\n    font-weight: ", ";\n    ", "\n  }\n\n  img {\n    display: block;\n    border-radius: 50%;\n    width: 100%;\n    height: auto;\n    background-color: ", ";\n    box-shadow: ", ";\n  }\n"])), function (props) {
    return props.variant && theme.color[props.variant];
}, function (_a) {
    var $size = _a.$size;
    return css(templateObject_3$9 || (templateObject_3$9 = __makeTemplateObject(["\n    width: ", ";\n    height: ", ";\n  "], ["\n    width: ", ";\n    height: ", ";\n  "])), $size.avatar.size, $size.avatar.size);
}, theme.color.white, theme.font.family.regular, theme.font.weight.bold, function (_a) {
    var $size = _a.$size, theme = _a.theme;
    return css(templateObject_4$9 || (templateObject_4$9 = __makeTemplateObject(["\n      font-size: ", ";\n      line-height: ", ";\n    "], ["\n      font-size: ", ";\n      line-height: ", ";\n    "])), solveThemeValue(theme.font.size, $size.avatar.fontSize), solveThemeValue(theme.font.size, $size.avatar.lineHeight));
}, theme.color.white, theme.boxShadow.avatar);
var UserName = styled.div(templateObject_7$4 || (templateObject_7$4 = __makeTemplateObject(["\n  text-align: left;\n  font-family: ", ";\n  font-weight: ", ";\n  \n  letter-spacing: 0px;\n  color: ", ";\n  ", "\n"], ["\n  text-align: left;\n  font-family: ", ";\n  font-weight: ", ";\n  \n  letter-spacing: 0px;\n  color: ", ";\n  ", "\n"])), theme.font.family.regular, theme.font.weight.bold, theme.color.gray_900, function (_a) {
    var $size = _a.$size;
    return css(templateObject_6$4 || (templateObject_6$4 = __makeTemplateObject(["\n    font-size: ", ";\n    line-height: ", ";\n  "], ["\n    font-size: ", ";\n    line-height: ", ";\n  "])), solveThemeValue(theme.font.size, $size.name.fontSize), solveThemeValue(theme.font.size, $size.name.lineHeight));
});
var UserDescription = styled.div(templateObject_9$3 || (templateObject_9$3 = __makeTemplateObject(["\n  text-align: left;\n  font-family: ", ";\n  font-weight: ", ";\n  letter-spacing: 0px;\n  color: ", ";\n  margin-top: ", ";\n  ", "\n"], ["\n  text-align: left;\n  font-family: ", ";\n  font-weight: ", ";\n  letter-spacing: 0px;\n  color: ", ";\n  margin-top: ", ";\n  ", "\n"])), theme.font.family.regular, theme.font.weight.v_500, theme.color.gray_700, theme.margin.v_4, function (_a) {
    var $size = _a.$size;
    return css(templateObject_8$3 || (templateObject_8$3 = __makeTemplateObject(["\n    font-size: ", ";\n    line-height: ", ";\n  "], ["\n    font-size: ", ";\n    line-height: ", ";\n  "])), solveThemeValue(theme.font.size, $size.description.fontSize), solveThemeValue(theme.font.size, $size.description.lineHeight));
});
var templateObject_1$c, templateObject_2$a, templateObject_3$9, templateObject_4$9, templateObject_5$6, templateObject_6$4, templateObject_7$4, templateObject_8$3, templateObject_9$3;

var UserBadge = function (_a) {
    var description = _a.description, id = _a.id, icon = _a.icon, name = _a.name, size = _a.size, showUserInfo = _a.showUserInfo, color = _a.color;
    var themeContext = useContext(ThemeContext);
    var sizeVariant = useMemo(function () {
        return solveVariant(themeContext.userBadge.size, size, 'normal');
    }, [size]);
    return (React.createElement(ContainerUserBadge, { "data-testid": id },
        React.createElement(Avatar, { variant: color, "$size": sizeVariant }, icon
            ? React.createElement("img", { src: icon, alt: name || 'avatar' })
            : React.createElement("span", null, name ? getInitials(name) : 'AA')),
        showUserInfo && (React.createElement(ContainerUserInfo, null,
            name && (React.createElement(UserName, { "$size": sizeVariant }, name)),
            description && (React.createElement(UserDescription, { "$size": sizeVariant }, description))))));
};
UserBadge.defaultProps = {
    color: 'purple_800',
    size: 'normal',
    showUserInfo: true
};

var StyledText = styled('p')(templateObject_1$b || (templateObject_1$b = __makeTemplateObject(["\n  \n  ", "\n"], ["\n  \n  ", "\n"])), function (_a) {
    var size = _a.size, color = _a.color, family = _a.family, weight = _a.weight;
    return ({
        color: color && solveThemeValue(theme.color, color),
        fontFamily: family && solveThemeValue(theme.font.family, family),
        fontSize: size && solveThemeValue(theme.font.size, size),
        fontWeight: weight && solveThemeValue(theme.font.weight, weight)
    });
});
var templateObject_1$b;

var defaultProps = {
    family: 'regular',
    size: 'v_12',
    color: 'black',
    weight: 'v_100'
};
var Text = function (props) {
    return React.createElement(StyledText, __assign({}, props), props.children);
};
Text.defaultProps = defaultProps;

var Cnpj = function (_a) {
    var children = _a.children, id = _a.id;
    return React.createElement(NumberFormat, { format: CNPJ_MASK, displayType: 'text', "data-testid": id, value: children });
};

var Cpf = function (_a) {
    var children = _a.children, id = _a.id;
    return React.createElement(NumberFormat, { format: CPF_MASK, displayType: 'text', "data-testid": id, value: children });
};

var Real = function (_a) {
    var children = _a.children, id = _a.id;
    if (!children)
        children = '0';
    return React.createElement(NumberFormat, __assign({ displayType: 'text', value: parseFloat(children), "data-testid": id }, REAL_MASK));
};

var Phone = function (_a) {
    var children = _a.children, id = _a.id;
    var mask = children.length < 11 ? PHONE_MASK : CELLPHONE_MASK;
    return React.createElement(NumberFormat, { format: mask, displayType: 'text', "data-testid": id, value: children });
};

var NumberPC = function (_a) {
    var children = _a.children, id = _a.id, props = __rest(_a, ["children", "id"]);
    return React.createElement(NumberFormat, __assign({ displayType: 'text', value: children, "data-testid": id }, NUMBER_PUNCTUATION, props));
};
NumberPC.defaultProps = {
    decimalScale: 2
};

// these aren't really private, but nor are they really useful to document

/**
 * @private
 */
class LuxonError extends Error {}

/**
 * @private
 */
class InvalidDateTimeError extends LuxonError {
  constructor(reason) {
    super(`Invalid DateTime: ${reason.toMessage()}`);
  }
}

/**
 * @private
 */
class InvalidIntervalError extends LuxonError {
  constructor(reason) {
    super(`Invalid Interval: ${reason.toMessage()}`);
  }
}

/**
 * @private
 */
class InvalidDurationError extends LuxonError {
  constructor(reason) {
    super(`Invalid Duration: ${reason.toMessage()}`);
  }
}

/**
 * @private
 */
class ConflictingSpecificationError extends LuxonError {}

/**
 * @private
 */
class InvalidUnitError extends LuxonError {
  constructor(unit) {
    super(`Invalid unit ${unit}`);
  }
}

/**
 * @private
 */
class InvalidArgumentError extends LuxonError {}

/**
 * @private
 */
class ZoneIsAbstractError extends LuxonError {
  constructor() {
    super("Zone is an abstract class");
  }
}

/**
 * @private
 */

const n = "numeric",
  s = "short",
  l = "long";

const DATE_SHORT = {
  year: n,
  month: n,
  day: n,
};

const DATE_MED = {
  year: n,
  month: s,
  day: n,
};

const DATE_MED_WITH_WEEKDAY = {
  year: n,
  month: s,
  day: n,
  weekday: s,
};

const DATE_FULL = {
  year: n,
  month: l,
  day: n,
};

const DATE_HUGE = {
  year: n,
  month: l,
  day: n,
  weekday: l,
};

const TIME_SIMPLE = {
  hour: n,
  minute: n,
};

const TIME_WITH_SECONDS = {
  hour: n,
  minute: n,
  second: n,
};

const TIME_WITH_SHORT_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  timeZoneName: s,
};

const TIME_WITH_LONG_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  timeZoneName: l,
};

const TIME_24_SIMPLE = {
  hour: n,
  minute: n,
  hourCycle: "h23",
};

const TIME_24_WITH_SECONDS = {
  hour: n,
  minute: n,
  second: n,
  hourCycle: "h23",
};

const TIME_24_WITH_SHORT_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  hourCycle: "h23",
  timeZoneName: s,
};

const TIME_24_WITH_LONG_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  hourCycle: "h23",
  timeZoneName: l,
};

const DATETIME_SHORT = {
  year: n,
  month: n,
  day: n,
  hour: n,
  minute: n,
};

const DATETIME_SHORT_WITH_SECONDS = {
  year: n,
  month: n,
  day: n,
  hour: n,
  minute: n,
  second: n,
};

const DATETIME_MED = {
  year: n,
  month: s,
  day: n,
  hour: n,
  minute: n,
};

const DATETIME_MED_WITH_SECONDS = {
  year: n,
  month: s,
  day: n,
  hour: n,
  minute: n,
  second: n,
};

const DATETIME_MED_WITH_WEEKDAY = {
  year: n,
  month: s,
  day: n,
  weekday: s,
  hour: n,
  minute: n,
};

const DATETIME_FULL = {
  year: n,
  month: l,
  day: n,
  hour: n,
  minute: n,
  timeZoneName: s,
};

const DATETIME_FULL_WITH_SECONDS = {
  year: n,
  month: l,
  day: n,
  hour: n,
  minute: n,
  second: n,
  timeZoneName: s,
};

const DATETIME_HUGE = {
  year: n,
  month: l,
  day: n,
  weekday: l,
  hour: n,
  minute: n,
  timeZoneName: l,
};

const DATETIME_HUGE_WITH_SECONDS = {
  year: n,
  month: l,
  day: n,
  weekday: l,
  hour: n,
  minute: n,
  second: n,
  timeZoneName: l,
};

/*
  This is just a junk drawer, containing anything used across multiple classes.
  Because Luxon is small(ish), this should stay small and we won't worry about splitting
  it up into, say, parsingUtil.js and basicUtil.js and so on. But they are divided up by feature area.
*/

/**
 * @private
 */

// TYPES

function isUndefined(o) {
  return typeof o === "undefined";
}

function isNumber(o) {
  return typeof o === "number";
}

function isInteger(o) {
  return typeof o === "number" && o % 1 === 0;
}

function isString(o) {
  return typeof o === "string";
}

function isDate(o) {
  return Object.prototype.toString.call(o) === "[object Date]";
}

// CAPABILITIES

function hasRelative() {
  try {
    return typeof Intl !== "undefined" && !!Intl.RelativeTimeFormat;
  } catch (e) {
    return false;
  }
}

// OBJECTS AND ARRAYS

function maybeArray(thing) {
  return Array.isArray(thing) ? thing : [thing];
}

function bestBy(arr, by, compare) {
  if (arr.length === 0) {
    return undefined;
  }
  return arr.reduce((best, next) => {
    const pair = [by(next), next];
    if (!best) {
      return pair;
    } else if (compare(best[0], pair[0]) === best[0]) {
      return best;
    } else {
      return pair;
    }
  }, null)[1];
}

function pick(obj, keys) {
  return keys.reduce((a, k) => {
    a[k] = obj[k];
    return a;
  }, {});
}

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

// NUMBERS AND STRINGS

function integerBetween(thing, bottom, top) {
  return isInteger(thing) && thing >= bottom && thing <= top;
}

// x % n but takes the sign of n instead of x
function floorMod(x, n) {
  return x - n * Math.floor(x / n);
}

function padStart(input, n = 2) {
  const isNeg = input < 0;
  let padded;
  if (isNeg) {
    padded = "-" + ("" + -input).padStart(n, "0");
  } else {
    padded = ("" + input).padStart(n, "0");
  }
  return padded;
}

function parseInteger(string) {
  if (isUndefined(string) || string === null || string === "") {
    return undefined;
  } else {
    return parseInt(string, 10);
  }
}

function parseFloating(string) {
  if (isUndefined(string) || string === null || string === "") {
    return undefined;
  } else {
    return parseFloat(string);
  }
}

function parseMillis(fraction) {
  // Return undefined (instead of 0) in these cases, where fraction is not set
  if (isUndefined(fraction) || fraction === null || fraction === "") {
    return undefined;
  } else {
    const f = parseFloat("0." + fraction) * 1000;
    return Math.floor(f);
  }
}

function roundTo(number, digits, towardZero = false) {
  const factor = 10 ** digits,
    rounder = towardZero ? Math.trunc : Math.round;
  return rounder(number * factor) / factor;
}

// DATE BASICS

function isLeapYear(year) {
  return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}

function daysInYear(year) {
  return isLeapYear(year) ? 366 : 365;
}

function daysInMonth(year, month) {
  const modMonth = floorMod(month - 1, 12) + 1,
    modYear = year + (month - modMonth) / 12;

  if (modMonth === 2) {
    return isLeapYear(modYear) ? 29 : 28;
  } else {
    return [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][modMonth - 1];
  }
}

// covert a calendar object to a local timestamp (epoch, but with the offset baked in)
function objToLocalTS(obj) {
  let d = Date.UTC(
    obj.year,
    obj.month - 1,
    obj.day,
    obj.hour,
    obj.minute,
    obj.second,
    obj.millisecond
  );

  // for legacy reasons, years between 0 and 99 are interpreted as 19XX; revert that
  if (obj.year < 100 && obj.year >= 0) {
    d = new Date(d);
    d.setUTCFullYear(d.getUTCFullYear() - 1900);
  }
  return +d;
}

function weeksInWeekYear(weekYear) {
  const p1 =
      (weekYear +
        Math.floor(weekYear / 4) -
        Math.floor(weekYear / 100) +
        Math.floor(weekYear / 400)) %
      7,
    last = weekYear - 1,
    p2 = (last + Math.floor(last / 4) - Math.floor(last / 100) + Math.floor(last / 400)) % 7;
  return p1 === 4 || p2 === 3 ? 53 : 52;
}

function untruncateYear(year) {
  if (year > 99) {
    return year;
  } else return year > 60 ? 1900 + year : 2000 + year;
}

// PARSING

function parseZoneInfo(ts, offsetFormat, locale, timeZone = null) {
  const date = new Date(ts),
    intlOpts = {
      hourCycle: "h23",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    };

  if (timeZone) {
    intlOpts.timeZone = timeZone;
  }

  const modified = { timeZoneName: offsetFormat, ...intlOpts };

  const parsed = new Intl.DateTimeFormat(locale, modified)
    .formatToParts(date)
    .find((m) => m.type.toLowerCase() === "timezonename");
  return parsed ? parsed.value : null;
}

// signedOffset('-5', '30') -> -330
function signedOffset(offHourStr, offMinuteStr) {
  let offHour = parseInt(offHourStr, 10);

  // don't || this because we want to preserve -0
  if (Number.isNaN(offHour)) {
    offHour = 0;
  }

  const offMin = parseInt(offMinuteStr, 10) || 0,
    offMinSigned = offHour < 0 || Object.is(offHour, -0) ? -offMin : offMin;
  return offHour * 60 + offMinSigned;
}

// COERCION

function asNumber(value) {
  const numericValue = Number(value);
  if (typeof value === "boolean" || value === "" || Number.isNaN(numericValue))
    throw new InvalidArgumentError(`Invalid unit value ${value}`);
  return numericValue;
}

function normalizeObject(obj, normalizer) {
  const normalized = {};
  for (const u in obj) {
    if (hasOwnProperty(obj, u)) {
      const v = obj[u];
      if (v === undefined || v === null) continue;
      normalized[normalizer(u)] = asNumber(v);
    }
  }
  return normalized;
}

function formatOffset(offset, format) {
  const hours = Math.trunc(Math.abs(offset / 60)),
    minutes = Math.trunc(Math.abs(offset % 60)),
    sign = offset >= 0 ? "+" : "-";

  switch (format) {
    case "short":
      return `${sign}${padStart(hours, 2)}:${padStart(minutes, 2)}`;
    case "narrow":
      return `${sign}${hours}${minutes > 0 ? `:${minutes}` : ""}`;
    case "techie":
      return `${sign}${padStart(hours, 2)}${padStart(minutes, 2)}`;
    default:
      throw new RangeError(`Value format ${format} is out of range for property format`);
  }
}

function timeObject(obj) {
  return pick(obj, ["hour", "minute", "second", "millisecond"]);
}

const ianaRegex = /[A-Za-z_+-]{1,256}(:?\/[A-Za-z0-9_+-]{1,256}(\/[A-Za-z0-9_+-]{1,256})?)?/;

/**
 * @private
 */

const monthsLong = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const monthsShort = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const monthsNarrow = ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"];

function months(length) {
  switch (length) {
    case "narrow":
      return [...monthsNarrow];
    case "short":
      return [...monthsShort];
    case "long":
      return [...monthsLong];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
    case "2-digit":
      return ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    default:
      return null;
  }
}

const weekdaysLong = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

const weekdaysShort = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

const weekdaysNarrow = ["M", "T", "W", "T", "F", "S", "S"];

function weekdays(length) {
  switch (length) {
    case "narrow":
      return [...weekdaysNarrow];
    case "short":
      return [...weekdaysShort];
    case "long":
      return [...weekdaysLong];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7"];
    default:
      return null;
  }
}

const meridiems = ["AM", "PM"];

const erasLong = ["Before Christ", "Anno Domini"];

const erasShort = ["BC", "AD"];

const erasNarrow = ["B", "A"];

function eras(length) {
  switch (length) {
    case "narrow":
      return [...erasNarrow];
    case "short":
      return [...erasShort];
    case "long":
      return [...erasLong];
    default:
      return null;
  }
}

function meridiemForDateTime(dt) {
  return meridiems[dt.hour < 12 ? 0 : 1];
}

function weekdayForDateTime(dt, length) {
  return weekdays(length)[dt.weekday - 1];
}

function monthForDateTime(dt, length) {
  return months(length)[dt.month - 1];
}

function eraForDateTime(dt, length) {
  return eras(length)[dt.year < 0 ? 0 : 1];
}

function formatRelativeTime(unit, count, numeric = "always", narrow = false) {
  const units = {
    years: ["year", "yr."],
    quarters: ["quarter", "qtr."],
    months: ["month", "mo."],
    weeks: ["week", "wk."],
    days: ["day", "day", "days"],
    hours: ["hour", "hr."],
    minutes: ["minute", "min."],
    seconds: ["second", "sec."],
  };

  const lastable = ["hours", "minutes", "seconds"].indexOf(unit) === -1;

  if (numeric === "auto" && lastable) {
    const isDay = unit === "days";
    switch (count) {
      case 1:
        return isDay ? "tomorrow" : `next ${units[unit][0]}`;
      case -1:
        return isDay ? "yesterday" : `last ${units[unit][0]}`;
      case 0:
        return isDay ? "today" : `this ${units[unit][0]}`;
    }
  }

  const isInPast = Object.is(count, -0) || count < 0,
    fmtValue = Math.abs(count),
    singular = fmtValue === 1,
    lilUnits = units[unit],
    fmtUnit = narrow
      ? singular
        ? lilUnits[1]
        : lilUnits[2] || lilUnits[1]
      : singular
      ? units[unit][0]
      : unit;
  return isInPast ? `${fmtValue} ${fmtUnit} ago` : `in ${fmtValue} ${fmtUnit}`;
}

function stringifyTokens(splits, tokenToString) {
  let s = "";
  for (const token of splits) {
    if (token.literal) {
      s += token.val;
    } else {
      s += tokenToString(token.val);
    }
  }
  return s;
}

const macroTokenToFormatOpts = {
  D: DATE_SHORT,
  DD: DATE_MED,
  DDD: DATE_FULL,
  DDDD: DATE_HUGE,
  t: TIME_SIMPLE,
  tt: TIME_WITH_SECONDS,
  ttt: TIME_WITH_SHORT_OFFSET,
  tttt: TIME_WITH_LONG_OFFSET,
  T: TIME_24_SIMPLE,
  TT: TIME_24_WITH_SECONDS,
  TTT: TIME_24_WITH_SHORT_OFFSET,
  TTTT: TIME_24_WITH_LONG_OFFSET,
  f: DATETIME_SHORT,
  ff: DATETIME_MED,
  fff: DATETIME_FULL,
  ffff: DATETIME_HUGE,
  F: DATETIME_SHORT_WITH_SECONDS,
  FF: DATETIME_MED_WITH_SECONDS,
  FFF: DATETIME_FULL_WITH_SECONDS,
  FFFF: DATETIME_HUGE_WITH_SECONDS,
};

/**
 * @private
 */

class Formatter {
  static create(locale, opts = {}) {
    return new Formatter(locale, opts);
  }

  static parseFormat(fmt) {
    let current = null,
      currentFull = "",
      bracketed = false;
    const splits = [];
    for (let i = 0; i < fmt.length; i++) {
      const c = fmt.charAt(i);
      if (c === "'") {
        if (currentFull.length > 0) {
          splits.push({ literal: bracketed, val: currentFull });
        }
        current = null;
        currentFull = "";
        bracketed = !bracketed;
      } else if (bracketed) {
        currentFull += c;
      } else if (c === current) {
        currentFull += c;
      } else {
        if (currentFull.length > 0) {
          splits.push({ literal: false, val: currentFull });
        }
        currentFull = c;
        current = c;
      }
    }

    if (currentFull.length > 0) {
      splits.push({ literal: bracketed, val: currentFull });
    }

    return splits;
  }

  static macroTokenToFormatOpts(token) {
    return macroTokenToFormatOpts[token];
  }

  constructor(locale, formatOpts) {
    this.opts = formatOpts;
    this.loc = locale;
    this.systemLoc = null;
  }

  formatWithSystemDefault(dt, opts) {
    if (this.systemLoc === null) {
      this.systemLoc = this.loc.redefaultToSystem();
    }
    const df = this.systemLoc.dtFormatter(dt, { ...this.opts, ...opts });
    return df.format();
  }

  formatDateTime(dt, opts = {}) {
    const df = this.loc.dtFormatter(dt, { ...this.opts, ...opts });
    return df.format();
  }

  formatDateTimeParts(dt, opts = {}) {
    const df = this.loc.dtFormatter(dt, { ...this.opts, ...opts });
    return df.formatToParts();
  }

  resolvedOptions(dt, opts = {}) {
    const df = this.loc.dtFormatter(dt, { ...this.opts, ...opts });
    return df.resolvedOptions();
  }

  num(n, p = 0) {
    // we get some perf out of doing this here, annoyingly
    if (this.opts.forceSimple) {
      return padStart(n, p);
    }

    const opts = { ...this.opts };

    if (p > 0) {
      opts.padTo = p;
    }

    return this.loc.numberFormatter(opts).format(n);
  }

  formatDateTimeFromString(dt, fmt) {
    const knownEnglish = this.loc.listingMode() === "en",
      useDateTimeFormatter = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory",
      string = (opts, extract) => this.loc.extract(dt, opts, extract),
      formatOffset = (opts) => {
        if (dt.isOffsetFixed && dt.offset === 0 && opts.allowZ) {
          return "Z";
        }

        return dt.isValid ? dt.zone.formatOffset(dt.ts, opts.format) : "";
      },
      meridiem = () =>
        knownEnglish
          ? meridiemForDateTime(dt)
          : string({ hour: "numeric", hourCycle: "h12" }, "dayperiod"),
      month = (length, standalone) =>
        knownEnglish
          ? monthForDateTime(dt, length)
          : string(standalone ? { month: length } : { month: length, day: "numeric" }, "month"),
      weekday = (length, standalone) =>
        knownEnglish
          ? weekdayForDateTime(dt, length)
          : string(
              standalone ? { weekday: length } : { weekday: length, month: "long", day: "numeric" },
              "weekday"
            ),
      maybeMacro = (token) => {
        const formatOpts = Formatter.macroTokenToFormatOpts(token);
        if (formatOpts) {
          return this.formatWithSystemDefault(dt, formatOpts);
        } else {
          return token;
        }
      },
      era = (length) =>
        knownEnglish ? eraForDateTime(dt, length) : string({ era: length }, "era"),
      tokenToString = (token) => {
        // Where possible: http://cldr.unicode.org/translation/date-time-1/date-time#TOC-Standalone-vs.-Format-Styles
        switch (token) {
          // ms
          case "S":
            return this.num(dt.millisecond);
          case "u":
          // falls through
          case "SSS":
            return this.num(dt.millisecond, 3);
          // seconds
          case "s":
            return this.num(dt.second);
          case "ss":
            return this.num(dt.second, 2);
          // fractional seconds
          case "uu":
            return this.num(Math.floor(dt.millisecond / 10), 2);
          case "uuu":
            return this.num(Math.floor(dt.millisecond / 100));
          // minutes
          case "m":
            return this.num(dt.minute);
          case "mm":
            return this.num(dt.minute, 2);
          // hours
          case "h":
            return this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12);
          case "hh":
            return this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12, 2);
          case "H":
            return this.num(dt.hour);
          case "HH":
            return this.num(dt.hour, 2);
          // offset
          case "Z":
            // like +6
            return formatOffset({ format: "narrow", allowZ: this.opts.allowZ });
          case "ZZ":
            // like +06:00
            return formatOffset({ format: "short", allowZ: this.opts.allowZ });
          case "ZZZ":
            // like +0600
            return formatOffset({ format: "techie", allowZ: this.opts.allowZ });
          case "ZZZZ":
            // like EST
            return dt.zone.offsetName(dt.ts, { format: "short", locale: this.loc.locale });
          case "ZZZZZ":
            // like Eastern Standard Time
            return dt.zone.offsetName(dt.ts, { format: "long", locale: this.loc.locale });
          // zone
          case "z":
            // like America/New_York
            return dt.zoneName;
          // meridiems
          case "a":
            return meridiem();
          // dates
          case "d":
            return useDateTimeFormatter ? string({ day: "numeric" }, "day") : this.num(dt.day);
          case "dd":
            return useDateTimeFormatter ? string({ day: "2-digit" }, "day") : this.num(dt.day, 2);
          // weekdays - standalone
          case "c":
            // like 1
            return this.num(dt.weekday);
          case "ccc":
            // like 'Tues'
            return weekday("short", true);
          case "cccc":
            // like 'Tuesday'
            return weekday("long", true);
          case "ccccc":
            // like 'T'
            return weekday("narrow", true);
          // weekdays - format
          case "E":
            // like 1
            return this.num(dt.weekday);
          case "EEE":
            // like 'Tues'
            return weekday("short", false);
          case "EEEE":
            // like 'Tuesday'
            return weekday("long", false);
          case "EEEEE":
            // like 'T'
            return weekday("narrow", false);
          // months - standalone
          case "L":
            // like 1
            return useDateTimeFormatter
              ? string({ month: "numeric", day: "numeric" }, "month")
              : this.num(dt.month);
          case "LL":
            // like 01, doesn't seem to work
            return useDateTimeFormatter
              ? string({ month: "2-digit", day: "numeric" }, "month")
              : this.num(dt.month, 2);
          case "LLL":
            // like Jan
            return month("short", true);
          case "LLLL":
            // like January
            return month("long", true);
          case "LLLLL":
            // like J
            return month("narrow", true);
          // months - format
          case "M":
            // like 1
            return useDateTimeFormatter
              ? string({ month: "numeric" }, "month")
              : this.num(dt.month);
          case "MM":
            // like 01
            return useDateTimeFormatter
              ? string({ month: "2-digit" }, "month")
              : this.num(dt.month, 2);
          case "MMM":
            // like Jan
            return month("short", false);
          case "MMMM":
            // like January
            return month("long", false);
          case "MMMMM":
            // like J
            return month("narrow", false);
          // years
          case "y":
            // like 2014
            return useDateTimeFormatter ? string({ year: "numeric" }, "year") : this.num(dt.year);
          case "yy":
            // like 14
            return useDateTimeFormatter
              ? string({ year: "2-digit" }, "year")
              : this.num(dt.year.toString().slice(-2), 2);
          case "yyyy":
            // like 0012
            return useDateTimeFormatter
              ? string({ year: "numeric" }, "year")
              : this.num(dt.year, 4);
          case "yyyyyy":
            // like 000012
            return useDateTimeFormatter
              ? string({ year: "numeric" }, "year")
              : this.num(dt.year, 6);
          // eras
          case "G":
            // like AD
            return era("short");
          case "GG":
            // like Anno Domini
            return era("long");
          case "GGGGG":
            return era("narrow");
          case "kk":
            return this.num(dt.weekYear.toString().slice(-2), 2);
          case "kkkk":
            return this.num(dt.weekYear, 4);
          case "W":
            return this.num(dt.weekNumber);
          case "WW":
            return this.num(dt.weekNumber, 2);
          case "o":
            return this.num(dt.ordinal);
          case "ooo":
            return this.num(dt.ordinal, 3);
          case "q":
            // like 1
            return this.num(dt.quarter);
          case "qq":
            // like 01
            return this.num(dt.quarter, 2);
          case "X":
            return this.num(Math.floor(dt.ts / 1000));
          case "x":
            return this.num(dt.ts);
          default:
            return maybeMacro(token);
        }
      };

    return stringifyTokens(Formatter.parseFormat(fmt), tokenToString);
  }

  formatDurationFromString(dur, fmt) {
    const tokenToField = (token) => {
        switch (token[0]) {
          case "S":
            return "millisecond";
          case "s":
            return "second";
          case "m":
            return "minute";
          case "h":
            return "hour";
          case "d":
            return "day";
          case "M":
            return "month";
          case "y":
            return "year";
          default:
            return null;
        }
      },
      tokenToString = (lildur) => (token) => {
        const mapped = tokenToField(token);
        if (mapped) {
          return this.num(lildur.get(mapped), token.length);
        } else {
          return token;
        }
      },
      tokens = Formatter.parseFormat(fmt),
      realTokens = tokens.reduce(
        (found, { literal, val }) => (literal ? found : found.concat(val)),
        []
      ),
      collapsed = dur.shiftTo(...realTokens.map(tokenToField).filter((t) => t));
    return stringifyTokens(tokens, tokenToString(collapsed));
  }
}

class Invalid {
  constructor(reason, explanation) {
    this.reason = reason;
    this.explanation = explanation;
  }

  toMessage() {
    if (this.explanation) {
      return `${this.reason}: ${this.explanation}`;
    } else {
      return this.reason;
    }
  }
}

/**
 * @interface
 */
class Zone {
  /**
   * The type of zone
   * @abstract
   * @type {string}
   */
  get type() {
    throw new ZoneIsAbstractError();
  }

  /**
   * The name of this zone.
   * @abstract
   * @type {string}
   */
  get name() {
    throw new ZoneIsAbstractError();
  }

  /**
   * Returns whether the offset is known to be fixed for the whole year.
   * @abstract
   * @type {boolean}
   */
  get isUniversal() {
    throw new ZoneIsAbstractError();
  }

  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(ts, opts) {
    throw new ZoneIsAbstractError();
  }

  /**
   * Returns the offset's value as a string
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(ts, format) {
    throw new ZoneIsAbstractError();
  }

  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(ts) {
    throw new ZoneIsAbstractError();
  }

  /**
   * Return whether this Zone is equal to another zone
   * @abstract
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(otherZone) {
    throw new ZoneIsAbstractError();
  }

  /**
   * Return whether this Zone is valid.
   * @abstract
   * @type {boolean}
   */
  get isValid() {
    throw new ZoneIsAbstractError();
  }
}

let singleton$1 = null;

/**
 * Represents the local zone for this JavaScript environment.
 * @implements {Zone}
 */
class SystemZone extends Zone {
  /**
   * Get a singleton instance of the local zone
   * @return {SystemZone}
   */
  static get instance() {
    if (singleton$1 === null) {
      singleton$1 = new SystemZone();
    }
    return singleton$1;
  }

  /** @override **/
  get type() {
    return "system";
  }

  /** @override **/
  get name() {
    return new Intl.DateTimeFormat().resolvedOptions().timeZone;
  }

  /** @override **/
  get isUniversal() {
    return false;
  }

  /** @override **/
  offsetName(ts, { format, locale }) {
    return parseZoneInfo(ts, format, locale);
  }

  /** @override **/
  formatOffset(ts, format) {
    return formatOffset(this.offset(ts), format);
  }

  /** @override **/
  offset(ts) {
    return -new Date(ts).getTimezoneOffset();
  }

  /** @override **/
  equals(otherZone) {
    return otherZone.type === "system";
  }

  /** @override **/
  get isValid() {
    return true;
  }
}

const matchingRegex = RegExp(`^${ianaRegex.source}$`);

let dtfCache = {};
function makeDTF(zone) {
  if (!dtfCache[zone]) {
    dtfCache[zone] = new Intl.DateTimeFormat("en-US", {
      hour12: false,
      timeZone: zone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  }
  return dtfCache[zone];
}

const typeToPos = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5,
};

function hackyOffset(dtf, date) {
  const formatted = dtf.format(date).replace(/\u200E/g, ""),
    parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted),
    [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed;
  return [fYear, fMonth, fDay, fHour, fMinute, fSecond];
}

function partsOffset(dtf, date) {
  const formatted = dtf.formatToParts(date),
    filled = [];
  for (let i = 0; i < formatted.length; i++) {
    const { type, value } = formatted[i],
      pos = typeToPos[type];

    if (!isUndefined(pos)) {
      filled[pos] = parseInt(value, 10);
    }
  }
  return filled;
}

let ianaZoneCache = {};
/**
 * A zone identified by an IANA identifier, like America/New_York
 * @implements {Zone}
 */
class IANAZone extends Zone {
  /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */
  static create(name) {
    if (!ianaZoneCache[name]) {
      ianaZoneCache[name] = new IANAZone(name);
    }
    return ianaZoneCache[name];
  }

  /**
   * Reset local caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCache() {
    ianaZoneCache = {};
    dtfCache = {};
  }

  /**
   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
   * @param {string} s - The string to check validity on
   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
   * @example IANAZone.isValidSpecifier("Fantasia/Castle") //=> true
   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
   * @return {boolean}
   */
  static isValidSpecifier(s) {
    return !!(s && s.match(matchingRegex));
  }

  /**
   * Returns whether the provided string identifies a real zone
   * @param {string} zone - The string to check
   * @example IANAZone.isValidZone("America/New_York") //=> true
   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
   * @return {boolean}
   */
  static isValidZone(zone) {
    if (!zone) {
      return false;
    }
    try {
      new Intl.DateTimeFormat("en-US", { timeZone: zone }).format();
      return true;
    } catch (e) {
      return false;
    }
  }

  constructor(name) {
    super();
    /** @private **/
    this.zoneName = name;
    /** @private **/
    this.valid = IANAZone.isValidZone(name);
  }

  /** @override **/
  get type() {
    return "iana";
  }

  /** @override **/
  get name() {
    return this.zoneName;
  }

  /** @override **/
  get isUniversal() {
    return false;
  }

  /** @override **/
  offsetName(ts, { format, locale }) {
    return parseZoneInfo(ts, format, locale, this.name);
  }

  /** @override **/
  formatOffset(ts, format) {
    return formatOffset(this.offset(ts), format);
  }

  /** @override **/
  offset(ts) {
    const date = new Date(ts);

    if (isNaN(date)) return NaN;

    const dtf = makeDTF(this.name),
      [year, month, day, hour, minute, second] = dtf.formatToParts
        ? partsOffset(dtf, date)
        : hackyOffset(dtf, date);

    // because we're using hour12 and https://bugs.chromium.org/p/chromium/issues/detail?id=1025564&can=2&q=%2224%3A00%22%20datetimeformat
    const adjustedHour = hour === 24 ? 0 : hour;

    const asUTC = objToLocalTS({
      year,
      month,
      day,
      hour: adjustedHour,
      minute,
      second,
      millisecond: 0,
    });

    let asTS = +date;
    const over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return (asUTC - asTS) / (60 * 1000);
  }

  /** @override **/
  equals(otherZone) {
    return otherZone.type === "iana" && otherZone.name === this.name;
  }

  /** @override **/
  get isValid() {
    return this.valid;
  }
}

let singleton = null;

/**
 * A zone with a fixed offset (meaning no DST)
 * @implements {Zone}
 */
class FixedOffsetZone extends Zone {
  /**
   * Get a singleton instance of UTC
   * @return {FixedOffsetZone}
   */
  static get utcInstance() {
    if (singleton === null) {
      singleton = new FixedOffsetZone(0);
    }
    return singleton;
  }

  /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */
  static instance(offset) {
    return offset === 0 ? FixedOffsetZone.utcInstance : new FixedOffsetZone(offset);
  }

  /**
   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
   * @param {string} s - The offset string to parse
   * @example FixedOffsetZone.parseSpecifier("UTC+6")
   * @example FixedOffsetZone.parseSpecifier("UTC+06")
   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
   * @return {FixedOffsetZone}
   */
  static parseSpecifier(s) {
    if (s) {
      const r = s.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
      if (r) {
        return new FixedOffsetZone(signedOffset(r[1], r[2]));
      }
    }
    return null;
  }

  constructor(offset) {
    super();
    /** @private **/
    this.fixed = offset;
  }

  /** @override **/
  get type() {
    return "fixed";
  }

  /** @override **/
  get name() {
    return this.fixed === 0 ? "UTC" : `UTC${formatOffset(this.fixed, "narrow")}`;
  }

  /** @override **/
  offsetName() {
    return this.name;
  }

  /** @override **/
  formatOffset(ts, format) {
    return formatOffset(this.fixed, format);
  }

  /** @override **/
  get isUniversal() {
    return true;
  }

  /** @override **/
  offset() {
    return this.fixed;
  }

  /** @override **/
  equals(otherZone) {
    return otherZone.type === "fixed" && otherZone.fixed === this.fixed;
  }

  /** @override **/
  get isValid() {
    return true;
  }
}

/**
 * A zone that failed to parse. You should never need to instantiate this.
 * @implements {Zone}
 */
class InvalidZone extends Zone {
  constructor(zoneName) {
    super();
    /**  @private */
    this.zoneName = zoneName;
  }

  /** @override **/
  get type() {
    return "invalid";
  }

  /** @override **/
  get name() {
    return this.zoneName;
  }

  /** @override **/
  get isUniversal() {
    return false;
  }

  /** @override **/
  offsetName() {
    return null;
  }

  /** @override **/
  formatOffset() {
    return "";
  }

  /** @override **/
  offset() {
    return NaN;
  }

  /** @override **/
  equals() {
    return false;
  }

  /** @override **/
  get isValid() {
    return false;
  }
}

/**
 * @private
 */

function normalizeZone(input, defaultZone) {
  if (isUndefined(input) || input === null) {
    return defaultZone;
  } else if (input instanceof Zone) {
    return input;
  } else if (isString(input)) {
    const lowered = input.toLowerCase();
    if (lowered === "local" || lowered === "system") return defaultZone;
    else if (lowered === "utc" || lowered === "gmt") return FixedOffsetZone.utcInstance;
    else if (IANAZone.isValidSpecifier(lowered)) return IANAZone.create(input);
    else return FixedOffsetZone.parseSpecifier(lowered) || new InvalidZone(input);
  } else if (isNumber(input)) {
    return FixedOffsetZone.instance(input);
  } else if (typeof input === "object" && input.offset && typeof input.offset === "number") {
    // This is dumb, but the instanceof check above doesn't seem to really work
    // so we're duck checking it
    return input;
  } else {
    return new InvalidZone(input);
  }
}

let now = () => Date.now(),
  defaultZone = "system",
  defaultLocale = null,
  defaultNumberingSystem = null,
  defaultOutputCalendar = null,
  throwOnInvalid;

/**
 * Settings contains static getters and setters that control Luxon's overall behavior. Luxon is a simple library with few options, but the ones it does have live here.
 */
class Settings {
  /**
   * Get the callback for returning the current timestamp.
   * @type {function}
   */
  static get now() {
    return now;
  }

  /**
   * Set the callback for returning the current timestamp.
   * The function should return a number, which will be interpreted as an Epoch millisecond count
   * @type {function}
   * @example Settings.now = () => Date.now() + 3000 // pretend it is 3 seconds in the future
   * @example Settings.now = () => 0 // always pretend it's Jan 1, 1970 at midnight in UTC time
   */
  static set now(n) {
    now = n;
  }

  /**
   * Set the default time zone to create DateTimes in. Does not affect existing instances.
   * Use the value "system" to reset this value to the system's time zone.
   * @type {string}
   */
  static set defaultZone(zone) {
    defaultZone = zone;
  }

  /**
   * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
   * The default value is the system's time zone (the one set on the machine that runs this code).
   * @type {Zone}
   */
  static get defaultZone() {
    return normalizeZone(defaultZone, SystemZone.instance);
  }

  /**
   * Get the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultLocale() {
    return defaultLocale;
  }

  /**
   * Set the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultLocale(locale) {
    defaultLocale = locale;
  }

  /**
   * Get the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultNumberingSystem() {
    return defaultNumberingSystem;
  }

  /**
   * Set the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultNumberingSystem(numberingSystem) {
    defaultNumberingSystem = numberingSystem;
  }

  /**
   * Get the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultOutputCalendar() {
    return defaultOutputCalendar;
  }

  /**
   * Set the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultOutputCalendar(outputCalendar) {
    defaultOutputCalendar = outputCalendar;
  }

  /**
   * Get whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static get throwOnInvalid() {
    return throwOnInvalid;
  }

  /**
   * Set whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static set throwOnInvalid(t) {
    throwOnInvalid = t;
  }

  /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCaches() {
    Locale.resetCache();
    IANAZone.resetCache();
  }
}

// todo - remap caching

let intlLFCache = {};
function getCachedLF(locString, opts = {}) {
  const key = JSON.stringify([locString, opts]);
  let dtf = intlLFCache[key];
  if (!dtf) {
    dtf = new Intl.ListFormat(locString, opts);
    intlLFCache[key] = dtf;
  }
  return dtf;
}

let intlDTCache = {};
function getCachedDTF(locString, opts = {}) {
  const key = JSON.stringify([locString, opts]);
  let dtf = intlDTCache[key];
  if (!dtf) {
    dtf = new Intl.DateTimeFormat(locString, opts);
    intlDTCache[key] = dtf;
  }
  return dtf;
}

let intlNumCache = {};
function getCachedINF(locString, opts = {}) {
  const key = JSON.stringify([locString, opts]);
  let inf = intlNumCache[key];
  if (!inf) {
    inf = new Intl.NumberFormat(locString, opts);
    intlNumCache[key] = inf;
  }
  return inf;
}

let intlRelCache = {};
function getCachedRTF(locString, opts = {}) {
  const { base, ...cacheKeyOpts } = opts; // exclude `base` from the options
  const key = JSON.stringify([locString, cacheKeyOpts]);
  let inf = intlRelCache[key];
  if (!inf) {
    inf = new Intl.RelativeTimeFormat(locString, opts);
    intlRelCache[key] = inf;
  }
  return inf;
}

let sysLocaleCache = null;
function systemLocale() {
  if (sysLocaleCache) {
    return sysLocaleCache;
  } else {
    sysLocaleCache = new Intl.DateTimeFormat().resolvedOptions().locale;
    return sysLocaleCache;
  }
}

function parseLocaleString(localeStr) {
  // I really want to avoid writing a BCP 47 parser
  // see, e.g. https://github.com/wooorm/bcp-47
  // Instead, we'll do this:

  // a) if the string has no -u extensions, just leave it alone
  // b) if it does, use Intl to resolve everything
  // c) if Intl fails, try again without the -u

  const uIndex = localeStr.indexOf("-u-");
  if (uIndex === -1) {
    return [localeStr];
  } else {
    let options;
    const smaller = localeStr.substring(0, uIndex);
    try {
      options = getCachedDTF(localeStr).resolvedOptions();
    } catch (e) {
      options = getCachedDTF(smaller).resolvedOptions();
    }

    const { numberingSystem, calendar } = options;
    // return the smaller one so that we can append the calendar and numbering overrides to it
    return [smaller, numberingSystem, calendar];
  }
}

function intlConfigString(localeStr, numberingSystem, outputCalendar) {
  if (outputCalendar || numberingSystem) {
    localeStr += "-u";

    if (outputCalendar) {
      localeStr += `-ca-${outputCalendar}`;
    }

    if (numberingSystem) {
      localeStr += `-nu-${numberingSystem}`;
    }
    return localeStr;
  } else {
    return localeStr;
  }
}

function mapMonths(f) {
  const ms = [];
  for (let i = 1; i <= 12; i++) {
    const dt = DateTime.utc(2016, i, 1);
    ms.push(f(dt));
  }
  return ms;
}

function mapWeekdays(f) {
  const ms = [];
  for (let i = 1; i <= 7; i++) {
    const dt = DateTime.utc(2016, 11, 13 + i);
    ms.push(f(dt));
  }
  return ms;
}

function listStuff(loc, length, defaultOK, englishFn, intlFn) {
  const mode = loc.listingMode(defaultOK);

  if (mode === "error") {
    return null;
  } else if (mode === "en") {
    return englishFn(length);
  } else {
    return intlFn(length);
  }
}

function supportsFastNumbers(loc) {
  if (loc.numberingSystem && loc.numberingSystem !== "latn") {
    return false;
  } else {
    return (
      loc.numberingSystem === "latn" ||
      !loc.locale ||
      loc.locale.startsWith("en") ||
      new Intl.DateTimeFormat(loc.intl).resolvedOptions().numberingSystem === "latn"
    );
  }
}

/**
 * @private
 */

class PolyNumberFormatter {
  constructor(intl, forceSimple, opts) {
    this.padTo = opts.padTo || 0;
    this.floor = opts.floor || false;

    const { padTo, floor, ...otherOpts } = opts;

    if (!forceSimple || Object.keys(otherOpts).length > 0) {
      const intlOpts = { useGrouping: false, ...opts };
      if (opts.padTo > 0) intlOpts.minimumIntegerDigits = opts.padTo;
      this.inf = getCachedINF(intl, intlOpts);
    }
  }

  format(i) {
    if (this.inf) {
      const fixed = this.floor ? Math.floor(i) : i;
      return this.inf.format(fixed);
    } else {
      // to match the browser's numberformatter defaults
      const fixed = this.floor ? Math.floor(i) : roundTo(i, 3);
      return padStart(fixed, this.padTo);
    }
  }
}

/**
 * @private
 */

class PolyDateFormatter {
  constructor(dt, intl, opts) {
    this.opts = opts;

    let z;
    if (dt.zone.isUniversal) {
      // UTC-8 or Etc/UTC-8 are not part of tzdata, only Etc/GMT+8 and the like.
      // That is why fixed-offset TZ is set to that unless it is:
      // 1. Representing offset 0 when UTC is used to maintain previous behavior and does not become GMT.
      // 2. Unsupported by the browser:
      //    - some do not support Etc/
      //    - < Etc/GMT-14, > Etc/GMT+12, and 30-minute or 45-minute offsets are not part of tzdata
      const gmtOffset = -1 * (dt.offset / 60);
      const offsetZ = gmtOffset >= 0 ? `Etc/GMT+${gmtOffset}` : `Etc/GMT${gmtOffset}`;
      if (dt.offset !== 0 && IANAZone.create(offsetZ).valid) {
        z = offsetZ;
        this.dt = dt;
      } else {
        // Not all fixed-offset zones like Etc/+4:30 are present in tzdata.
        // So we have to make do. Two cases:
        // 1. The format options tell us to show the zone. We can't do that, so the best
        // we can do is format the date in UTC.
        // 2. The format options don't tell us to show the zone. Then we can adjust them
        // the time and tell the formatter to show it to us in UTC, so that the time is right
        // and the bad zone doesn't show up.
        z = "UTC";
        if (opts.timeZoneName) {
          this.dt = dt;
        } else {
          this.dt = dt.offset === 0 ? dt : DateTime.fromMillis(dt.ts + dt.offset * 60 * 1000);
        }
      }
    } else if (dt.zone.type === "system") {
      this.dt = dt;
    } else {
      this.dt = dt;
      z = dt.zone.name;
    }

    const intlOpts = { ...this.opts };
    if (z) {
      intlOpts.timeZone = z;
    }
    this.dtf = getCachedDTF(intl, intlOpts);
  }

  format() {
    return this.dtf.format(this.dt.toJSDate());
  }

  formatToParts() {
    return this.dtf.formatToParts(this.dt.toJSDate());
  }

  resolvedOptions() {
    return this.dtf.resolvedOptions();
  }
}

/**
 * @private
 */
class PolyRelFormatter {
  constructor(intl, isEnglish, opts) {
    this.opts = { style: "long", ...opts };
    if (!isEnglish && hasRelative()) {
      this.rtf = getCachedRTF(intl, opts);
    }
  }

  format(count, unit) {
    if (this.rtf) {
      return this.rtf.format(count, unit);
    } else {
      return formatRelativeTime(unit, count, this.opts.numeric, this.opts.style !== "long");
    }
  }

  formatToParts(count, unit) {
    if (this.rtf) {
      return this.rtf.formatToParts(count, unit);
    } else {
      return [];
    }
  }
}

/**
 * @private
 */

class Locale {
  static fromOpts(opts) {
    return Locale.create(opts.locale, opts.numberingSystem, opts.outputCalendar, opts.defaultToEN);
  }

  static create(locale, numberingSystem, outputCalendar, defaultToEN = false) {
    const specifiedLocale = locale || Settings.defaultLocale;
    // the system locale is useful for human readable strings but annoying for parsing/formatting known formats
    const localeR = specifiedLocale || (defaultToEN ? "en-US" : systemLocale());
    const numberingSystemR = numberingSystem || Settings.defaultNumberingSystem;
    const outputCalendarR = outputCalendar || Settings.defaultOutputCalendar;
    return new Locale(localeR, numberingSystemR, outputCalendarR, specifiedLocale);
  }

  static resetCache() {
    sysLocaleCache = null;
    intlDTCache = {};
    intlNumCache = {};
    intlRelCache = {};
  }

  static fromObject({ locale, numberingSystem, outputCalendar } = {}) {
    return Locale.create(locale, numberingSystem, outputCalendar);
  }

  constructor(locale, numbering, outputCalendar, specifiedLocale) {
    const [parsedLocale, parsedNumberingSystem, parsedOutputCalendar] = parseLocaleString(locale);

    this.locale = parsedLocale;
    this.numberingSystem = numbering || parsedNumberingSystem || null;
    this.outputCalendar = outputCalendar || parsedOutputCalendar || null;
    this.intl = intlConfigString(this.locale, this.numberingSystem, this.outputCalendar);

    this.weekdaysCache = { format: {}, standalone: {} };
    this.monthsCache = { format: {}, standalone: {} };
    this.meridiemCache = null;
    this.eraCache = {};

    this.specifiedLocale = specifiedLocale;
    this.fastNumbersCached = null;
  }

  get fastNumbers() {
    if (this.fastNumbersCached == null) {
      this.fastNumbersCached = supportsFastNumbers(this);
    }

    return this.fastNumbersCached;
  }

  listingMode() {
    const isActuallyEn = this.isEnglish();
    const hasNoWeirdness =
      (this.numberingSystem === null || this.numberingSystem === "latn") &&
      (this.outputCalendar === null || this.outputCalendar === "gregory");
    return isActuallyEn && hasNoWeirdness ? "en" : "intl";
  }

  clone(alts) {
    if (!alts || Object.getOwnPropertyNames(alts).length === 0) {
      return this;
    } else {
      return Locale.create(
        alts.locale || this.specifiedLocale,
        alts.numberingSystem || this.numberingSystem,
        alts.outputCalendar || this.outputCalendar,
        alts.defaultToEN || false
      );
    }
  }

  redefaultToEN(alts = {}) {
    return this.clone({ ...alts, defaultToEN: true });
  }

  redefaultToSystem(alts = {}) {
    return this.clone({ ...alts, defaultToEN: false });
  }

  months(length, format = false, defaultOK = true) {
    return listStuff(this, length, defaultOK, months, () => {
      const intl = format ? { month: length, day: "numeric" } : { month: length },
        formatStr = format ? "format" : "standalone";
      if (!this.monthsCache[formatStr][length]) {
        this.monthsCache[formatStr][length] = mapMonths((dt) => this.extract(dt, intl, "month"));
      }
      return this.monthsCache[formatStr][length];
    });
  }

  weekdays(length, format = false, defaultOK = true) {
    return listStuff(this, length, defaultOK, weekdays, () => {
      const intl = format
          ? { weekday: length, year: "numeric", month: "long", day: "numeric" }
          : { weekday: length },
        formatStr = format ? "format" : "standalone";
      if (!this.weekdaysCache[formatStr][length]) {
        this.weekdaysCache[formatStr][length] = mapWeekdays((dt) =>
          this.extract(dt, intl, "weekday")
        );
      }
      return this.weekdaysCache[formatStr][length];
    });
  }

  meridiems(defaultOK = true) {
    return listStuff(
      this,
      undefined,
      defaultOK,
      () => meridiems,
      () => {
        // In theory there could be aribitrary day periods. We're gonna assume there are exactly two
        // for AM and PM. This is probably wrong, but it's makes parsing way easier.
        if (!this.meridiemCache) {
          const intl = { hour: "numeric", hourCycle: "h12" };
          this.meridiemCache = [DateTime.utc(2016, 11, 13, 9), DateTime.utc(2016, 11, 13, 19)].map(
            (dt) => this.extract(dt, intl, "dayperiod")
          );
        }

        return this.meridiemCache;
      }
    );
  }

  eras(length, defaultOK = true) {
    return listStuff(this, length, defaultOK, eras, () => {
      const intl = { era: length };

      // This is problematic. Different calendars are going to define eras totally differently. What I need is the minimum set of dates
      // to definitely enumerate them.
      if (!this.eraCache[length]) {
        this.eraCache[length] = [DateTime.utc(-40, 1, 1), DateTime.utc(2017, 1, 1)].map((dt) =>
          this.extract(dt, intl, "era")
        );
      }

      return this.eraCache[length];
    });
  }

  extract(dt, intlOpts, field) {
    const df = this.dtFormatter(dt, intlOpts),
      results = df.formatToParts(),
      matching = results.find((m) => m.type.toLowerCase() === field);
    return matching ? matching.value : null;
  }

  numberFormatter(opts = {}) {
    // this forcesimple option is never used (the only caller short-circuits on it, but it seems safer to leave)
    // (in contrast, the rest of the condition is used heavily)
    return new PolyNumberFormatter(this.intl, opts.forceSimple || this.fastNumbers, opts);
  }

  dtFormatter(dt, intlOpts = {}) {
    return new PolyDateFormatter(dt, this.intl, intlOpts);
  }

  relFormatter(opts = {}) {
    return new PolyRelFormatter(this.intl, this.isEnglish(), opts);
  }

  listFormatter(opts = {}) {
    return getCachedLF(this.intl, opts);
  }

  isEnglish() {
    return (
      this.locale === "en" ||
      this.locale.toLowerCase() === "en-us" ||
      new Intl.DateTimeFormat(this.intl).resolvedOptions().locale.startsWith("en-us")
    );
  }

  equals(other) {
    return (
      this.locale === other.locale &&
      this.numberingSystem === other.numberingSystem &&
      this.outputCalendar === other.outputCalendar
    );
  }
}

/*
 * This file handles parsing for well-specified formats. Here's how it works:
 * Two things go into parsing: a regex to match with and an extractor to take apart the groups in the match.
 * An extractor is just a function that takes a regex match array and returns a { year: ..., month: ... } object
 * parse() does the work of executing the regex and applying the extractor. It takes multiple regex/extractor pairs to try in sequence.
 * Extractors can take a "cursor" representing the offset in the match to look at. This makes it easy to combine extractors.
 * combineExtractors() does the work of combining them, keeping track of the cursor through multiple extractions.
 * Some extractions are super dumb and simpleParse and fromStrings help DRY them.
 */

function combineRegexes(...regexes) {
  const full = regexes.reduce((f, r) => f + r.source, "");
  return RegExp(`^${full}$`);
}

function combineExtractors(...extractors) {
  return (m) =>
    extractors
      .reduce(
        ([mergedVals, mergedZone, cursor], ex) => {
          const [val, zone, next] = ex(m, cursor);
          return [{ ...mergedVals, ...val }, mergedZone || zone, next];
        },
        [{}, null, 1]
      )
      .slice(0, 2);
}

function parse(s, ...patterns) {
  if (s == null) {
    return [null, null];
  }

  for (const [regex, extractor] of patterns) {
    const m = regex.exec(s);
    if (m) {
      return extractor(m);
    }
  }
  return [null, null];
}

function simpleParse(...keys) {
  return (match, cursor) => {
    const ret = {};
    let i;

    for (i = 0; i < keys.length; i++) {
      ret[keys[i]] = parseInteger(match[cursor + i]);
    }
    return [ret, null, cursor + i];
  };
}

// ISO and SQL parsing
const offsetRegex = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/,
  isoTimeBaseRegex = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/,
  isoTimeRegex = RegExp(`${isoTimeBaseRegex.source}${offsetRegex.source}?`),
  isoTimeExtensionRegex = RegExp(`(?:T${isoTimeRegex.source})?`),
  isoYmdRegex = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/,
  isoWeekRegex = /(\d{4})-?W(\d\d)(?:-?(\d))?/,
  isoOrdinalRegex = /(\d{4})-?(\d{3})/,
  extractISOWeekData = simpleParse("weekYear", "weekNumber", "weekDay"),
  extractISOOrdinalData = simpleParse("year", "ordinal"),
  sqlYmdRegex = /(\d{4})-(\d\d)-(\d\d)/, // dumbed-down version of the ISO one
  sqlTimeRegex = RegExp(
    `${isoTimeBaseRegex.source} ?(?:${offsetRegex.source}|(${ianaRegex.source}))?`
  ),
  sqlTimeExtensionRegex = RegExp(`(?: ${sqlTimeRegex.source})?`);

function int(match, pos, fallback) {
  const m = match[pos];
  return isUndefined(m) ? fallback : parseInteger(m);
}

function extractISOYmd(match, cursor) {
  const item = {
    year: int(match, cursor),
    month: int(match, cursor + 1, 1),
    day: int(match, cursor + 2, 1),
  };

  return [item, null, cursor + 3];
}

function extractISOTime(match, cursor) {
  const item = {
    hours: int(match, cursor, 0),
    minutes: int(match, cursor + 1, 0),
    seconds: int(match, cursor + 2, 0),
    milliseconds: parseMillis(match[cursor + 3]),
  };

  return [item, null, cursor + 4];
}

function extractISOOffset(match, cursor) {
  const local = !match[cursor] && !match[cursor + 1],
    fullOffset = signedOffset(match[cursor + 1], match[cursor + 2]),
    zone = local ? null : FixedOffsetZone.instance(fullOffset);
  return [{}, zone, cursor + 3];
}

function extractIANAZone(match, cursor) {
  const zone = match[cursor] ? IANAZone.create(match[cursor]) : null;
  return [{}, zone, cursor + 1];
}

// ISO time parsing

const isoTimeOnly = RegExp(`^T?${isoTimeBaseRegex.source}$`);

// ISO duration parsing

const isoDuration =
  /^-?P(?:(?:(-?\d{1,9}(?:\.\d{1,9})?)Y)?(?:(-?\d{1,9}(?:\.\d{1,9})?)M)?(?:(-?\d{1,9}(?:\.\d{1,9})?)W)?(?:(-?\d{1,9}(?:\.\d{1,9})?)D)?(?:T(?:(-?\d{1,9}(?:\.\d{1,9})?)H)?(?:(-?\d{1,9}(?:\.\d{1,9})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,9}))?S)?)?)$/;

function extractISODuration(match) {
  const [s, yearStr, monthStr, weekStr, dayStr, hourStr, minuteStr, secondStr, millisecondsStr] =
    match;

  const hasNegativePrefix = s[0] === "-";
  const negativeSeconds = secondStr && secondStr[0] === "-";

  const maybeNegate = (num, force = false) =>
    num !== undefined && (force || (num && hasNegativePrefix)) ? -num : num;

  return [
    {
      years: maybeNegate(parseFloating(yearStr)),
      months: maybeNegate(parseFloating(monthStr)),
      weeks: maybeNegate(parseFloating(weekStr)),
      days: maybeNegate(parseFloating(dayStr)),
      hours: maybeNegate(parseFloating(hourStr)),
      minutes: maybeNegate(parseFloating(minuteStr)),
      seconds: maybeNegate(parseFloating(secondStr), secondStr === "-0"),
      milliseconds: maybeNegate(parseMillis(millisecondsStr), negativeSeconds),
    },
  ];
}

// These are a little braindead. EDT *should* tell us that we're in, say, America/New_York
// and not just that we're in -240 *right now*. But since I don't think these are used that often
// I'm just going to ignore that
const obsOffsets = {
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60,
};

function fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
  const result = {
    year: yearStr.length === 2 ? untruncateYear(parseInteger(yearStr)) : parseInteger(yearStr),
    month: monthsShort.indexOf(monthStr) + 1,
    day: parseInteger(dayStr),
    hour: parseInteger(hourStr),
    minute: parseInteger(minuteStr),
  };

  if (secondStr) result.second = parseInteger(secondStr);
  if (weekdayStr) {
    result.weekday =
      weekdayStr.length > 3
        ? weekdaysLong.indexOf(weekdayStr) + 1
        : weekdaysShort.indexOf(weekdayStr) + 1;
  }

  return result;
}

// RFC 2822/5322
const rfc2822 =
  /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;

function extractRFC2822(match) {
  const [
      ,
      weekdayStr,
      dayStr,
      monthStr,
      yearStr,
      hourStr,
      minuteStr,
      secondStr,
      obsOffset,
      milOffset,
      offHourStr,
      offMinuteStr,
    ] = match,
    result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);

  let offset;
  if (obsOffset) {
    offset = obsOffsets[obsOffset];
  } else if (milOffset) {
    offset = 0;
  } else {
    offset = signedOffset(offHourStr, offMinuteStr);
  }

  return [result, new FixedOffsetZone(offset)];
}

function preprocessRFC2822(s) {
  // Remove comments and folding whitespace and replace multiple-spaces with a single space
  return s
    .replace(/\([^)]*\)|[\n\t]/g, " ")
    .replace(/(\s\s+)/g, " ")
    .trim();
}

// http date

const rfc1123 =
    /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/,
  rfc850 =
    /^(Monday|Tuesday|Wedsday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/,
  ascii =
    /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;

function extractRFC1123Or850(match) {
  const [, weekdayStr, dayStr, monthStr, yearStr, hourStr, minuteStr, secondStr] = match,
    result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  return [result, FixedOffsetZone.utcInstance];
}

function extractASCII(match) {
  const [, weekdayStr, monthStr, dayStr, hourStr, minuteStr, secondStr, yearStr] = match,
    result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  return [result, FixedOffsetZone.utcInstance];
}

const isoYmdWithTimeExtensionRegex = combineRegexes(isoYmdRegex, isoTimeExtensionRegex);
const isoWeekWithTimeExtensionRegex = combineRegexes(isoWeekRegex, isoTimeExtensionRegex);
const isoOrdinalWithTimeExtensionRegex = combineRegexes(isoOrdinalRegex, isoTimeExtensionRegex);
const isoTimeCombinedRegex = combineRegexes(isoTimeRegex);

const extractISOYmdTimeAndOffset = combineExtractors(
  extractISOYmd,
  extractISOTime,
  extractISOOffset
);
const extractISOWeekTimeAndOffset = combineExtractors(
  extractISOWeekData,
  extractISOTime,
  extractISOOffset
);
const extractISOOrdinalDateAndTime = combineExtractors(
  extractISOOrdinalData,
  extractISOTime,
  extractISOOffset
);
const extractISOTimeAndOffset = combineExtractors(extractISOTime, extractISOOffset);

/**
 * @private
 */

function parseISODate(s) {
  return parse(
    s,
    [isoYmdWithTimeExtensionRegex, extractISOYmdTimeAndOffset],
    [isoWeekWithTimeExtensionRegex, extractISOWeekTimeAndOffset],
    [isoOrdinalWithTimeExtensionRegex, extractISOOrdinalDateAndTime],
    [isoTimeCombinedRegex, extractISOTimeAndOffset]
  );
}

function parseRFC2822Date(s) {
  return parse(preprocessRFC2822(s), [rfc2822, extractRFC2822]);
}

function parseHTTPDate(s) {
  return parse(
    s,
    [rfc1123, extractRFC1123Or850],
    [rfc850, extractRFC1123Or850],
    [ascii, extractASCII]
  );
}

function parseISODuration(s) {
  return parse(s, [isoDuration, extractISODuration]);
}

const extractISOTimeOnly = combineExtractors(extractISOTime);

function parseISOTimeOnly(s) {
  return parse(s, [isoTimeOnly, extractISOTimeOnly]);
}

const sqlYmdWithTimeExtensionRegex = combineRegexes(sqlYmdRegex, sqlTimeExtensionRegex);
const sqlTimeCombinedRegex = combineRegexes(sqlTimeRegex);

const extractISOYmdTimeOffsetAndIANAZone = combineExtractors(
  extractISOYmd,
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);
const extractISOTimeOffsetAndIANAZone = combineExtractors(
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);

function parseSQL(s) {
  return parse(
    s,
    [sqlYmdWithTimeExtensionRegex, extractISOYmdTimeOffsetAndIANAZone],
    [sqlTimeCombinedRegex, extractISOTimeOffsetAndIANAZone]
  );
}

const INVALID$2 = "Invalid Duration";

// unit conversion constants
const lowOrderMatrix = {
    weeks: {
      days: 7,
      hours: 7 * 24,
      minutes: 7 * 24 * 60,
      seconds: 7 * 24 * 60 * 60,
      milliseconds: 7 * 24 * 60 * 60 * 1000,
    },
    days: {
      hours: 24,
      minutes: 24 * 60,
      seconds: 24 * 60 * 60,
      milliseconds: 24 * 60 * 60 * 1000,
    },
    hours: { minutes: 60, seconds: 60 * 60, milliseconds: 60 * 60 * 1000 },
    minutes: { seconds: 60, milliseconds: 60 * 1000 },
    seconds: { milliseconds: 1000 },
  },
  casualMatrix = {
    years: {
      quarters: 4,
      months: 12,
      weeks: 52,
      days: 365,
      hours: 365 * 24,
      minutes: 365 * 24 * 60,
      seconds: 365 * 24 * 60 * 60,
      milliseconds: 365 * 24 * 60 * 60 * 1000,
    },
    quarters: {
      months: 3,
      weeks: 13,
      days: 91,
      hours: 91 * 24,
      minutes: 91 * 24 * 60,
      seconds: 91 * 24 * 60 * 60,
      milliseconds: 91 * 24 * 60 * 60 * 1000,
    },
    months: {
      weeks: 4,
      days: 30,
      hours: 30 * 24,
      minutes: 30 * 24 * 60,
      seconds: 30 * 24 * 60 * 60,
      milliseconds: 30 * 24 * 60 * 60 * 1000,
    },

    ...lowOrderMatrix,
  },
  daysInYearAccurate = 146097.0 / 400,
  daysInMonthAccurate = 146097.0 / 4800,
  accurateMatrix = {
    years: {
      quarters: 4,
      months: 12,
      weeks: daysInYearAccurate / 7,
      days: daysInYearAccurate,
      hours: daysInYearAccurate * 24,
      minutes: daysInYearAccurate * 24 * 60,
      seconds: daysInYearAccurate * 24 * 60 * 60,
      milliseconds: daysInYearAccurate * 24 * 60 * 60 * 1000,
    },
    quarters: {
      months: 3,
      weeks: daysInYearAccurate / 28,
      days: daysInYearAccurate / 4,
      hours: (daysInYearAccurate * 24) / 4,
      minutes: (daysInYearAccurate * 24 * 60) / 4,
      seconds: (daysInYearAccurate * 24 * 60 * 60) / 4,
      milliseconds: (daysInYearAccurate * 24 * 60 * 60 * 1000) / 4,
    },
    months: {
      weeks: daysInMonthAccurate / 7,
      days: daysInMonthAccurate,
      hours: daysInMonthAccurate * 24,
      minutes: daysInMonthAccurate * 24 * 60,
      seconds: daysInMonthAccurate * 24 * 60 * 60,
      milliseconds: daysInMonthAccurate * 24 * 60 * 60 * 1000,
    },
    ...lowOrderMatrix,
  };

// units ordered by size
const orderedUnits$1 = [
  "years",
  "quarters",
  "months",
  "weeks",
  "days",
  "hours",
  "minutes",
  "seconds",
  "milliseconds",
];

const reverseUnits = orderedUnits$1.slice(0).reverse();

// clone really means "create another instance just like this one, but with these changes"
function clone$1(dur, alts, clear = false) {
  // deep merge for vals
  const conf = {
    values: clear ? alts.values : { ...dur.values, ...(alts.values || {}) },
    loc: dur.loc.clone(alts.loc),
    conversionAccuracy: alts.conversionAccuracy || dur.conversionAccuracy,
  };
  return new Duration(conf);
}

function antiTrunc(n) {
  return n < 0 ? Math.floor(n) : Math.ceil(n);
}

// NB: mutates parameters
function convert(matrix, fromMap, fromUnit, toMap, toUnit) {
  const conv = matrix[toUnit][fromUnit],
    raw = fromMap[fromUnit] / conv,
    sameSign = Math.sign(raw) === Math.sign(toMap[toUnit]),
    // ok, so this is wild, but see the matrix in the tests
    added =
      !sameSign && toMap[toUnit] !== 0 && Math.abs(raw) <= 1 ? antiTrunc(raw) : Math.trunc(raw);
  toMap[toUnit] += added;
  fromMap[fromUnit] -= added * conv;
}

// NB: mutates parameters
function normalizeValues(matrix, vals) {
  reverseUnits.reduce((previous, current) => {
    if (!isUndefined(vals[current])) {
      if (previous) {
        convert(matrix, vals, previous, vals, current);
      }
      return current;
    } else {
      return previous;
    }
  }, null);
}

/**
 * A Duration object represents a period of time, like "2 months" or "1 day, 1 hour". Conceptually, it's just a map of units to their quantities, accompanied by some additional configuration and methods for creating, parsing, interrogating, transforming, and formatting them. They can be used on their own or in conjunction with other Luxon types; for example, you can use {@link DateTime#plus} to add a Duration object to a DateTime, producing another DateTime.
 *
 * Here is a brief overview of commonly used methods and getters in Duration:
 *
 * * **Creation** To create a Duration, use {@link Duration#fromMillis}, {@link Duration#fromObject}, or {@link Duration#fromISO}.
 * * **Unit values** See the {@link Duration#years}, {@link Duration.months}, {@link Duration#weeks}, {@link Duration#days}, {@link Duration#hours}, {@link Duration#minutes}, {@link Duration#seconds}, {@link Duration#milliseconds} accessors.
 * * **Configuration** See  {@link Duration#locale} and {@link Duration#numberingSystem} accessors.
 * * **Transformation** To create new Durations out of old ones use {@link Duration#plus}, {@link Duration#minus}, {@link Duration#normalize}, {@link Duration#set}, {@link Duration#reconfigure}, {@link Duration#shiftTo}, and {@link Duration#negate}.
 * * **Output** To convert the Duration into other representations, see {@link Duration#as}, {@link Duration#toISO}, {@link Duration#toFormat}, and {@link Duration#toJSON}
 *
 * There's are more methods documented below. In addition, for more information on subtler topics like internationalization and validity, see the external documentation.
 */
class Duration {
  /**
   * @private
   */
  constructor(config) {
    const accurate = config.conversionAccuracy === "longterm" || false;
    /**
     * @access private
     */
    this.values = config.values;
    /**
     * @access private
     */
    this.loc = config.loc || Locale.create();
    /**
     * @access private
     */
    this.conversionAccuracy = accurate ? "longterm" : "casual";
    /**
     * @access private
     */
    this.invalid = config.invalid || null;
    /**
     * @access private
     */
    this.matrix = accurate ? accurateMatrix : casualMatrix;
    /**
     * @access private
     */
    this.isLuxonDuration = true;
  }

  /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  static fromMillis(count, opts) {
    return Duration.fromObject({ milliseconds: count }, opts);
  }

  /**
   * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
   * If this object is empty then a zero milliseconds duration is returned.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.years
   * @param {number} obj.quarters
   * @param {number} obj.months
   * @param {number} obj.weeks
   * @param {number} obj.days
   * @param {number} obj.hours
   * @param {number} obj.minutes
   * @param {number} obj.seconds
   * @param {number} obj.milliseconds
   * @param {Object} [opts=[]] - options for creating this Duration
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  static fromObject(obj, opts = {}) {
    if (obj == null || typeof obj !== "object") {
      throw new InvalidArgumentError(
        `Duration.fromObject: argument expected to be an object, got ${
          obj === null ? "null" : typeof obj
        }`
      );
    }

    return new Duration({
      values: normalizeObject(obj, Duration.normalizeUnit),
      loc: Locale.fromObject(opts),
      conversionAccuracy: opts.conversionAccuracy,
    });
  }

  /**
   * Create a Duration from DurationLike.
   *
   * @param {Object | number | Duration} durationLike
   * One of:
   * - object with keys like 'years' and 'hours'.
   * - number representing milliseconds
   * - Duration instance
   * @return {Duration}
   */
  static fromDurationLike(durationLike) {
    if (isNumber(durationLike)) {
      return Duration.fromMillis(durationLike);
    } else if (Duration.isDuration(durationLike)) {
      return durationLike;
    } else if (typeof durationLike === "object") {
      return Duration.fromObject(durationLike);
    } else {
      throw new InvalidArgumentError(
        `Unknown duration argument ${durationLike} of type ${typeof durationLike}`
      );
    }
  }

  /**
   * Create a Duration from an ISO 8601 duration string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
   * @return {Duration}
   */
  static fromISO(text, opts) {
    const [parsed] = parseISODuration(text);
    if (parsed) {
      return Duration.fromObject(parsed, opts);
    } else {
      return Duration.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
    }
  }

  /**
   * Create a Duration from an ISO 8601 time string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
   * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @return {Duration}
   */
  static fromISOTime(text, opts) {
    const [parsed] = parseISOTimeOnly(text);
    if (parsed) {
      return Duration.fromObject(parsed, opts);
    } else {
      return Duration.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
    }
  }

  /**
   * Create an invalid Duration.
   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Duration}
   */
  static invalid(reason, explanation = null) {
    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the Duration is invalid");
    }

    const invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);

    if (Settings.throwOnInvalid) {
      throw new InvalidDurationError(invalid);
    } else {
      return new Duration({ invalid });
    }
  }

  /**
   * @private
   */
  static normalizeUnit(unit) {
    const normalized = {
      year: "years",
      years: "years",
      quarter: "quarters",
      quarters: "quarters",
      month: "months",
      months: "months",
      week: "weeks",
      weeks: "weeks",
      day: "days",
      days: "days",
      hour: "hours",
      hours: "hours",
      minute: "minutes",
      minutes: "minutes",
      second: "seconds",
      seconds: "seconds",
      millisecond: "milliseconds",
      milliseconds: "milliseconds",
    }[unit ? unit.toLowerCase() : unit];

    if (!normalized) throw new InvalidUnitError(unit);

    return normalized;
  }

  /**
   * Check if an object is a Duration. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDuration(o) {
    return (o && o.isLuxonDuration) || false;
  }

  /**
   * Get  the locale of a Duration, such 'en-GB'
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }

  /**
   * Get the numbering system of a Duration, such 'beng'. The numbering system is used when formatting the Duration
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }

  /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @return {string}
   */
  toFormat(fmt, opts = {}) {
    // reverse-compat since 1.2; we always round down now, never up, and we do it by default
    const fmtOpts = {
      ...opts,
      floor: opts.round !== false && opts.floor !== false,
    };
    return this.isValid
      ? Formatter.create(this.loc, fmtOpts).formatDurationFromString(this, fmt)
      : INVALID$2;
  }

  /**
   * Returns a string representation of a Duration with all units included
   * To modify its behavior use the `listStyle` and any Intl.NumberFormat option, though `unitDisplay` is especially relevant. See {@link Intl.NumberFormat}.
   * @param opts - On option object to override the formatting. Accepts the same keys as the options parameter of the native `Int.NumberFormat` constructor, as well as `listStyle`.
   * @example
   * ```js
   * var dur = Duration.fromObject({ days: 1, hours: 5, minutes: 6 })
   * dur.toHuman() //=> '1 day, 5 hours, 6 minutes'
   * dur.toHuman({ listStyle: "long" }) //=> '1 day, 5 hours, and 6 minutes'
   * dur.toHuman({ unitDisplay: "short" }) //=> '1 day, 5 hr, 6 min'
   * ```
   */
  toHuman(opts = {}) {
    const l = orderedUnits$1
      .map((unit) => {
        const val = this.values[unit];
        if (isUndefined(val)) {
          return null;
        }
        return this.loc
          .numberFormatter({ style: "unit", unitDisplay: "long", ...opts, unit: unit.slice(0, -1) })
          .format(val);
      })
      .filter((n) => n);

    return this.loc
      .listFormatter({ type: "conjunction", style: opts.listStyle || "narrow", ...opts })
      .format(l);
  }

  /**
   * Returns a JavaScript object with this Duration's values.
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
   * @return {Object}
   */
  toObject() {
    if (!this.isValid) return {};
    return { ...this.values };
  }

  /**
   * Returns an ISO 8601-compliant string representation of this Duration.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
   * @return {string}
   */
  toISO() {
    // we could use the formatter, but this is an easier way to get the minimum string
    if (!this.isValid) return null;

    let s = "P";
    if (this.years !== 0) s += this.years + "Y";
    if (this.months !== 0 || this.quarters !== 0) s += this.months + this.quarters * 3 + "M";
    if (this.weeks !== 0) s += this.weeks + "W";
    if (this.days !== 0) s += this.days + "D";
    if (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0)
      s += "T";
    if (this.hours !== 0) s += this.hours + "H";
    if (this.minutes !== 0) s += this.minutes + "M";
    if (this.seconds !== 0 || this.milliseconds !== 0)
      // this will handle "floating point madness" by removing extra decimal places
      // https://stackoverflow.com/questions/588004/is-floating-point-math-broken
      s += roundTo(this.seconds + this.milliseconds / 1000, 3) + "S";
    if (s === "P") s += "T0S";
    return s;
  }

  /**
   * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
   * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
   * @return {string}
   */
  toISOTime(opts = {}) {
    if (!this.isValid) return null;

    const millis = this.toMillis();
    if (millis < 0 || millis >= 86400000) return null;

    opts = {
      suppressMilliseconds: false,
      suppressSeconds: false,
      includePrefix: false,
      format: "extended",
      ...opts,
    };

    const value = this.shiftTo("hours", "minutes", "seconds", "milliseconds");

    let fmt = opts.format === "basic" ? "hhmm" : "hh:mm";

    if (!opts.suppressSeconds || value.seconds !== 0 || value.milliseconds !== 0) {
      fmt += opts.format === "basic" ? "ss" : ":ss";
      if (!opts.suppressMilliseconds || value.milliseconds !== 0) {
        fmt += ".SSS";
      }
    }

    let str = value.toFormat(fmt);

    if (opts.includePrefix) {
      str = "T" + str;
    }

    return str;
  }

  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }

  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
   * @return {string}
   */
  toString() {
    return this.toISO();
  }

  /**
   * Returns an milliseconds value of this Duration.
   * @return {number}
   */
  toMillis() {
    return this.as("milliseconds");
  }

  /**
   * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }

  /**
   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  plus(duration) {
    if (!this.isValid) return this;

    const dur = Duration.fromDurationLike(duration),
      result = {};

    for (const k of orderedUnits$1) {
      if (hasOwnProperty(dur.values, k) || hasOwnProperty(this.values, k)) {
        result[k] = dur.get(k) + this.get(k);
      }
    }

    return clone$1(this, { values: result }, true);
  }

  /**
   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  minus(duration) {
    if (!this.isValid) return this;

    const dur = Duration.fromDurationLike(duration);
    return this.plus(dur.negate());
  }

  /**
   * Scale this Duration by the specified amount. Return a newly-constructed Duration.
   * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits(x => x * 2) //=> { hours: 2, minutes: 60 }
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits((x, u) => u === "hour" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
   * @return {Duration}
   */
  mapUnits(fn) {
    if (!this.isValid) return this;
    const result = {};
    for (const k of Object.keys(this.values)) {
      result[k] = asNumber(fn(this.values[k], k));
    }
    return clone$1(this, { values: result }, true);
  }

  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
   * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
   * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
   * @return {number}
   */
  get(unit) {
    return this[Duration.normalizeUnit(unit)];
  }

  /**
   * "Set" the values of specified units. Return a newly-constructed Duration.
   * @param {Object} values - a mapping of units to numbers
   * @example dur.set({ years: 2017 })
   * @example dur.set({ hours: 8, minutes: 30 })
   * @return {Duration}
   */
  set(values) {
    if (!this.isValid) return this;

    const mixed = { ...this.values, ...normalizeObject(values, Duration.normalizeUnit) };
    return clone$1(this, { values: mixed });
  }

  /**
   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
   * @example dur.reconfigure({ locale: 'en-GB' })
   * @return {Duration}
   */
  reconfigure({ locale, numberingSystem, conversionAccuracy } = {}) {
    const loc = this.loc.clone({ locale, numberingSystem }),
      opts = { loc };

    if (conversionAccuracy) {
      opts.conversionAccuracy = conversionAccuracy;
    }

    return clone$1(this, opts);
  }

  /**
   * Return the length of the duration in the specified unit.
   * @param {string} unit - a unit such as 'minutes' or 'days'
   * @example Duration.fromObject({years: 1}).as('days') //=> 365
   * @example Duration.fromObject({years: 1}).as('months') //=> 12
   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
   * @return {number}
   */
  as(unit) {
    return this.isValid ? this.shiftTo(unit).get(unit) : NaN;
  }

  /**
   * Reduce this Duration to its canonical representation in its current units.
   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
   * @return {Duration}
   */
  normalize() {
    if (!this.isValid) return this;
    const vals = this.toObject();
    normalizeValues(this.matrix, vals);
    return clone$1(this, { values: vals }, true);
  }

  /**
   * Convert this Duration into its representation in a different set of units.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
   * @return {Duration}
   */
  shiftTo(...units) {
    if (!this.isValid) return this;

    if (units.length === 0) {
      return this;
    }

    units = units.map((u) => Duration.normalizeUnit(u));

    const built = {},
      accumulated = {},
      vals = this.toObject();
    let lastUnit;

    for (const k of orderedUnits$1) {
      if (units.indexOf(k) >= 0) {
        lastUnit = k;

        let own = 0;

        // anything we haven't boiled down yet should get boiled to this unit
        for (const ak in accumulated) {
          own += this.matrix[ak][k] * accumulated[ak];
          accumulated[ak] = 0;
        }

        // plus anything that's already in this unit
        if (isNumber(vals[k])) {
          own += vals[k];
        }

        const i = Math.trunc(own);
        built[k] = i;
        accumulated[k] = (own * 1000 - i * 1000) / 1000;

        // plus anything further down the chain that should be rolled up in to this
        for (const down in vals) {
          if (orderedUnits$1.indexOf(down) > orderedUnits$1.indexOf(k)) {
            convert(this.matrix, vals, down, built, k);
          }
        }
        // otherwise, keep it in the wings to boil it later
      } else if (isNumber(vals[k])) {
        accumulated[k] = vals[k];
      }
    }

    // anything leftover becomes the decimal for the last unit
    // lastUnit must be defined since units is not empty
    for (const key in accumulated) {
      if (accumulated[key] !== 0) {
        built[lastUnit] +=
          key === lastUnit ? accumulated[key] : accumulated[key] / this.matrix[lastUnit][key];
      }
    }

    return clone$1(this, { values: built }, true).normalize();
  }

  /**
   * Return the negative of this Duration.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
   * @return {Duration}
   */
  negate() {
    if (!this.isValid) return this;
    const negated = {};
    for (const k of Object.keys(this.values)) {
      negated[k] = -this.values[k];
    }
    return clone$1(this, { values: negated }, true);
  }

  /**
   * Get the years.
   * @type {number}
   */
  get years() {
    return this.isValid ? this.values.years || 0 : NaN;
  }

  /**
   * Get the quarters.
   * @type {number}
   */
  get quarters() {
    return this.isValid ? this.values.quarters || 0 : NaN;
  }

  /**
   * Get the months.
   * @type {number}
   */
  get months() {
    return this.isValid ? this.values.months || 0 : NaN;
  }

  /**
   * Get the weeks
   * @type {number}
   */
  get weeks() {
    return this.isValid ? this.values.weeks || 0 : NaN;
  }

  /**
   * Get the days.
   * @type {number}
   */
  get days() {
    return this.isValid ? this.values.days || 0 : NaN;
  }

  /**
   * Get the hours.
   * @type {number}
   */
  get hours() {
    return this.isValid ? this.values.hours || 0 : NaN;
  }

  /**
   * Get the minutes.
   * @type {number}
   */
  get minutes() {
    return this.isValid ? this.values.minutes || 0 : NaN;
  }

  /**
   * Get the seconds.
   * @return {number}
   */
  get seconds() {
    return this.isValid ? this.values.seconds || 0 : NaN;
  }

  /**
   * Get the milliseconds.
   * @return {number}
   */
  get milliseconds() {
    return this.isValid ? this.values.milliseconds || 0 : NaN;
  }

  /**
   * Returns whether the Duration is invalid. Invalid durations are returned by diff operations
   * on invalid DateTimes or Intervals.
   * @return {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }

  /**
   * Returns an error code if this Duration became invalid, or null if the Duration is valid
   * @return {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }

  /**
   * Returns an explanation of why this Duration became invalid, or null if the Duration is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }

  /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */
  equals(other) {
    if (!this.isValid || !other.isValid) {
      return false;
    }

    if (!this.loc.equals(other.loc)) {
      return false;
    }

    function eq(v1, v2) {
      // Consider 0 and undefined as equal
      if (v1 === undefined || v1 === 0) return v2 === undefined || v2 === 0;
      return v1 === v2;
    }

    for (const u of orderedUnits$1) {
      if (!eq(this.values[u], other.values[u])) {
        return false;
      }
    }
    return true;
  }
}

const INVALID$1 = "Invalid Interval";

// checks if the start is equal to or before the end
function validateStartEnd(start, end) {
  if (!start || !start.isValid) {
    return Interval.invalid("missing or invalid start");
  } else if (!end || !end.isValid) {
    return Interval.invalid("missing or invalid end");
  } else if (end < start) {
    return Interval.invalid(
      "end before start",
      `The end of an interval must be after its start, but you had start=${start.toISO()} and end=${end.toISO()}`
    );
  } else {
    return null;
  }
}

/**
 * An Interval object represents a half-open interval of time, where each endpoint is a {@link DateTime}. Conceptually, it's a container for those two endpoints, accompanied by methods for creating, parsing, interrogating, comparing, transforming, and formatting them.
 *
 * Here is a brief overview of the most commonly used methods and getters in Interval:
 *
 * * **Creation** To create an Interval, use {@link Interval#fromDateTimes}, {@link Interval#after}, {@link Interval#before}, or {@link Interval#fromISO}.
 * * **Accessors** Use {@link Interval#start} and {@link Interval#end} to get the start and end.
 * * **Interrogation** To analyze the Interval, use {@link Interval#count}, {@link Interval#length}, {@link Interval#hasSame}, {@link Interval#contains}, {@link Interval#isAfter}, or {@link Interval#isBefore}.
 * * **Transformation** To create other Intervals out of this one, use {@link Interval#set}, {@link Interval#splitAt}, {@link Interval#splitBy}, {@link Interval#divideEqually}, {@link Interval#merge}, {@link Interval#xor}, {@link Interval#union}, {@link Interval#intersection}, or {@link Interval#difference}.
 * * **Comparison** To compare this Interval to another one, use {@link Interval#equals}, {@link Interval#overlaps}, {@link Interval#abutsStart}, {@link Interval#abutsEnd}, {@link Interval#engulfs}
 * * **Output** To convert the Interval into other representations, see {@link Interval#toString}, {@link Interval#toISO}, {@link Interval#toISODate}, {@link Interval#toISOTime}, {@link Interval#toFormat}, and {@link Interval#toDuration}.
 */
class Interval {
  /**
   * @private
   */
  constructor(config) {
    /**
     * @access private
     */
    this.s = config.start;
    /**
     * @access private
     */
    this.e = config.end;
    /**
     * @access private
     */
    this.invalid = config.invalid || null;
    /**
     * @access private
     */
    this.isLuxonInterval = true;
  }

  /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */
  static invalid(reason, explanation = null) {
    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the Interval is invalid");
    }

    const invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);

    if (Settings.throwOnInvalid) {
      throw new InvalidIntervalError(invalid);
    } else {
      return new Interval({ invalid });
    }
  }

  /**
   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
   * @param {DateTime|Date|Object} start
   * @param {DateTime|Date|Object} end
   * @return {Interval}
   */
  static fromDateTimes(start, end) {
    const builtStart = friendlyDateTime(start),
      builtEnd = friendlyDateTime(end);

    const validateError = validateStartEnd(builtStart, builtEnd);

    if (validateError == null) {
      return new Interval({
        start: builtStart,
        end: builtEnd,
      });
    } else {
      return validateError;
    }
  }

  /**
   * Create an Interval from a start DateTime and a Duration to extend to.
   * @param {DateTime|Date|Object} start
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static after(start, duration) {
    const dur = Duration.fromDurationLike(duration),
      dt = friendlyDateTime(start);
    return Interval.fromDateTimes(dt, dt.plus(dur));
  }

  /**
   * Create an Interval from an end DateTime and a Duration to extend backwards to.
   * @param {DateTime|Date|Object} end
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static before(end, duration) {
    const dur = Duration.fromDurationLike(duration),
      dt = friendlyDateTime(end);
    return Interval.fromDateTimes(dt.minus(dur), dt);
  }

  /**
   * Create an Interval from an ISO 8601 string.
   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
   * @param {string} text - the ISO string to parse
   * @param {Object} [opts] - options to pass {@link DateTime#fromISO} and optionally {@link Duration#fromISO}
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {Interval}
   */
  static fromISO(text, opts) {
    const [s, e] = (text || "").split("/", 2);
    if (s && e) {
      let start, startIsValid;
      try {
        start = DateTime.fromISO(s, opts);
        startIsValid = start.isValid;
      } catch (e) {
        startIsValid = false;
      }

      let end, endIsValid;
      try {
        end = DateTime.fromISO(e, opts);
        endIsValid = end.isValid;
      } catch (e) {
        endIsValid = false;
      }

      if (startIsValid && endIsValid) {
        return Interval.fromDateTimes(start, end);
      }

      if (startIsValid) {
        const dur = Duration.fromISO(e, opts);
        if (dur.isValid) {
          return Interval.after(start, dur);
        }
      } else if (endIsValid) {
        const dur = Duration.fromISO(s, opts);
        if (dur.isValid) {
          return Interval.before(end, dur);
        }
      }
    }
    return Interval.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
  }

  /**
   * Check if an object is an Interval. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isInterval(o) {
    return (o && o.isLuxonInterval) || false;
  }

  /**
   * Returns the start of the Interval
   * @type {DateTime}
   */
  get start() {
    return this.isValid ? this.s : null;
  }

  /**
   * Returns the end of the Interval
   * @type {DateTime}
   */
  get end() {
    return this.isValid ? this.e : null;
  }

  /**
   * Returns whether this Interval's end is at least its start, meaning that the Interval isn't 'backwards'.
   * @type {boolean}
   */
  get isValid() {
    return this.invalidReason === null;
  }

  /**
   * Returns an error code if this Interval is invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }

  /**
   * Returns an explanation of why this Interval became invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }

  /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */
  length(unit = "milliseconds") {
    return this.isValid ? this.toDuration(...[unit]).get(unit) : NaN;
  }

  /**
   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
   * Unlike {@link Interval#length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
   * @param {string} [unit='milliseconds'] - the unit of time to count.
   * @return {number}
   */
  count(unit = "milliseconds") {
    if (!this.isValid) return NaN;
    const start = this.start.startOf(unit),
      end = this.end.startOf(unit);
    return Math.floor(end.diff(start, unit).get(unit)) + 1;
  }

  /**
   * Returns whether this Interval's start and end are both in the same unit of time
   * @param {string} unit - the unit of time to check sameness on
   * @return {boolean}
   */
  hasSame(unit) {
    return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, unit) : false;
  }

  /**
   * Return whether this Interval has the same start and end DateTimes.
   * @return {boolean}
   */
  isEmpty() {
    return this.s.valueOf() === this.e.valueOf();
  }

  /**
   * Return whether this Interval's start is after the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isAfter(dateTime) {
    if (!this.isValid) return false;
    return this.s > dateTime;
  }

  /**
   * Return whether this Interval's end is before the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isBefore(dateTime) {
    if (!this.isValid) return false;
    return this.e <= dateTime;
  }

  /**
   * Return whether this Interval contains the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  contains(dateTime) {
    if (!this.isValid) return false;
    return this.s <= dateTime && this.e > dateTime;
  }

  /**
   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
   * @param {Object} values - the values to set
   * @param {DateTime} values.start - the starting DateTime
   * @param {DateTime} values.end - the ending DateTime
   * @return {Interval}
   */
  set({ start, end } = {}) {
    if (!this.isValid) return this;
    return Interval.fromDateTimes(start || this.s, end || this.e);
  }

  /**
   * Split this Interval at each of the specified DateTimes
   * @param {...DateTime} dateTimes - the unit of time to count.
   * @return {Array}
   */
  splitAt(...dateTimes) {
    if (!this.isValid) return [];
    const sorted = dateTimes
        .map(friendlyDateTime)
        .filter((d) => this.contains(d))
        .sort(),
      results = [];
    let { s } = this,
      i = 0;

    while (s < this.e) {
      const added = sorted[i] || this.e,
        next = +added > +this.e ? this.e : added;
      results.push(Interval.fromDateTimes(s, next));
      s = next;
      i += 1;
    }

    return results;
  }

  /**
   * Split this Interval into smaller Intervals, each of the specified length.
   * Left over time is grouped into a smaller interval
   * @param {Duration|Object|number} duration - The length of each resulting interval.
   * @return {Array}
   */
  splitBy(duration) {
    const dur = Duration.fromDurationLike(duration);

    if (!this.isValid || !dur.isValid || dur.as("milliseconds") === 0) {
      return [];
    }

    let { s } = this,
      idx = 1,
      next;

    const results = [];
    while (s < this.e) {
      const added = this.start.plus(dur.mapUnits((x) => x * idx));
      next = +added > +this.e ? this.e : added;
      results.push(Interval.fromDateTimes(s, next));
      s = next;
      idx += 1;
    }

    return results;
  }

  /**
   * Split this Interval into the specified number of smaller intervals.
   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
   * @return {Array}
   */
  divideEqually(numberOfParts) {
    if (!this.isValid) return [];
    return this.splitBy(this.length() / numberOfParts).slice(0, numberOfParts);
  }

  /**
   * Return whether this Interval overlaps with the specified Interval
   * @param {Interval} other
   * @return {boolean}
   */
  overlaps(other) {
    return this.e > other.s && this.s < other.e;
  }

  /**
   * Return whether this Interval's end is adjacent to the specified Interval's start.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsStart(other) {
    if (!this.isValid) return false;
    return +this.e === +other.s;
  }

  /**
   * Return whether this Interval's start is adjacent to the specified Interval's end.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsEnd(other) {
    if (!this.isValid) return false;
    return +other.e === +this.s;
  }

  /**
   * Return whether this Interval engulfs the start and end of the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */
  engulfs(other) {
    if (!this.isValid) return false;
    return this.s <= other.s && this.e >= other.e;
  }

  /**
   * Return whether this Interval has the same start and end as the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */
  equals(other) {
    if (!this.isValid || !other.isValid) {
      return false;
    }

    return this.s.equals(other.s) && this.e.equals(other.e);
  }

  /**
   * Return an Interval representing the intersection of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
   * Returns null if the intersection is empty, meaning, the intervals don't intersect.
   * @param {Interval} other
   * @return {Interval}
   */
  intersection(other) {
    if (!this.isValid) return this;
    const s = this.s > other.s ? this.s : other.s,
      e = this.e < other.e ? this.e : other.e;

    if (s >= e) {
      return null;
    } else {
      return Interval.fromDateTimes(s, e);
    }
  }

  /**
   * Return an Interval representing the union of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
   * @param {Interval} other
   * @return {Interval}
   */
  union(other) {
    if (!this.isValid) return this;
    const s = this.s < other.s ? this.s : other.s,
      e = this.e > other.e ? this.e : other.e;
    return Interval.fromDateTimes(s, e);
  }

  /**
   * Merge an array of Intervals into a equivalent minimal set of Intervals.
   * Combines overlapping and adjacent Intervals.
   * @param {Array} intervals
   * @return {Array}
   */
  static merge(intervals) {
    const [found, final] = intervals
      .sort((a, b) => a.s - b.s)
      .reduce(
        ([sofar, current], item) => {
          if (!current) {
            return [sofar, item];
          } else if (current.overlaps(item) || current.abutsStart(item)) {
            return [sofar, current.union(item)];
          } else {
            return [sofar.concat([current]), item];
          }
        },
        [[], null]
      );
    if (final) {
      found.push(final);
    }
    return found;
  }

  /**
   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
   * @param {Array} intervals
   * @return {Array}
   */
  static xor(intervals) {
    let start = null,
      currentCount = 0;
    const results = [],
      ends = intervals.map((i) => [
        { time: i.s, type: "s" },
        { time: i.e, type: "e" },
      ]),
      flattened = Array.prototype.concat(...ends),
      arr = flattened.sort((a, b) => a.time - b.time);

    for (const i of arr) {
      currentCount += i.type === "s" ? 1 : -1;

      if (currentCount === 1) {
        start = i.time;
      } else {
        if (start && +start !== +i.time) {
          results.push(Interval.fromDateTimes(start, i.time));
        }

        start = null;
      }
    }

    return Interval.merge(results);
  }

  /**
   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
   * @param {...Interval} intervals
   * @return {Array}
   */
  difference(...intervals) {
    return Interval.xor([this].concat(intervals))
      .map((i) => this.intersection(i))
      .filter((i) => i && !i.isEmpty());
  }

  /**
   * Returns a string representation of this Interval appropriate for debugging.
   * @return {string}
   */
  toString() {
    if (!this.isValid) return INVALID$1;
    return `[${this.s.toISO()} – ${this.e.toISO()})`;
  }

  /**
   * Returns an ISO 8601-compliant string representation of this Interval.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISO(opts) {
    if (!this.isValid) return INVALID$1;
    return `${this.s.toISO(opts)}/${this.e.toISO(opts)}`;
  }

  /**
   * Returns an ISO 8601-compliant string representation of date of this Interval.
   * The time components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {string}
   */
  toISODate() {
    if (!this.isValid) return INVALID$1;
    return `${this.s.toISODate()}/${this.e.toISODate()}`;
  }

  /**
   * Returns an ISO 8601-compliant string representation of time of this Interval.
   * The date components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISOTime(opts) {
    if (!this.isValid) return INVALID$1;
    return `${this.s.toISOTime(opts)}/${this.e.toISOTime(opts)}`;
  }

  /**
   * Returns a string representation of this Interval formatted according to the specified format string.
   * @param {string} dateFormat - the format string. This string formats the start and end time. See {@link DateTime#toFormat} for details.
   * @param {Object} opts - options
   * @param {string} [opts.separator =  ' – '] - a separator to place between the start and end representations
   * @return {string}
   */
  toFormat(dateFormat, { separator = " – " } = {}) {
    if (!this.isValid) return INVALID$1;
    return `${this.s.toFormat(dateFormat)}${separator}${this.e.toFormat(dateFormat)}`;
  }

  /**
   * Return a Duration representing the time spanned by this interval.
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
   * @return {Duration}
   */
  toDuration(unit, opts) {
    if (!this.isValid) {
      return Duration.invalid(this.invalidReason);
    }
    return this.e.diff(this.s, unit, opts);
  }

  /**
   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
   * @param {function} mapFn
   * @return {Interval}
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
   */
  mapEndpoints(mapFn) {
    return Interval.fromDateTimes(mapFn(this.s), mapFn(this.e));
  }
}

/**
 * The Info class contains static methods for retrieving general time and date related data. For example, it has methods for finding out if a time zone has a DST, for listing the months in any supported locale, and for discovering which of Luxon features are available in the current environment.
 */
class Info {
  /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */
  static hasDST(zone = Settings.defaultZone) {
    const proto = DateTime.now().setZone(zone).set({ month: 12 });

    return !zone.isUniversal && proto.offset !== proto.set({ month: 6 }).offset;
  }

  /**
   * Return whether the specified zone is a valid IANA specifier.
   * @param {string} zone - Zone to check
   * @return {boolean}
   */
  static isValidIANAZone(zone) {
    return IANAZone.isValidSpecifier(zone) && IANAZone.isValidZone(zone);
  }

  /**
   * Converts the input into a {@link Zone} instance.
   *
   * * If `input` is already a Zone instance, it is returned unchanged.
   * * If `input` is a string containing a valid time zone name, a Zone instance
   *   with that name is returned.
   * * If `input` is a string that doesn't refer to a known time zone, a Zone
   *   instance with {@link Zone#isValid} == false is returned.
   * * If `input is a number, a Zone instance with the specified fixed offset
   *   in minutes is returned.
   * * If `input` is `null` or `undefined`, the default zone is returned.
   * @param {string|Zone|number} [input] - the value to be converted
   * @return {Zone}
   */
  static normalizeZone(input) {
    return normalizeZone(input, Settings.defaultZone);
  }

  /**
   * Return an array of standalone month names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @example Info.months()[0] //=> 'January'
   * @example Info.months('short')[0] //=> 'Jan'
   * @example Info.months('numeric')[0] //=> '1'
   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
   * @return {Array}
   */
  static months(
    length = "long",
    { locale = null, numberingSystem = null, locObj = null, outputCalendar = "gregory" } = {}
  ) {
    return (locObj || Locale.create(locale, numberingSystem, outputCalendar)).months(length);
  }

  /**
   * Return an array of format month names.
   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
   * changes the string.
   * See {@link Info#months}
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @return {Array}
   */
  static monthsFormat(
    length = "long",
    { locale = null, numberingSystem = null, locObj = null, outputCalendar = "gregory" } = {}
  ) {
    return (locObj || Locale.create(locale, numberingSystem, outputCalendar)).months(length, true);
  }

  /**
   * Return an array of standalone week names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @example Info.weekdays()[0] //=> 'Monday'
   * @example Info.weekdays('short')[0] //=> 'Mon'
   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
   * @return {Array}
   */
  static weekdays(length = "long", { locale = null, numberingSystem = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale, numberingSystem, null)).weekdays(length);
  }

  /**
   * Return an array of format week names.
   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
   * changes the string.
   * See {@link Info#weekdays}
   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale=null] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @return {Array}
   */
  static weekdaysFormat(
    length = "long",
    { locale = null, numberingSystem = null, locObj = null } = {}
  ) {
    return (locObj || Locale.create(locale, numberingSystem, null)).weekdays(length, true);
  }

  /**
   * Return an array of meridiems.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
   * @return {Array}
   */
  static meridiems({ locale = null } = {}) {
    return Locale.create(locale).meridiems();
  }

  /**
   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.eras() //=> [ 'BC', 'AD' ]
   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
   * @return {Array}
   */
  static eras(length = "short", { locale = null } = {}) {
    return Locale.create(locale, null, "gregory").eras(length);
  }

  /**
   * Return the set of available features in this environment.
   * Some features of Luxon are not available in all environments. For example, on older browsers, relative time formatting support is not available. Use this function to figure out if that's the case.
   * Keys:
   * * `relative`: whether this environment supports relative time formatting
   * @example Info.features() //=> { relative: false }
   * @return {Object}
   */
  static features() {
    return { relative: hasRelative() };
  }
}

function dayDiff(earlier, later) {
  const utcDayStart = (dt) => dt.toUTC(0, { keepLocalTime: true }).startOf("day").valueOf(),
    ms = utcDayStart(later) - utcDayStart(earlier);
  return Math.floor(Duration.fromMillis(ms).as("days"));
}

function highOrderDiffs(cursor, later, units) {
  const differs = [
    ["years", (a, b) => b.year - a.year],
    ["quarters", (a, b) => b.quarter - a.quarter],
    ["months", (a, b) => b.month - a.month + (b.year - a.year) * 12],
    [
      "weeks",
      (a, b) => {
        const days = dayDiff(a, b);
        return (days - (days % 7)) / 7;
      },
    ],
    ["days", dayDiff],
  ];

  const results = {};
  let lowestOrder, highWater;

  for (const [unit, differ] of differs) {
    if (units.indexOf(unit) >= 0) {
      lowestOrder = unit;

      let delta = differ(cursor, later);
      highWater = cursor.plus({ [unit]: delta });

      if (highWater > later) {
        cursor = cursor.plus({ [unit]: delta - 1 });
        delta -= 1;
      } else {
        cursor = highWater;
      }

      results[unit] = delta;
    }
  }

  return [cursor, results, highWater, lowestOrder];
}

function diff (earlier, later, units, opts) {
  let [cursor, results, highWater, lowestOrder] = highOrderDiffs(earlier, later, units);

  const remainingMillis = later - cursor;

  const lowerOrderUnits = units.filter(
    (u) => ["hours", "minutes", "seconds", "milliseconds"].indexOf(u) >= 0
  );

  if (lowerOrderUnits.length === 0) {
    if (highWater < later) {
      highWater = cursor.plus({ [lowestOrder]: 1 });
    }

    if (highWater !== cursor) {
      results[lowestOrder] = (results[lowestOrder] || 0) + remainingMillis / (highWater - cursor);
    }
  }

  const duration = Duration.fromObject(results, opts);

  if (lowerOrderUnits.length > 0) {
    return Duration.fromMillis(remainingMillis, opts)
      .shiftTo(...lowerOrderUnits)
      .plus(duration);
  } else {
    return duration;
  }
}

const numberingSystems = {
  arab: "[\u0660-\u0669]",
  arabext: "[\u06F0-\u06F9]",
  bali: "[\u1B50-\u1B59]",
  beng: "[\u09E6-\u09EF]",
  deva: "[\u0966-\u096F]",
  fullwide: "[\uFF10-\uFF19]",
  gujr: "[\u0AE6-\u0AEF]",
  hanidec: "[〇|一|二|三|四|五|六|七|八|九]",
  khmr: "[\u17E0-\u17E9]",
  knda: "[\u0CE6-\u0CEF]",
  laoo: "[\u0ED0-\u0ED9]",
  limb: "[\u1946-\u194F]",
  mlym: "[\u0D66-\u0D6F]",
  mong: "[\u1810-\u1819]",
  mymr: "[\u1040-\u1049]",
  orya: "[\u0B66-\u0B6F]",
  tamldec: "[\u0BE6-\u0BEF]",
  telu: "[\u0C66-\u0C6F]",
  thai: "[\u0E50-\u0E59]",
  tibt: "[\u0F20-\u0F29]",
  latn: "\\d",
};

const numberingSystemsUTF16 = {
  arab: [1632, 1641],
  arabext: [1776, 1785],
  bali: [6992, 7001],
  beng: [2534, 2543],
  deva: [2406, 2415],
  fullwide: [65296, 65303],
  gujr: [2790, 2799],
  khmr: [6112, 6121],
  knda: [3302, 3311],
  laoo: [3792, 3801],
  limb: [6470, 6479],
  mlym: [3430, 3439],
  mong: [6160, 6169],
  mymr: [4160, 4169],
  orya: [2918, 2927],
  tamldec: [3046, 3055],
  telu: [3174, 3183],
  thai: [3664, 3673],
  tibt: [3872, 3881],
};

const hanidecChars = numberingSystems.hanidec.replace(/[\[|\]]/g, "").split("");

function parseDigits(str) {
  let value = parseInt(str, 10);
  if (isNaN(value)) {
    value = "";
    for (let i = 0; i < str.length; i++) {
      const code = str.charCodeAt(i);

      if (str[i].search(numberingSystems.hanidec) !== -1) {
        value += hanidecChars.indexOf(str[i]);
      } else {
        for (const key in numberingSystemsUTF16) {
          const [min, max] = numberingSystemsUTF16[key];
          if (code >= min && code <= max) {
            value += code - min;
          }
        }
      }
    }
    return parseInt(value, 10);
  } else {
    return value;
  }
}

function digitRegex({ numberingSystem }, append = "") {
  return new RegExp(`${numberingSystems[numberingSystem || "latn"]}${append}`);
}

const MISSING_FTP = "missing Intl.DateTimeFormat.formatToParts support";

function intUnit(regex, post = (i) => i) {
  return { regex, deser: ([s]) => post(parseDigits(s)) };
}

const NBSP = String.fromCharCode(160);
const spaceOrNBSP = `( |${NBSP})`;
const spaceOrNBSPRegExp = new RegExp(spaceOrNBSP, "g");

function fixListRegex(s) {
  // make dots optional and also make them literal
  // make space and non breakable space characters interchangeable
  return s.replace(/\./g, "\\.?").replace(spaceOrNBSPRegExp, spaceOrNBSP);
}

function stripInsensitivities(s) {
  return s
    .replace(/\./g, "") // ignore dots that were made optional
    .replace(spaceOrNBSPRegExp, " ") // interchange space and nbsp
    .toLowerCase();
}

function oneOf(strings, startIndex) {
  if (strings === null) {
    return null;
  } else {
    return {
      regex: RegExp(strings.map(fixListRegex).join("|")),
      deser: ([s]) =>
        strings.findIndex((i) => stripInsensitivities(s) === stripInsensitivities(i)) + startIndex,
    };
  }
}

function offset(regex, groups) {
  return { regex, deser: ([, h, m]) => signedOffset(h, m), groups };
}

function simple(regex) {
  return { regex, deser: ([s]) => s };
}

function escapeToken(value) {
  return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}

function unitForToken(token, loc) {
  const one = digitRegex(loc),
    two = digitRegex(loc, "{2}"),
    three = digitRegex(loc, "{3}"),
    four = digitRegex(loc, "{4}"),
    six = digitRegex(loc, "{6}"),
    oneOrTwo = digitRegex(loc, "{1,2}"),
    oneToThree = digitRegex(loc, "{1,3}"),
    oneToSix = digitRegex(loc, "{1,6}"),
    oneToNine = digitRegex(loc, "{1,9}"),
    twoToFour = digitRegex(loc, "{2,4}"),
    fourToSix = digitRegex(loc, "{4,6}"),
    literal = (t) => ({ regex: RegExp(escapeToken(t.val)), deser: ([s]) => s, literal: true }),
    unitate = (t) => {
      if (token.literal) {
        return literal(t);
      }
      switch (t.val) {
        // era
        case "G":
          return oneOf(loc.eras("short", false), 0);
        case "GG":
          return oneOf(loc.eras("long", false), 0);
        // years
        case "y":
          return intUnit(oneToSix);
        case "yy":
          return intUnit(twoToFour, untruncateYear);
        case "yyyy":
          return intUnit(four);
        case "yyyyy":
          return intUnit(fourToSix);
        case "yyyyyy":
          return intUnit(six);
        // months
        case "M":
          return intUnit(oneOrTwo);
        case "MM":
          return intUnit(two);
        case "MMM":
          return oneOf(loc.months("short", true, false), 1);
        case "MMMM":
          return oneOf(loc.months("long", true, false), 1);
        case "L":
          return intUnit(oneOrTwo);
        case "LL":
          return intUnit(two);
        case "LLL":
          return oneOf(loc.months("short", false, false), 1);
        case "LLLL":
          return oneOf(loc.months("long", false, false), 1);
        // dates
        case "d":
          return intUnit(oneOrTwo);
        case "dd":
          return intUnit(two);
        // ordinals
        case "o":
          return intUnit(oneToThree);
        case "ooo":
          return intUnit(three);
        // time
        case "HH":
          return intUnit(two);
        case "H":
          return intUnit(oneOrTwo);
        case "hh":
          return intUnit(two);
        case "h":
          return intUnit(oneOrTwo);
        case "mm":
          return intUnit(two);
        case "m":
          return intUnit(oneOrTwo);
        case "q":
          return intUnit(oneOrTwo);
        case "qq":
          return intUnit(two);
        case "s":
          return intUnit(oneOrTwo);
        case "ss":
          return intUnit(two);
        case "S":
          return intUnit(oneToThree);
        case "SSS":
          return intUnit(three);
        case "u":
          return simple(oneToNine);
        case "uu":
          return simple(oneOrTwo);
        case "uuu":
          return intUnit(one);
        // meridiem
        case "a":
          return oneOf(loc.meridiems(), 0);
        // weekYear (k)
        case "kkkk":
          return intUnit(four);
        case "kk":
          return intUnit(twoToFour, untruncateYear);
        // weekNumber (W)
        case "W":
          return intUnit(oneOrTwo);
        case "WW":
          return intUnit(two);
        // weekdays
        case "E":
        case "c":
          return intUnit(one);
        case "EEE":
          return oneOf(loc.weekdays("short", false, false), 1);
        case "EEEE":
          return oneOf(loc.weekdays("long", false, false), 1);
        case "ccc":
          return oneOf(loc.weekdays("short", true, false), 1);
        case "cccc":
          return oneOf(loc.weekdays("long", true, false), 1);
        // offset/zone
        case "Z":
        case "ZZ":
          return offset(new RegExp(`([+-]${oneOrTwo.source})(?::(${two.source}))?`), 2);
        case "ZZZ":
          return offset(new RegExp(`([+-]${oneOrTwo.source})(${two.source})?`), 2);
        // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
        // because we don't have any way to figure out what they are
        case "z":
          return simple(/[a-z_+-/]{1,256}?/i);
        default:
          return literal(t);
      }
    };

  const unit = unitate(token) || {
    invalidReason: MISSING_FTP,
  };

  unit.token = token;

  return unit;
}

const partTypeStyleToTokenVal = {
  year: {
    "2-digit": "yy",
    numeric: "yyyyy",
  },
  month: {
    numeric: "M",
    "2-digit": "MM",
    short: "MMM",
    long: "MMMM",
  },
  day: {
    numeric: "d",
    "2-digit": "dd",
  },
  weekday: {
    short: "EEE",
    long: "EEEE",
  },
  dayperiod: "a",
  dayPeriod: "a",
  hour: {
    numeric: "h",
    "2-digit": "hh",
  },
  minute: {
    numeric: "m",
    "2-digit": "mm",
  },
  second: {
    numeric: "s",
    "2-digit": "ss",
  },
};

function tokenForPart(part, locale, formatOpts) {
  const { type, value } = part;

  if (type === "literal") {
    return {
      literal: true,
      val: value,
    };
  }

  const style = formatOpts[type];

  let val = partTypeStyleToTokenVal[type];
  if (typeof val === "object") {
    val = val[style];
  }

  if (val) {
    return {
      literal: false,
      val,
    };
  }

  return undefined;
}

function buildRegex(units) {
  const re = units.map((u) => u.regex).reduce((f, r) => `${f}(${r.source})`, "");
  return [`^${re}$`, units];
}

function match(input, regex, handlers) {
  const matches = input.match(regex);

  if (matches) {
    const all = {};
    let matchIndex = 1;
    for (const i in handlers) {
      if (hasOwnProperty(handlers, i)) {
        const h = handlers[i],
          groups = h.groups ? h.groups + 1 : 1;
        if (!h.literal && h.token) {
          all[h.token.val[0]] = h.deser(matches.slice(matchIndex, matchIndex + groups));
        }
        matchIndex += groups;
      }
    }
    return [matches, all];
  } else {
    return [matches, {}];
  }
}

function dateTimeFromMatches(matches) {
  const toField = (token) => {
    switch (token) {
      case "S":
        return "millisecond";
      case "s":
        return "second";
      case "m":
        return "minute";
      case "h":
      case "H":
        return "hour";
      case "d":
        return "day";
      case "o":
        return "ordinal";
      case "L":
      case "M":
        return "month";
      case "y":
        return "year";
      case "E":
      case "c":
        return "weekday";
      case "W":
        return "weekNumber";
      case "k":
        return "weekYear";
      case "q":
        return "quarter";
      default:
        return null;
    }
  };

  let zone = null;
  let specificOffset;
  if (!isUndefined(matches.z)) {
    zone = IANAZone.create(matches.z);
  }

  if (!isUndefined(matches.Z)) {
    if (!zone) {
      zone = new FixedOffsetZone(matches.Z);
    }
    specificOffset = matches.Z;
  }

  if (!isUndefined(matches.q)) {
    matches.M = (matches.q - 1) * 3 + 1;
  }

  if (!isUndefined(matches.h)) {
    if (matches.h < 12 && matches.a === 1) {
      matches.h += 12;
    } else if (matches.h === 12 && matches.a === 0) {
      matches.h = 0;
    }
  }

  if (matches.G === 0 && matches.y) {
    matches.y = -matches.y;
  }

  if (!isUndefined(matches.u)) {
    matches.S = parseMillis(matches.u);
  }

  const vals = Object.keys(matches).reduce((r, k) => {
    const f = toField(k);
    if (f) {
      r[f] = matches[k];
    }

    return r;
  }, {});

  return [vals, zone, specificOffset];
}

let dummyDateTimeCache = null;

function getDummyDateTime() {
  if (!dummyDateTimeCache) {
    dummyDateTimeCache = DateTime.fromMillis(1555555555555);
  }

  return dummyDateTimeCache;
}

function maybeExpandMacroToken(token, locale) {
  if (token.literal) {
    return token;
  }

  const formatOpts = Formatter.macroTokenToFormatOpts(token.val);

  if (!formatOpts) {
    return token;
  }

  const formatter = Formatter.create(locale, formatOpts);
  const parts = formatter.formatDateTimeParts(getDummyDateTime());

  const tokens = parts.map((p) => tokenForPart(p, locale, formatOpts));

  if (tokens.includes(undefined)) {
    return token;
  }

  return tokens;
}

function expandMacroTokens(tokens, locale) {
  return Array.prototype.concat(...tokens.map((t) => maybeExpandMacroToken(t, locale)));
}

/**
 * @private
 */

function explainFromTokens(locale, input, format) {
  const tokens = expandMacroTokens(Formatter.parseFormat(format), locale),
    units = tokens.map((t) => unitForToken(t, locale)),
    disqualifyingUnit = units.find((t) => t.invalidReason);

  if (disqualifyingUnit) {
    return { input, tokens, invalidReason: disqualifyingUnit.invalidReason };
  } else {
    const [regexString, handlers] = buildRegex(units),
      regex = RegExp(regexString, "i"),
      [rawMatches, matches] = match(input, regex, handlers),
      [result, zone, specificOffset] = matches
        ? dateTimeFromMatches(matches)
        : [null, null, undefined];
    if (hasOwnProperty(matches, "a") && hasOwnProperty(matches, "H")) {
      throw new ConflictingSpecificationError(
        "Can't include meridiem when specifying 24-hour format"
      );
    }
    return { input, tokens, regex, rawMatches, matches, result, zone, specificOffset };
  }
}

function parseFromTokens(locale, input, format) {
  const { result, zone, specificOffset, invalidReason } = explainFromTokens(locale, input, format);
  return [result, zone, specificOffset, invalidReason];
}

const nonLeapLadder = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334],
  leapLadder = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];

function unitOutOfRange(unit, value) {
  return new Invalid(
    "unit out of range",
    `you specified ${value} (of type ${typeof value}) as a ${unit}, which is invalid`
  );
}

function dayOfWeek(year, month, day) {
  const js = new Date(Date.UTC(year, month - 1, day)).getUTCDay();
  return js === 0 ? 7 : js;
}

function computeOrdinal(year, month, day) {
  return day + (isLeapYear(year) ? leapLadder : nonLeapLadder)[month - 1];
}

function uncomputeOrdinal(year, ordinal) {
  const table = isLeapYear(year) ? leapLadder : nonLeapLadder,
    month0 = table.findIndex((i) => i < ordinal),
    day = ordinal - table[month0];
  return { month: month0 + 1, day };
}

/**
 * @private
 */

function gregorianToWeek(gregObj) {
  const { year, month, day } = gregObj,
    ordinal = computeOrdinal(year, month, day),
    weekday = dayOfWeek(year, month, day);

  let weekNumber = Math.floor((ordinal - weekday + 10) / 7),
    weekYear;

  if (weekNumber < 1) {
    weekYear = year - 1;
    weekNumber = weeksInWeekYear(weekYear);
  } else if (weekNumber > weeksInWeekYear(year)) {
    weekYear = year + 1;
    weekNumber = 1;
  } else {
    weekYear = year;
  }

  return { weekYear, weekNumber, weekday, ...timeObject(gregObj) };
}

function weekToGregorian(weekData) {
  const { weekYear, weekNumber, weekday } = weekData,
    weekdayOfJan4 = dayOfWeek(weekYear, 1, 4),
    yearInDays = daysInYear(weekYear);

  let ordinal = weekNumber * 7 + weekday - weekdayOfJan4 - 3,
    year;

  if (ordinal < 1) {
    year = weekYear - 1;
    ordinal += daysInYear(year);
  } else if (ordinal > yearInDays) {
    year = weekYear + 1;
    ordinal -= daysInYear(weekYear);
  } else {
    year = weekYear;
  }

  const { month, day } = uncomputeOrdinal(year, ordinal);
  return { year, month, day, ...timeObject(weekData) };
}

function gregorianToOrdinal(gregData) {
  const { year, month, day } = gregData;
  const ordinal = computeOrdinal(year, month, day);
  return { year, ordinal, ...timeObject(gregData) };
}

function ordinalToGregorian(ordinalData) {
  const { year, ordinal } = ordinalData;
  const { month, day } = uncomputeOrdinal(year, ordinal);
  return { year, month, day, ...timeObject(ordinalData) };
}

function hasInvalidWeekData(obj) {
  const validYear = isInteger(obj.weekYear),
    validWeek = integerBetween(obj.weekNumber, 1, weeksInWeekYear(obj.weekYear)),
    validWeekday = integerBetween(obj.weekday, 1, 7);

  if (!validYear) {
    return unitOutOfRange("weekYear", obj.weekYear);
  } else if (!validWeek) {
    return unitOutOfRange("week", obj.week);
  } else if (!validWeekday) {
    return unitOutOfRange("weekday", obj.weekday);
  } else return false;
}

function hasInvalidOrdinalData(obj) {
  const validYear = isInteger(obj.year),
    validOrdinal = integerBetween(obj.ordinal, 1, daysInYear(obj.year));

  if (!validYear) {
    return unitOutOfRange("year", obj.year);
  } else if (!validOrdinal) {
    return unitOutOfRange("ordinal", obj.ordinal);
  } else return false;
}

function hasInvalidGregorianData(obj) {
  const validYear = isInteger(obj.year),
    validMonth = integerBetween(obj.month, 1, 12),
    validDay = integerBetween(obj.day, 1, daysInMonth(obj.year, obj.month));

  if (!validYear) {
    return unitOutOfRange("year", obj.year);
  } else if (!validMonth) {
    return unitOutOfRange("month", obj.month);
  } else if (!validDay) {
    return unitOutOfRange("day", obj.day);
  } else return false;
}

function hasInvalidTimeData(obj) {
  const { hour, minute, second, millisecond } = obj;
  const validHour =
      integerBetween(hour, 0, 23) ||
      (hour === 24 && minute === 0 && second === 0 && millisecond === 0),
    validMinute = integerBetween(minute, 0, 59),
    validSecond = integerBetween(second, 0, 59),
    validMillisecond = integerBetween(millisecond, 0, 999);

  if (!validHour) {
    return unitOutOfRange("hour", hour);
  } else if (!validMinute) {
    return unitOutOfRange("minute", minute);
  } else if (!validSecond) {
    return unitOutOfRange("second", second);
  } else if (!validMillisecond) {
    return unitOutOfRange("millisecond", millisecond);
  } else return false;
}

const INVALID = "Invalid DateTime";
const MAX_DATE = 8.64e15;

function unsupportedZone(zone) {
  return new Invalid("unsupported zone", `the zone "${zone.name}" is not supported`);
}

// we cache week data on the DT object and this intermediates the cache
function possiblyCachedWeekData(dt) {
  if (dt.weekData === null) {
    dt.weekData = gregorianToWeek(dt.c);
  }
  return dt.weekData;
}

// clone really means, "make a new object with these modifications". all "setters" really use this
// to create a new object while only changing some of the properties
function clone(inst, alts) {
  const current = {
    ts: inst.ts,
    zone: inst.zone,
    c: inst.c,
    o: inst.o,
    loc: inst.loc,
    invalid: inst.invalid,
  };
  return new DateTime({ ...current, ...alts, old: current });
}

// find the right offset a given local time. The o input is our guess, which determines which
// offset we'll pick in ambiguous cases (e.g. there are two 3 AMs b/c Fallback DST)
function fixOffset(localTS, o, tz) {
  // Our UTC time is just a guess because our offset is just a guess
  let utcGuess = localTS - o * 60 * 1000;

  // Test whether the zone matches the offset for this ts
  const o2 = tz.offset(utcGuess);

  // If so, offset didn't change and we're done
  if (o === o2) {
    return [utcGuess, o];
  }

  // If not, change the ts by the difference in the offset
  utcGuess -= (o2 - o) * 60 * 1000;

  // If that gives us the local time we want, we're done
  const o3 = tz.offset(utcGuess);
  if (o2 === o3) {
    return [utcGuess, o2];
  }

  // If it's different, we're in a hole time. The offset has changed, but the we don't adjust the time
  return [localTS - Math.min(o2, o3) * 60 * 1000, Math.max(o2, o3)];
}

// convert an epoch timestamp into a calendar object with the given offset
function tsToObj(ts, offset) {
  ts += offset * 60 * 1000;

  const d = new Date(ts);

  return {
    year: d.getUTCFullYear(),
    month: d.getUTCMonth() + 1,
    day: d.getUTCDate(),
    hour: d.getUTCHours(),
    minute: d.getUTCMinutes(),
    second: d.getUTCSeconds(),
    millisecond: d.getUTCMilliseconds(),
  };
}

// convert a calendar object to a epoch timestamp
function objToTS(obj, offset, zone) {
  return fixOffset(objToLocalTS(obj), offset, zone);
}

// create a new DT instance by adding a duration, adjusting for DSTs
function adjustTime(inst, dur) {
  const oPre = inst.o,
    year = inst.c.year + Math.trunc(dur.years),
    month = inst.c.month + Math.trunc(dur.months) + Math.trunc(dur.quarters) * 3,
    c = {
      ...inst.c,
      year,
      month,
      day:
        Math.min(inst.c.day, daysInMonth(year, month)) +
        Math.trunc(dur.days) +
        Math.trunc(dur.weeks) * 7,
    },
    millisToAdd = Duration.fromObject({
      years: dur.years - Math.trunc(dur.years),
      quarters: dur.quarters - Math.trunc(dur.quarters),
      months: dur.months - Math.trunc(dur.months),
      weeks: dur.weeks - Math.trunc(dur.weeks),
      days: dur.days - Math.trunc(dur.days),
      hours: dur.hours,
      minutes: dur.minutes,
      seconds: dur.seconds,
      milliseconds: dur.milliseconds,
    }).as("milliseconds"),
    localTS = objToLocalTS(c);

  let [ts, o] = fixOffset(localTS, oPre, inst.zone);

  if (millisToAdd !== 0) {
    ts += millisToAdd;
    // that could have changed the offset by going over a DST, but we want to keep the ts the same
    o = inst.zone.offset(ts);
  }

  return { ts, o };
}

// helper useful in turning the results of parsing into real dates
// by handling the zone options
function parseDataToDateTime(parsed, parsedZone, opts, format, text, specificOffset) {
  const { setZone, zone } = opts;
  if (parsed && Object.keys(parsed).length !== 0) {
    const interpretationZone = parsedZone || zone,
      inst = DateTime.fromObject(parsed, {
        ...opts,
        zone: interpretationZone,
        specificOffset,
      });
    return setZone ? inst : inst.setZone(zone);
  } else {
    return DateTime.invalid(
      new Invalid("unparsable", `the input "${text}" can't be parsed as ${format}`)
    );
  }
}

// if you want to output a technical format (e.g. RFC 2822), this helper
// helps handle the details
function toTechFormat(dt, format, allowZ = true) {
  return dt.isValid
    ? Formatter.create(Locale.create("en-US"), {
        allowZ,
        forceSimple: true,
      }).formatDateTimeFromString(dt, format)
    : null;
}

function toISODate(o, extended) {
  const longFormat = o.c.year > 9999 || o.c.year < 0;
  let c = "";
  if (longFormat && o.c.year >= 0) c += "+";
  c += padStart(o.c.year, longFormat ? 6 : 4);

  if (extended) {
    c += "-";
    c += padStart(o.c.month);
    c += "-";
    c += padStart(o.c.day);
  } else {
    c += padStart(o.c.month);
    c += padStart(o.c.day);
  }
  return c;
}

function toISOTime(o, extended, suppressSeconds, suppressMilliseconds, includeOffset) {
  let c = padStart(o.c.hour);
  if (extended) {
    c += ":";
    c += padStart(o.c.minute);
    if (o.c.second !== 0 || !suppressSeconds) {
      c += ":";
    }
  } else {
    c += padStart(o.c.minute);
  }

  if (o.c.second !== 0 || !suppressSeconds) {
    c += padStart(o.c.second);

    if (o.c.millisecond !== 0 || !suppressMilliseconds) {
      c += ".";
      c += padStart(o.c.millisecond, 3);
    }
  }

  if (includeOffset) {
    if (o.isOffsetFixed && o.offset === 0) {
      c += "Z";
    } else if (o.o < 0) {
      c += "-";
      c += padStart(Math.trunc(-o.o / 60));
      c += ":";
      c += padStart(Math.trunc(-o.o % 60));
    } else {
      c += "+";
      c += padStart(Math.trunc(o.o / 60));
      c += ":";
      c += padStart(Math.trunc(o.o % 60));
    }
  }
  return c;
}

// defaults for unspecified units in the supported calendars
const defaultUnitValues = {
    month: 1,
    day: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0,
  },
  defaultWeekUnitValues = {
    weekNumber: 1,
    weekday: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0,
  },
  defaultOrdinalUnitValues = {
    ordinal: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0,
  };

// Units in the supported calendars, sorted by bigness
const orderedUnits = ["year", "month", "day", "hour", "minute", "second", "millisecond"],
  orderedWeekUnits = [
    "weekYear",
    "weekNumber",
    "weekday",
    "hour",
    "minute",
    "second",
    "millisecond",
  ],
  orderedOrdinalUnits = ["year", "ordinal", "hour", "minute", "second", "millisecond"];

// standardize case and plurality in units
function normalizeUnit(unit) {
  const normalized = {
    year: "year",
    years: "year",
    month: "month",
    months: "month",
    day: "day",
    days: "day",
    hour: "hour",
    hours: "hour",
    minute: "minute",
    minutes: "minute",
    quarter: "quarter",
    quarters: "quarter",
    second: "second",
    seconds: "second",
    millisecond: "millisecond",
    milliseconds: "millisecond",
    weekday: "weekday",
    weekdays: "weekday",
    weeknumber: "weekNumber",
    weeksnumber: "weekNumber",
    weeknumbers: "weekNumber",
    weekyear: "weekYear",
    weekyears: "weekYear",
    ordinal: "ordinal",
  }[unit.toLowerCase()];

  if (!normalized) throw new InvalidUnitError(unit);

  return normalized;
}

// this is a dumbed down version of fromObject() that runs about 60% faster
// but doesn't do any validation, makes a bunch of assumptions about what units
// are present, and so on.

// this is a dumbed down version of fromObject() that runs about 60% faster
// but doesn't do any validation, makes a bunch of assumptions about what units
// are present, and so on.
function quickDT(obj, opts) {
  const zone = normalizeZone(opts.zone, Settings.defaultZone),
    loc = Locale.fromObject(opts),
    tsNow = Settings.now();

  let ts, o;

  // assume we have the higher-order units
  if (!isUndefined(obj.year)) {
    for (const u of orderedUnits) {
      if (isUndefined(obj[u])) {
        obj[u] = defaultUnitValues[u];
      }
    }

    const invalid = hasInvalidGregorianData(obj) || hasInvalidTimeData(obj);
    if (invalid) {
      return DateTime.invalid(invalid);
    }

    const offsetProvis = zone.offset(tsNow);
    [ts, o] = objToTS(obj, offsetProvis, zone);
  } else {
    ts = tsNow;
  }

  return new DateTime({ ts, zone, loc, o });
}

function diffRelative(start, end, opts) {
  const round = isUndefined(opts.round) ? true : opts.round,
    format = (c, unit) => {
      c = roundTo(c, round || opts.calendary ? 0 : 2, true);
      const formatter = end.loc.clone(opts).relFormatter(opts);
      return formatter.format(c, unit);
    },
    differ = (unit) => {
      if (opts.calendary) {
        if (!end.hasSame(start, unit)) {
          return end.startOf(unit).diff(start.startOf(unit), unit).get(unit);
        } else return 0;
      } else {
        return end.diff(start, unit).get(unit);
      }
    };

  if (opts.unit) {
    return format(differ(opts.unit), opts.unit);
  }

  for (const unit of opts.units) {
    const count = differ(unit);
    if (Math.abs(count) >= 1) {
      return format(count, unit);
    }
  }
  return format(start > end ? -0 : 0, opts.units[opts.units.length - 1]);
}

function lastOpts(argList) {
  let opts = {},
    args;
  if (argList.length > 0 && typeof argList[argList.length - 1] === "object") {
    opts = argList[argList.length - 1];
    args = Array.from(argList).slice(0, argList.length - 1);
  } else {
    args = Array.from(argList);
  }
  return [opts, args];
}

/**
 * A DateTime is an immutable data structure representing a specific date and time and accompanying methods. It contains class and instance methods for creating, parsing, interrogating, transforming, and formatting them.
 *
 * A DateTime comprises of:
 * * A timestamp. Each DateTime instance refers to a specific millisecond of the Unix epoch.
 * * A time zone. Each instance is considered in the context of a specific zone (by default the local system's zone).
 * * Configuration properties that effect how output strings are formatted, such as `locale`, `numberingSystem`, and `outputCalendar`.
 *
 * Here is a brief overview of the most commonly used functionality it provides:
 *
 * * **Creation**: To create a DateTime from its components, use one of its factory class methods: {@link DateTime#local}, {@link DateTime#utc}, and (most flexibly) {@link DateTime#fromObject}. To create one from a standard string format, use {@link DateTime#fromISO}, {@link DateTime#fromHTTP}, and {@link DateTime#fromRFC2822}. To create one from a custom string format, use {@link DateTime#fromFormat}. To create one from a native JS date, use {@link DateTime#fromJSDate}.
 * * **Gregorian calendar and time**: To examine the Gregorian properties of a DateTime individually (i.e as opposed to collectively through {@link DateTime#toObject}), use the {@link DateTime#year}, {@link DateTime#month},
 * {@link DateTime#day}, {@link DateTime#hour}, {@link DateTime#minute}, {@link DateTime#second}, {@link DateTime#millisecond} accessors.
 * * **Week calendar**: For ISO week calendar attributes, see the {@link DateTime#weekYear}, {@link DateTime#weekNumber}, and {@link DateTime#weekday} accessors.
 * * **Configuration** See the {@link DateTime#locale} and {@link DateTime#numberingSystem} accessors.
 * * **Transformation**: To transform the DateTime into other DateTimes, use {@link DateTime#set}, {@link DateTime#reconfigure}, {@link DateTime#setZone}, {@link DateTime#setLocale}, {@link DateTime.plus}, {@link DateTime#minus}, {@link DateTime#endOf}, {@link DateTime#startOf}, {@link DateTime#toUTC}, and {@link DateTime#toLocal}.
 * * **Output**: To convert the DateTime to other representations, use the {@link DateTime#toRelative}, {@link DateTime#toRelativeCalendar}, {@link DateTime#toJSON}, {@link DateTime#toISO}, {@link DateTime#toHTTP}, {@link DateTime#toObject}, {@link DateTime#toRFC2822}, {@link DateTime#toString}, {@link DateTime#toLocaleString}, {@link DateTime#toFormat}, {@link DateTime#toMillis} and {@link DateTime#toJSDate}.
 *
 * There's plenty others documented below. In addition, for more information on subtler topics like internationalization, time zones, alternative calendars, validity, and so on, see the external documentation.
 */
class DateTime {
  /**
   * @access private
   */
  constructor(config) {
    const zone = config.zone || Settings.defaultZone;

    let invalid =
      config.invalid ||
      (Number.isNaN(config.ts) ? new Invalid("invalid input") : null) ||
      (!zone.isValid ? unsupportedZone(zone) : null);
    /**
     * @access private
     */
    this.ts = isUndefined(config.ts) ? Settings.now() : config.ts;

    let c = null,
      o = null;
    if (!invalid) {
      const unchanged = config.old && config.old.ts === this.ts && config.old.zone.equals(zone);

      if (unchanged) {
        [c, o] = [config.old.c, config.old.o];
      } else {
        const ot = zone.offset(this.ts);
        c = tsToObj(this.ts, ot);
        invalid = Number.isNaN(c.year) ? new Invalid("invalid input") : null;
        c = invalid ? null : c;
        o = invalid ? null : ot;
      }
    }

    /**
     * @access private
     */
    this._zone = zone;
    /**
     * @access private
     */
    this.loc = config.loc || Locale.create();
    /**
     * @access private
     */
    this.invalid = invalid;
    /**
     * @access private
     */
    this.weekData = null;
    /**
     * @access private
     */
    this.c = c;
    /**
     * @access private
     */
    this.o = o;
    /**
     * @access private
     */
    this.isLuxonDateTime = true;
  }

  // CONSTRUCT

  /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */
  static now() {
    return new DateTime({});
  }

  /**
   * Create a local DateTime
   * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month, 1-indexed
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.local()                                  //~> now
   * @example DateTime.local({ zone: "America/New_York" })      //~> now, in US east coast time
   * @example DateTime.local(2017)                              //~> 2017-01-01T00:00:00
   * @example DateTime.local(2017, 3)                           //~> 2017-03-01T00:00:00
   * @example DateTime.local(2017, 3, 12, { locale: "fr" })     //~> 2017-03-12T00:00:00, with a French locale
   * @example DateTime.local(2017, 3, 12, 5)                    //~> 2017-03-12T05:00:00
   * @example DateTime.local(2017, 3, 12, 5, { zone: "utc" })   //~> 2017-03-12T05:00:00, in UTC
   * @example DateTime.local(2017, 3, 12, 5, 45)                //~> 2017-03-12T05:45:00
   * @example DateTime.local(2017, 3, 12, 5, 45, 10)            //~> 2017-03-12T05:45:10
   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765)       //~> 2017-03-12T05:45:10.765
   * @return {DateTime}
   */
  static local() {
    const [opts, args] = lastOpts(arguments),
      [year, month, day, hour, minute, second, millisecond] = args;
    return quickDT({ year, month, day, hour, minute, second, millisecond }, opts);
  }

  /**
   * Create a DateTime in UTC
   * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @param {Object} options - configuration options for the DateTime
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} [options.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [options.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @example DateTime.utc()                                              //~> now
   * @example DateTime.utc(2017)                                          //~> 2017-01-01T00:00:00Z
   * @example DateTime.utc(2017, 3)                                       //~> 2017-03-01T00:00:00Z
   * @example DateTime.utc(2017, 3, 12)                                   //~> 2017-03-12T00:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5)                                //~> 2017-03-12T05:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45)                            //~> 2017-03-12T05:45:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, { locale: "fr" })          //~> 2017-03-12T05:45:00Z with a French locale
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)                        //~> 2017-03-12T05:45:10Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765, { locale: "fr" }) //~> 2017-03-12T05:45:10.765Z with a French locale
   * @return {DateTime}
   */
  static utc() {
    const [opts, args] = lastOpts(arguments),
      [year, month, day, hour, minute, second, millisecond] = args;

    opts.zone = FixedOffsetZone.utcInstance;
    return quickDT({ year, month, day, hour, minute, second, millisecond }, opts);
  }

  /**
   * Create a DateTime from a JavaScript Date object. Uses the default zone.
   * @param {Date} date - a JavaScript Date object
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @return {DateTime}
   */
  static fromJSDate(date, options = {}) {
    const ts = isDate(date) ? date.valueOf() : NaN;
    if (Number.isNaN(ts)) {
      return DateTime.invalid("invalid input");
    }

    const zoneToUse = normalizeZone(options.zone, Settings.defaultZone);
    if (!zoneToUse.isValid) {
      return DateTime.invalid(unsupportedZone(zoneToUse));
    }

    return new DateTime({
      ts: ts,
      zone: zoneToUse,
      loc: Locale.fromObject(options),
    });
  }

  /**
   * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromMillis(milliseconds, options = {}) {
    if (!isNumber(milliseconds)) {
      throw new InvalidArgumentError(
        `fromMillis requires a numerical input, but received a ${typeof milliseconds} with value ${milliseconds}`
      );
    } else if (milliseconds < -MAX_DATE || milliseconds > MAX_DATE) {
      // this isn't perfect because because we can still end up out of range because of additional shifting, but it's a start
      return DateTime.invalid("Timestamp out of range");
    } else {
      return new DateTime({
        ts: milliseconds,
        zone: normalizeZone(options.zone, Settings.defaultZone),
        loc: Locale.fromObject(options),
      });
    }
  }

  /**
   * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} seconds - a number of seconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromSeconds(seconds, options = {}) {
    if (!isNumber(seconds)) {
      throw new InvalidArgumentError("fromSeconds requires a numerical input");
    } else {
      return new DateTime({
        ts: seconds * 1000,
        zone: normalizeZone(options.zone, Settings.defaultZone),
        loc: Locale.fromObject(options),
      });
    }
  }

  /**
   * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.year - a year, such as 1987
   * @param {number} obj.month - a month, 1-12
   * @param {number} obj.day - a day of the month, 1-31, depending on the month
   * @param {number} obj.ordinal - day of the year, 1-365 or 366
   * @param {number} obj.weekYear - an ISO week year
   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
   * @param {number} obj.hour - hour of the day, 0-23
   * @param {number} obj.minute - minute of the hour, 0-59
   * @param {number} obj.second - second of the minute, 0-59
   * @param {number} obj.millisecond - millisecond of the second, 0-999
   * @param {Object} opts - options for creating this DateTime
   * @param {string|Zone} [opts.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'utc' }),
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'local' })
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'America/New_York' })
   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
   * @return {DateTime}
   */
  static fromObject(obj, opts = {}) {
    obj = obj || {};
    const zoneToUse = normalizeZone(opts.zone, Settings.defaultZone);
    if (!zoneToUse.isValid) {
      return DateTime.invalid(unsupportedZone(zoneToUse));
    }

    const tsNow = Settings.now(),
      offsetProvis = !isUndefined(opts.specificOffset)
        ? opts.specificOffset
        : zoneToUse.offset(tsNow),
      normalized = normalizeObject(obj, normalizeUnit),
      containsOrdinal = !isUndefined(normalized.ordinal),
      containsGregorYear = !isUndefined(normalized.year),
      containsGregorMD = !isUndefined(normalized.month) || !isUndefined(normalized.day),
      containsGregor = containsGregorYear || containsGregorMD,
      definiteWeekDef = normalized.weekYear || normalized.weekNumber,
      loc = Locale.fromObject(opts);

    // cases:
    // just a weekday -> this week's instance of that weekday, no worries
    // (gregorian data or ordinal) + (weekYear or weekNumber) -> error
    // (gregorian month or day) + ordinal -> error
    // otherwise just use weeks or ordinals or gregorian, depending on what's specified

    if ((containsGregor || containsOrdinal) && definiteWeekDef) {
      throw new ConflictingSpecificationError(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    }

    if (containsGregorMD && containsOrdinal) {
      throw new ConflictingSpecificationError("Can't mix ordinal dates with month/day");
    }

    const useWeekData = definiteWeekDef || (normalized.weekday && !containsGregor);

    // configure ourselves to deal with gregorian dates or week stuff
    let units,
      defaultValues,
      objNow = tsToObj(tsNow, offsetProvis);
    if (useWeekData) {
      units = orderedWeekUnits;
      defaultValues = defaultWeekUnitValues;
      objNow = gregorianToWeek(objNow);
    } else if (containsOrdinal) {
      units = orderedOrdinalUnits;
      defaultValues = defaultOrdinalUnitValues;
      objNow = gregorianToOrdinal(objNow);
    } else {
      units = orderedUnits;
      defaultValues = defaultUnitValues;
    }

    // set default values for missing stuff
    let foundFirst = false;
    for (const u of units) {
      const v = normalized[u];
      if (!isUndefined(v)) {
        foundFirst = true;
      } else if (foundFirst) {
        normalized[u] = defaultValues[u];
      } else {
        normalized[u] = objNow[u];
      }
    }

    // make sure the values we have are in range
    const higherOrderInvalid = useWeekData
        ? hasInvalidWeekData(normalized)
        : containsOrdinal
        ? hasInvalidOrdinalData(normalized)
        : hasInvalidGregorianData(normalized),
      invalid = higherOrderInvalid || hasInvalidTimeData(normalized);

    if (invalid) {
      return DateTime.invalid(invalid);
    }

    // compute the actual time
    const gregorian = useWeekData
        ? weekToGregorian(normalized)
        : containsOrdinal
        ? ordinalToGregorian(normalized)
        : normalized,
      [tsFinal, offsetFinal] = objToTS(gregorian, offsetProvis, zoneToUse),
      inst = new DateTime({
        ts: tsFinal,
        zone: zoneToUse,
        o: offsetFinal,
        loc,
      });

    // gregorian data + weekday serves only to validate
    if (normalized.weekday && containsGregor && obj.weekday !== inst.weekday) {
      return DateTime.invalid(
        "mismatched weekday",
        `you can't specify both a weekday of ${normalized.weekday} and a date of ${inst.toISO()}`
      );
    }

    return inst;
  }

  /**
   * Create a DateTime from an ISO 8601 string
   * @param {string} text - the ISO string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
   * @example DateTime.fromISO('2016-W05-4')
   * @return {DateTime}
   */
  static fromISO(text, opts = {}) {
    const [vals, parsedZone] = parseISODate(text);
    return parseDataToDateTime(vals, parsedZone, opts, "ISO 8601", text);
  }

  /**
   * Create a DateTime from an RFC 2822 string
   * @param {string} text - the RFC 2822 string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
   * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
   * @return {DateTime}
   */
  static fromRFC2822(text, opts = {}) {
    const [vals, parsedZone] = parseRFC2822Date(text);
    return parseDataToDateTime(vals, parsedZone, opts, "RFC 2822", text);
  }

  /**
   * Create a DateTime from an HTTP header date
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @param {string} text - the HTTP header date
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
   * @return {DateTime}
   */
  static fromHTTP(text, opts = {}) {
    const [vals, parsedZone] = parseHTTPDate(text);
    return parseDataToDateTime(vals, parsedZone, opts, "HTTP", opts);
  }

  /**
   * Create a DateTime from an input string and format string.
   * Defaults to en-US if no locale has been specified, regardless of the system's locale. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromFormat(text, fmt, opts = {}) {
    if (isUndefined(text) || isUndefined(fmt)) {
      throw new InvalidArgumentError("fromFormat requires an input string and a format");
    }

    const { locale = null, numberingSystem = null } = opts,
      localeToUse = Locale.fromOpts({
        locale,
        numberingSystem,
        defaultToEN: true,
      }),
      [vals, parsedZone, specificOffset, invalid] = parseFromTokens(localeToUse, text, fmt);
    if (invalid) {
      return DateTime.invalid(invalid);
    } else {
      return parseDataToDateTime(vals, parsedZone, opts, `format ${fmt}`, text, specificOffset);
    }
  }

  /**
   * @deprecated use fromFormat instead
   */
  static fromString(text, fmt, opts = {}) {
    return DateTime.fromFormat(text, fmt, opts);
  }

  /**
   * Create a DateTime from a SQL date, time, or datetime
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} text - the string to parse
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @example DateTime.fromSQL('2017-05-15')
   * @example DateTime.fromSQL('2017-05-15 09:12:34')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
   * @example DateTime.fromSQL('09:12:34.342')
   * @return {DateTime}
   */
  static fromSQL(text, opts = {}) {
    const [vals, parsedZone] = parseSQL(text);
    return parseDataToDateTime(vals, parsedZone, opts, "SQL", text);
  }

  /**
   * Create an invalid DateTime.
   * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {DateTime}
   */
  static invalid(reason, explanation = null) {
    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the DateTime is invalid");
    }

    const invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);

    if (Settings.throwOnInvalid) {
      throw new InvalidDateTimeError(invalid);
    } else {
      return new DateTime({ invalid });
    }
  }

  /**
   * Check if an object is a DateTime. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDateTime(o) {
    return (o && o.isLuxonDateTime) || false;
  }

  // INFO

  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
   * @return {number}
   */
  get(unit) {
    return this[unit];
  }

  /**
   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
   * * The DateTime was created by an operation on another invalid date
   * @type {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }

  /**
   * Returns an error code if this DateTime is invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }

  /**
   * Returns an explanation of why this DateTime became invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }

  /**
   * Get the locale of a DateTime, such 'en-GB'. The locale is used when formatting the DateTime
   *
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }

  /**
   * Get the numbering system of a DateTime, such 'beng'. The numbering system is used when formatting the DateTime
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }

  /**
   * Get the output calendar of a DateTime, such 'islamic'. The output calendar is used when formatting the DateTime
   *
   * @type {string}
   */
  get outputCalendar() {
    return this.isValid ? this.loc.outputCalendar : null;
  }

  /**
   * Get the time zone associated with this DateTime.
   * @type {Zone}
   */
  get zone() {
    return this._zone;
  }

  /**
   * Get the name of the time zone.
   * @type {string}
   */
  get zoneName() {
    return this.isValid ? this.zone.name : null;
  }

  /**
   * Get the year
   * @example DateTime.local(2017, 5, 25).year //=> 2017
   * @type {number}
   */
  get year() {
    return this.isValid ? this.c.year : NaN;
  }

  /**
   * Get the quarter
   * @example DateTime.local(2017, 5, 25).quarter //=> 2
   * @type {number}
   */
  get quarter() {
    return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
  }

  /**
   * Get the month (1-12).
   * @example DateTime.local(2017, 5, 25).month //=> 5
   * @type {number}
   */
  get month() {
    return this.isValid ? this.c.month : NaN;
  }

  /**
   * Get the day of the month (1-30ish).
   * @example DateTime.local(2017, 5, 25).day //=> 25
   * @type {number}
   */
  get day() {
    return this.isValid ? this.c.day : NaN;
  }

  /**
   * Get the hour of the day (0-23).
   * @example DateTime.local(2017, 5, 25, 9).hour //=> 9
   * @type {number}
   */
  get hour() {
    return this.isValid ? this.c.hour : NaN;
  }

  /**
   * Get the minute of the hour (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30).minute //=> 30
   * @type {number}
   */
  get minute() {
    return this.isValid ? this.c.minute : NaN;
  }

  /**
   * Get the second of the minute (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52).second //=> 52
   * @type {number}
   */
  get second() {
    return this.isValid ? this.c.second : NaN;
  }

  /**
   * Get the millisecond of the second (0-999).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52, 654).millisecond //=> 654
   * @type {number}
   */
  get millisecond() {
    return this.isValid ? this.c.millisecond : NaN;
  }

  /**
   * Get the week year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 12, 31).weekYear //=> 2015
   * @type {number}
   */
  get weekYear() {
    return this.isValid ? possiblyCachedWeekData(this).weekYear : NaN;
  }

  /**
   * Get the week number of the week year (1-52ish).
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2017, 5, 25).weekNumber //=> 21
   * @type {number}
   */
  get weekNumber() {
    return this.isValid ? possiblyCachedWeekData(this).weekNumber : NaN;
  }

  /**
   * Get the day of the week.
   * 1 is Monday and 7 is Sunday
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 11, 31).weekday //=> 4
   * @type {number}
   */
  get weekday() {
    return this.isValid ? possiblyCachedWeekData(this).weekday : NaN;
  }

  /**
   * Get the ordinal (meaning the day of the year)
   * @example DateTime.local(2017, 5, 25).ordinal //=> 145
   * @type {number|DateTime}
   */
  get ordinal() {
    return this.isValid ? gregorianToOrdinal(this.c).ordinal : NaN;
  }

  /**
   * Get the human readable short month name, such as 'Oct'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthShort //=> Oct
   * @type {string}
   */
  get monthShort() {
    return this.isValid ? Info.months("short", { locObj: this.loc })[this.month - 1] : null;
  }

  /**
   * Get the human readable long month name, such as 'October'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthLong //=> October
   * @type {string}
   */
  get monthLong() {
    return this.isValid ? Info.months("long", { locObj: this.loc })[this.month - 1] : null;
  }

  /**
   * Get the human readable short weekday, such as 'Mon'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayShort //=> Mon
   * @type {string}
   */
  get weekdayShort() {
    return this.isValid ? Info.weekdays("short", { locObj: this.loc })[this.weekday - 1] : null;
  }

  /**
   * Get the human readable long weekday, such as 'Monday'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayLong //=> Monday
   * @type {string}
   */
  get weekdayLong() {
    return this.isValid ? Info.weekdays("long", { locObj: this.loc })[this.weekday - 1] : null;
  }

  /**
   * Get the UTC offset of this DateTime in minutes
   * @example DateTime.now().offset //=> -240
   * @example DateTime.utc().offset //=> 0
   * @type {number}
   */
  get offset() {
    return this.isValid ? +this.o : NaN;
  }

  /**
   * Get the short human name for the zone's current offset, for example "EST" or "EDT".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameShort() {
    if (this.isValid) {
      return this.zone.offsetName(this.ts, {
        format: "short",
        locale: this.locale,
      });
    } else {
      return null;
    }
  }

  /**
   * Get the long human name for the zone's current offset, for example "Eastern Standard Time" or "Eastern Daylight Time".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameLong() {
    if (this.isValid) {
      return this.zone.offsetName(this.ts, {
        format: "long",
        locale: this.locale,
      });
    } else {
      return null;
    }
  }

  /**
   * Get whether this zone's offset ever changes, as in a DST.
   * @type {boolean}
   */
  get isOffsetFixed() {
    return this.isValid ? this.zone.isUniversal : null;
  }

  /**
   * Get whether the DateTime is in a DST.
   * @type {boolean}
   */
  get isInDST() {
    if (this.isOffsetFixed) {
      return false;
    } else {
      return (
        this.offset > this.set({ month: 1 }).offset || this.offset > this.set({ month: 5 }).offset
      );
    }
  }

  /**
   * Returns true if this DateTime is in a leap year, false otherwise
   * @example DateTime.local(2016).isInLeapYear //=> true
   * @example DateTime.local(2013).isInLeapYear //=> false
   * @type {boolean}
   */
  get isInLeapYear() {
    return isLeapYear(this.year);
  }

  /**
   * Returns the number of days in this DateTime's month
   * @example DateTime.local(2016, 2).daysInMonth //=> 29
   * @example DateTime.local(2016, 3).daysInMonth //=> 31
   * @type {number}
   */
  get daysInMonth() {
    return daysInMonth(this.year, this.month);
  }

  /**
   * Returns the number of days in this DateTime's year
   * @example DateTime.local(2016).daysInYear //=> 366
   * @example DateTime.local(2013).daysInYear //=> 365
   * @type {number}
   */
  get daysInYear() {
    return this.isValid ? daysInYear(this.year) : NaN;
  }

  /**
   * Returns the number of weeks in this DateTime's year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2004).weeksInWeekYear //=> 53
   * @example DateTime.local(2013).weeksInWeekYear //=> 52
   * @type {number}
   */
  get weeksInWeekYear() {
    return this.isValid ? weeksInWeekYear(this.weekYear) : NaN;
  }

  /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */
  resolvedLocaleOptions(opts = {}) {
    const { locale, numberingSystem, calendar } = Formatter.create(
      this.loc.clone(opts),
      opts
    ).resolvedOptions(this);
    return { locale, numberingSystem, outputCalendar: calendar };
  }

  // TRANSFORM

  /**
   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
   *
   * Equivalent to {@link DateTime#setZone}('utc')
   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
   * @param {Object} [opts={}] - options to pass to `setZone()`
   * @return {DateTime}
   */
  toUTC(offset = 0, opts = {}) {
    return this.setZone(FixedOffsetZone.instance(offset), opts);
  }

  /**
   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
   *
   * Equivalent to `setZone('local')`
   * @return {DateTime}
   */
  toLocal() {
    return this.setZone(Settings.defaultZone);
  }

  /**
   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
   *
   * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link DateTime#plus}. You may wish to use {@link DateTime#toLocal} and {@link DateTime#toUTC} which provide simple convenience wrappers for commonly used zones.
   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link DateTime#Zone} class.
   * @param {Object} opts - options
   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
   * @return {DateTime}
   */
  setZone(zone, { keepLocalTime = false, keepCalendarTime = false } = {}) {
    zone = normalizeZone(zone, Settings.defaultZone);
    if (zone.equals(this.zone)) {
      return this;
    } else if (!zone.isValid) {
      return DateTime.invalid(unsupportedZone(zone));
    } else {
      let newTS = this.ts;
      if (keepLocalTime || keepCalendarTime) {
        const offsetGuess = zone.offset(this.ts);
        const asObj = this.toObject();
        [newTS] = objToTS(asObj, offsetGuess, zone);
      }
      return clone(this, { ts: newTS, zone });
    }
  }

  /**
   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
   * @param {Object} properties - the properties to set
   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
   * @return {DateTime}
   */
  reconfigure({ locale, numberingSystem, outputCalendar } = {}) {
    const loc = this.loc.clone({ locale, numberingSystem, outputCalendar });
    return clone(this, { loc });
  }

  /**
   * "Set" the locale. Returns a newly-constructed DateTime.
   * Just a convenient alias for reconfigure({ locale })
   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
   * @return {DateTime}
   */
  setLocale(locale) {
    return this.reconfigure({ locale });
  }

  /**
   * "Set" the values of specified units. Returns a newly-constructed DateTime.
   * You can only set units with this method; for "setting" metadata, see {@link DateTime#reconfigure} and {@link DateTime#setZone}.
   * @param {Object} values - a mapping of units to numbers
   * @example dt.set({ year: 2017 })
   * @example dt.set({ hour: 8, minute: 30 })
   * @example dt.set({ weekday: 5 })
   * @example dt.set({ year: 2005, ordinal: 234 })
   * @return {DateTime}
   */
  set(values) {
    if (!this.isValid) return this;

    const normalized = normalizeObject(values, normalizeUnit),
      settingWeekStuff =
        !isUndefined(normalized.weekYear) ||
        !isUndefined(normalized.weekNumber) ||
        !isUndefined(normalized.weekday),
      containsOrdinal = !isUndefined(normalized.ordinal),
      containsGregorYear = !isUndefined(normalized.year),
      containsGregorMD = !isUndefined(normalized.month) || !isUndefined(normalized.day),
      containsGregor = containsGregorYear || containsGregorMD,
      definiteWeekDef = normalized.weekYear || normalized.weekNumber;

    if ((containsGregor || containsOrdinal) && definiteWeekDef) {
      throw new ConflictingSpecificationError(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    }

    if (containsGregorMD && containsOrdinal) {
      throw new ConflictingSpecificationError("Can't mix ordinal dates with month/day");
    }

    let mixed;
    if (settingWeekStuff) {
      mixed = weekToGregorian({ ...gregorianToWeek(this.c), ...normalized });
    } else if (!isUndefined(normalized.ordinal)) {
      mixed = ordinalToGregorian({ ...gregorianToOrdinal(this.c), ...normalized });
    } else {
      mixed = { ...this.toObject(), ...normalized };

      // if we didn't set the day but we ended up on an overflow date,
      // use the last day of the right month
      if (isUndefined(normalized.day)) {
        mixed.day = Math.min(daysInMonth(mixed.year, mixed.month), mixed.day);
      }
    }

    const [ts, o] = objToTS(mixed, this.o, this.zone);
    return clone(this, { ts, o });
  }

  /**
   * Add a period of time to this DateTime and return the resulting DateTime
   *
   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @example DateTime.now().plus(123) //~> in 123 milliseconds
   * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
   * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
   * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
   * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
   * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
   * @return {DateTime}
   */
  plus(duration) {
    if (!this.isValid) return this;
    const dur = Duration.fromDurationLike(duration);
    return clone(this, adjustTime(this, dur));
  }

  /**
   * Subtract a period of time to this DateTime and return the resulting DateTime
   * See {@link DateTime#plus}
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   @return {DateTime}
   */
  minus(duration) {
    if (!this.isValid) return this;
    const dur = Duration.fromDurationLike(duration).negate();
    return clone(this, adjustTime(this, dur));
  }

  /**
   * "Set" this DateTime to the beginning of a unit of time.
   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
   * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
   * @return {DateTime}
   */
  startOf(unit) {
    if (!this.isValid) return this;
    const o = {},
      normalizedUnit = Duration.normalizeUnit(unit);
    switch (normalizedUnit) {
      case "years":
        o.month = 1;
      // falls through
      case "quarters":
      case "months":
        o.day = 1;
      // falls through
      case "weeks":
      case "days":
        o.hour = 0;
      // falls through
      case "hours":
        o.minute = 0;
      // falls through
      case "minutes":
        o.second = 0;
      // falls through
      case "seconds":
        o.millisecond = 0;
        break;
      // no default, invalid units throw in normalizeUnit()
    }

    if (normalizedUnit === "weeks") {
      o.weekday = 1;
    }

    if (normalizedUnit === "quarters") {
      const q = Math.ceil(this.month / 3);
      o.month = (q - 1) * 3 + 1;
    }

    return this.set(o);
  }

  /**
   * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
   * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
   * @return {DateTime}
   */
  endOf(unit) {
    return this.isValid
      ? this.plus({ [unit]: 1 })
          .startOf(unit)
          .minus(1)
      : this;
  }

  // OUTPUT

  /**
   * Returns a string representation of this DateTime formatted according to the specified format string.
   * **You may not want this.** See {@link DateTime#toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/formatting?id=table-of-tokens).
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @param {string} fmt - the format string
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
   * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
   * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
   * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
   * @return {string}
   */
  toFormat(fmt, opts = {}) {
    return this.isValid
      ? Formatter.create(this.loc.redefaultToEN(opts)).formatDateTimeFromString(this, fmt)
      : INVALID;
  }

  /**
   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
   * of the DateTime in the assigned locale.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param formatOpts {Object} - Intl.DateTimeFormat constructor options and configuration options
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toLocaleString(); //=> 4/20/2017
   * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString({ locale: 'en-gb' }); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
   * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
   * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
   * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
   * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
   * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); //=> '11:32'
   * @return {string}
   */
  toLocaleString(formatOpts = DATE_SHORT, opts = {}) {
    return this.isValid
      ? Formatter.create(this.loc.clone(opts), formatOpts).formatDateTime(this)
      : INVALID;
  }

  /**
   * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
   * @example DateTime.now().toLocaleParts(); //=> [
   *                                   //=>   { type: 'day', value: '25' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'month', value: '05' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'year', value: '1982' }
   *                                   //=> ]
   */
  toLocaleParts(opts = {}) {
    return this.isValid
      ? Formatter.create(this.loc.clone(opts), opts).formatDateTimeParts(this)
      : [];
  }

  /**
   * Returns an ISO 8601-compliant string representation of this DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1983, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
   * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
   * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
   * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
   * @return {string}
   */
  toISO({
    format = "extended",
    suppressSeconds = false,
    suppressMilliseconds = false,
    includeOffset = true,
  } = {}) {
    if (!this.isValid) {
      return null;
    }

    const ext = format === "extended";

    let c = toISODate(this, ext);
    c += "T";
    c += toISOTime(this, ext, suppressSeconds, suppressMilliseconds, includeOffset);
    return c;
  }

  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's date component
   * @param {Object} opts - options
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
   * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
   * @return {string}
   */
  toISODate({ format = "extended" } = {}) {
    if (!this.isValid) {
      return null;
    }

    return toISODate(this, format === "extended");
  }

  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's week date
   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
   * @return {string}
   */
  toISOWeekDate() {
    return toTechFormat(this, "kkkk-'W'WW-c");
  }

  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's time component
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
   * @return {string}
   */
  toISOTime({
    suppressMilliseconds = false,
    suppressSeconds = false,
    includeOffset = true,
    includePrefix = false,
    format = "extended",
  } = {}) {
    if (!this.isValid) {
      return null;
    }

    let c = includePrefix ? "T" : "";
    return (
      c +
      toISOTime(this, format === "extended", suppressSeconds, suppressMilliseconds, includeOffset)
    );
  }

  /**
   * Returns an RFC 2822-compatible string representation of this DateTime
   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
   * @return {string}
   */
  toRFC2822() {
    return toTechFormat(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", false);
  }

  /**
   * Returns a string representation of this DateTime appropriate for use in HTTP headers. The output is always expressed in GMT.
   * Specifically, the string conforms to RFC 1123.
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
   * @return {string}
   */
  toHTTP() {
    return toTechFormat(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
  }

  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Date
   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
   * @return {string}
   */
  toSQLDate() {
    if (!this.isValid) {
      return null;
    }
    return toISODate(this, true);
  }

  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Time
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
   * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
   * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
   * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
   * @return {string}
   */
  toSQLTime({ includeOffset = true, includeZone = false } = {}) {
    let fmt = "HH:mm:ss.SSS";

    if (includeZone || includeOffset) {
      fmt += " ";
      if (includeZone) {
        fmt += "z";
      } else if (includeOffset) {
        fmt += "ZZ";
      }
    }

    return toTechFormat(this, fmt, true);
  }

  /**
   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
   * @return {string}
   */
  toSQL(opts = {}) {
    if (!this.isValid) {
      return null;
    }

    return `${this.toSQLDate()} ${this.toSQLTime(opts)}`;
  }

  /**
   * Returns a string representation of this DateTime appropriate for debugging
   * @return {string}
   */
  toString() {
    return this.isValid ? this.toISO() : INVALID;
  }

  /**
   * Returns the epoch milliseconds of this DateTime. Alias of {@link DateTime#toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }

  /**
   * Returns the epoch milliseconds of this DateTime.
   * @return {number}
   */
  toMillis() {
    return this.isValid ? this.ts : NaN;
  }

  /**
   * Returns the epoch seconds of this DateTime.
   * @return {number}
   */
  toSeconds() {
    return this.isValid ? this.ts / 1000 : NaN;
  }

  /**
   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }

  /**
   * Returns a BSON serializable equivalent to this DateTime.
   * @return {Date}
   */
  toBSON() {
    return this.toJSDate();
  }

  /**
   * Returns a JavaScript object with this DateTime's year, month, day, and so on.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
   * @return {Object}
   */
  toObject(opts = {}) {
    if (!this.isValid) return {};

    const base = { ...this.c };

    if (opts.includeConfig) {
      base.outputCalendar = this.outputCalendar;
      base.numberingSystem = this.loc.numberingSystem;
      base.locale = this.loc.locale;
    }
    return base;
  }

  /**
   * Returns a JavaScript Date equivalent to this DateTime.
   * @return {Date}
   */
  toJSDate() {
    return new Date(this.isValid ? this.ts : NaN);
  }

  // COMPARE

  /**
   * Return the difference between two DateTimes as a Duration.
   * @param {DateTime} otherDateTime - the DateTime to compare this one to
   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example
   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
   *     i2 = DateTime.fromISO('1983-10-14T10:30');
   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
   * @return {Duration}
   */
  diff(otherDateTime, unit = "milliseconds", opts = {}) {
    if (!this.isValid || !otherDateTime.isValid) {
      return Duration.invalid("created by diffing an invalid DateTime");
    }

    const durOpts = { locale: this.locale, numberingSystem: this.numberingSystem, ...opts };

    const units = maybeArray(unit).map(Duration.normalizeUnit),
      otherIsLater = otherDateTime.valueOf() > this.valueOf(),
      earlier = otherIsLater ? this : otherDateTime,
      later = otherIsLater ? otherDateTime : this,
      diffed = diff(earlier, later, units, durOpts);

    return otherIsLater ? diffed.negate() : diffed;
  }

  /**
   * Return the difference between this DateTime and right now.
   * See {@link DateTime#diff}
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  diffNow(unit = "milliseconds", opts = {}) {
    return this.diff(DateTime.now(), unit, opts);
  }

  /**
   * Return an Interval spanning between this DateTime and another DateTime
   * @param {DateTime} otherDateTime - the other end point of the Interval
   * @return {Interval}
   */
  until(otherDateTime) {
    return this.isValid ? Interval.fromDateTimes(this, otherDateTime) : this;
  }

  /**
   * Return whether this DateTime is in the same unit of time as another DateTime.
   * Higher-order units must also be identical for this function to return `true`.
   * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link DateTime#setZone} to convert one of the dates if needed.
   * @param {DateTime} otherDateTime - the other DateTime
   * @param {string} unit - the unit of time to check sameness on
   * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
   * @return {boolean}
   */
  hasSame(otherDateTime, unit) {
    if (!this.isValid) return false;

    const inputMs = otherDateTime.valueOf();
    const adjustedToZone = this.setZone(otherDateTime.zone, { keepLocalTime: true });
    return adjustedToZone.startOf(unit) <= inputMs && inputMs <= adjustedToZone.endOf(unit);
  }

  /**
   * Equality check
   * Two DateTimes are equal iff they represent the same millisecond, have the same zone and location, and are both valid.
   * To compare just the millisecond values, use `+dt1 === +dt2`.
   * @param {DateTime} other - the other DateTime
   * @return {boolean}
   */
  equals(other) {
    return (
      this.isValid &&
      other.isValid &&
      this.valueOf() === other.valueOf() &&
      this.zone.equals(other.zone) &&
      this.loc.equals(other.loc)
    );
  }

  /**
   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
   * platform supports Intl.RelativeTimeFormat. Rounds down by default.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
   * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
   * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
   * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
   * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
   * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
   * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
   * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
   */
  toRelative(options = {}) {
    if (!this.isValid) return null;
    const base = options.base || DateTime.fromObject({}, { zone: this.zone }),
      padding = options.padding ? (this < base ? -options.padding : options.padding) : 0;
    let units = ["years", "months", "days", "hours", "minutes", "seconds"];
    let unit = options.unit;
    if (Array.isArray(options.unit)) {
      units = options.unit;
      unit = undefined;
    }
    return diffRelative(base, this.plus(padding), {
      ...options,
      numeric: "always",
      units,
      unit,
    });
  }

  /**
   * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
   * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
   * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
   * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
   */
  toRelativeCalendar(options = {}) {
    if (!this.isValid) return null;

    return diffRelative(options.base || DateTime.fromObject({}, { zone: this.zone }), this, {
      ...options,
      numeric: "auto",
      units: ["years", "months", "days"],
      calendary: true,
    });
  }

  /**
   * Return the min of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
   * @return {DateTime} the min DateTime, or undefined if called with no argument
   */
  static min(...dateTimes) {
    if (!dateTimes.every(DateTime.isDateTime)) {
      throw new InvalidArgumentError("min requires all arguments be DateTimes");
    }
    return bestBy(dateTimes, (i) => i.valueOf(), Math.min);
  }

  /**
   * Return the max of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
   * @return {DateTime} the max DateTime, or undefined if called with no argument
   */
  static max(...dateTimes) {
    if (!dateTimes.every(DateTime.isDateTime)) {
      throw new InvalidArgumentError("max requires all arguments be DateTimes");
    }
    return bestBy(dateTimes, (i) => i.valueOf(), Math.max);
  }

  // MISC

  /**
   * Explain how a string would be parsed by fromFormat()
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see description)
   * @param {Object} options - options taken by fromFormat()
   * @return {Object}
   */
  static fromFormatExplain(text, fmt, options = {}) {
    const { locale = null, numberingSystem = null } = options,
      localeToUse = Locale.fromOpts({
        locale,
        numberingSystem,
        defaultToEN: true,
      });
    return explainFromTokens(localeToUse, text, fmt);
  }

  /**
   * @deprecated use fromFormatExplain instead
   */
  static fromStringExplain(text, fmt, options = {}) {
    return DateTime.fromFormatExplain(text, fmt, options);
  }

  // FORMAT PRESETS

  /**
   * {@link DateTime#toLocaleString} format like 10/14/1983
   * @type {Object}
   */
  static get DATE_SHORT() {
    return DATE_SHORT;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED() {
    return DATE_MED;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'Fri, Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED_WITH_WEEKDAY() {
    return DATE_MED_WITH_WEEKDAY;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983'
   * @type {Object}
   */
  static get DATE_FULL() {
    return DATE_FULL;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'Tuesday, October 14, 1983'
   * @type {Object}
   */
  static get DATE_HUGE() {
    return DATE_HUGE;
  }

  /**
   * {@link DateTime#toLocaleString} format like '09:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_SIMPLE() {
    return TIME_SIMPLE;
  }

  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SECONDS() {
    return TIME_WITH_SECONDS;
  }

  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SHORT_OFFSET() {
    return TIME_WITH_SHORT_OFFSET;
  }

  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_LONG_OFFSET() {
    return TIME_WITH_LONG_OFFSET;
  }

  /**
   * {@link DateTime#toLocaleString} format like '09:30', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_SIMPLE() {
    return TIME_24_SIMPLE;
  }

  /**
   * {@link DateTime#toLocaleString} format like '09:30:23', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SECONDS() {
    return TIME_24_WITH_SECONDS;
  }

  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 EDT', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SHORT_OFFSET() {
    return TIME_24_WITH_SHORT_OFFSET;
  }

  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 Eastern Daylight Time', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_LONG_OFFSET() {
    return TIME_24_WITH_LONG_OFFSET;
  }

  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT() {
    return DATETIME_SHORT;
  }

  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT_WITH_SECONDS() {
    return DATETIME_SHORT_WITH_SECONDS;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED() {
    return DATETIME_MED;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_SECONDS() {
    return DATETIME_MED_WITH_SECONDS;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'Fri, 14 Oct 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_WEEKDAY() {
    return DATETIME_MED_WITH_WEEKDAY;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL() {
    return DATETIME_FULL;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30:33 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL_WITH_SECONDS() {
    return DATETIME_FULL_WITH_SECONDS;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE() {
    return DATETIME_HUGE;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30:33 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE_WITH_SECONDS() {
    return DATETIME_HUGE_WITH_SECONDS;
  }
}

/**
 * @private
 */
function friendlyDateTime(dateTimeish) {
  if (DateTime.isDateTime(dateTimeish)) {
    return dateTimeish;
  } else if (dateTimeish && dateTimeish.valueOf && isNumber(dateTimeish.valueOf())) {
    return DateTime.fromJSDate(dateTimeish);
  } else if (dateTimeish && typeof dateTimeish === "object") {
    return DateTime.fromObject(dateTimeish);
  } else {
    throw new InvalidArgumentError(
      `Unknown datetime argument: ${dateTimeish}, of type ${typeof dateTimeish}`
    );
  }
}

var LocalDate = function (_a) {
    var children = _a.children, format = _a.format, locale = _a.locale, id = _a.id;
    var date = DateTime.fromISO(children)
        .toUTC()
        .setLocale(locale)
        .toFormat(format);
    return React.createElement("span", { "data-testid": id }, date);
};
LocalDate.defaultProps = {
    format: 'dd/MM/yyyy',
    locale: 'pt-BR'
};

var StyledTabs = styled.div.attrs(function (props) { return ({
    typeTab: props.theme.tab.type[props.type] || props.theme.tab.type.default
}); })(templateObject_1$a || (templateObject_1$a = __makeTemplateObject(["\n    display: flex;\n    flex-direction: ", ";\n    border-bottom: ", ";\n"], ["\n    display: flex;\n    flex-direction: ", ";\n    border-bottom: ", ";\n"
    // TODO Fix Layout shift font-weight bold
])), function (props) { return props.orientation || props.typeTab.orientation; }, function (props) { return props.typeTab.borderBaseline; });
// TODO Fix Layout shift font-weight bold
var StyledTabItem = styled.div.attrs(function (props) { return ({
    tabVariant: props.theme.tab.variant[props.variant] || props.theme.tab.variant.primary
}); })(templateObject_2$9 || (templateObject_2$9 = __makeTemplateObject(["\n  \n  font-family: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  color: ", ";\n  cursor: pointer;\n  box-sizing: border-box;\n\n  \n  &.selected {\n    font-weight: ", ";\n    color: ", ";\n  }\n  \n  ", "\n"], ["\n  \n  font-family: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  color: ", ";\n  cursor: pointer;\n  box-sizing: border-box;\n\n  \n  &.selected {\n    font-weight: ", ";\n    color: ", ";\n  }\n  \n  ", "\n"])), function (props) { return props.theme.font.family.regular; }, function (props) { return props.theme.font.size.v_16; }, function (props) { return props.theme.font.weight.v_500; }, function (props) { return props.tabVariant.colors.textColor; }, function (props) { return props.theme.font.weight.bold; }, function (props) { return props.tabVariant.colors.textSelected; }, UserSelectNone);
var StyledDefaultTabItem = styled(StyledTabItem)(templateObject_3$8 || (templateObject_3$8 = __makeTemplateObject(["\n  padding: ", " ", ";\n  text-align: center;\n  position: relative;\n  &.selected::after {\n    content: ' ';\n    bottom: -2px;\n    position: absolute;\n    height: 4px;\n    width: 100%;\n    left: 0;\n    background: ", ";\n  }\n"], ["\n  padding: ", " ", ";\n  text-align: center;\n  position: relative;\n  &.selected::after {\n    content: ' ';\n    bottom: -2px;\n    position: absolute;\n    height: 4px;\n    width: 100%;\n    left: 0;\n    background: ", ";\n  }\n"])), theme.padding.s_0_906, theme.padding.s_1, function (props) { return props.tabVariant.colors.borderSelected; });
var StyledMenuTabItem = styled(StyledTabItem)(templateObject_4$8 || (templateObject_4$8 = __makeTemplateObject(["\n  \n  padding: 0 ", ";\n  margin-bottom: ", ";\n  border-left: 4px solid transparent;\n  &.selected {\n    border-color: ", ";\n  }\n  &:last-child {\n    margin-bottom: 0\n  }\n"], ["\n  \n  padding: 0 ", ";\n  margin-bottom: ", ";\n  border-left: 4px solid transparent;\n  &.selected {\n    border-color: ", ";\n  }\n  &:last-child {\n    margin-bottom: 0\n  }\n"])), function (props) { return props.theme.padding.s_1_750; }, function (props) { return props.theme.margin.s_0_937; }, function (props) { return props.tabVariant.colors.borderSelected; });
var templateObject_1$a, templateObject_2$9, templateObject_3$8, templateObject_4$8;

var Tab = function (props) {
    return (React.createElement(StyledDefaultTabItem, __assign({ className: props.isSelected ? 'selected' : '' }, props), props.children));
};

var Tabs = function (_a) {
    var children = _a.children, selectedIndex = _a.selectedIndex, onSelect = _a.onSelect, props = __rest(_a, ["children", "selectedIndex", "onSelect"]);
    var _b = useState(selectedIndex), localSelectedIndex = _b[0], setLocalSelectedIndex = _b[1];
    useEffect(function () {
        setLocalSelectedIndex(selectedIndex);
    }, [selectedIndex]);
    var onSelectTab = function (index) {
        setLocalSelectedIndex(index);
        if (onSelect)
            onSelect(index);
    };
    var tabItems = React.Children.map(children, function (child, index) {
        if (React.isValidElement(child)) {
            index = child.props.index || index;
            return React.cloneElement(child, {
                localSelectedIndex: localSelectedIndex,
                onClick: function () {
                    onSelectTab(index);
                },
                index: child.props.index || index,
                isSelected: localSelectedIndex === index
            });
        }
        return child;
    });
    return (React.createElement(StyledTabs, __assign({}, props), tabItems));
};
Tabs.defaultProps = {
    variant: 'primary',
    type: 'default',
    orientation: 'row',
    onSelect: function () { }
};

var MenuTabItem = function (props) {
    return (React.createElement(StyledMenuTabItem, __assign({ className: props.isSelected ? 'selected' : '' }, props), props.children));
};

var MenuTab = function (props) {
    return (React.createElement(Tabs, __assign({}, props, { type: 'menu', orientation: 'column' })));
};
MenuTab.defaultProps = {
    variant: 'primary'
};

var Gauge$1 = styled.div(templateObject_1$9 || (templateObject_1$9 = __makeTemplateObject(["\n  width: 100%;\n  max-width: ", ";\n  font-family: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  color: #262C36;\n;"], ["\n  width: 100%;\n  max-width: ", ";\n  font-family: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  color: #262C36;\n;"])), gauge.width, theme.font.family.regular, theme.font.size.v_12, theme.font.weight.v_600);
var GaugeBody = styled.div(templateObject_2$8 || (templateObject_2$8 = __makeTemplateObject(["\n  width: 100%;\n  height: 0;\n  padding-bottom: 50%;\n  background: ", ";\n  position: relative;\n  border-top-left-radius: 100% 200%;\n  border-top-right-radius: 100% 200%;\n  overflow: hidden;\n"], ["\n  width: 100%;\n  height: 0;\n  padding-bottom: 50%;\n  background: ", ";\n  position: relative;\n  border-top-left-radius: 100% 200%;\n  border-top-right-radius: 100% 200%;\n  overflow: hidden;\n"])), theme.color.gray_300);
var GaugeFill = styled.div(templateObject_4$7 || (templateObject_4$7 = __makeTemplateObject(["\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: inherit;\n  height: 100%;\n  transform-origin: center top;\n  transition: transform 0.2s ease-out;\n\n  ", "\n"], ["\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: inherit;\n  height: 100%;\n  transform-origin: center top;\n  transition: transform 0.2s ease-out;\n\n  ", "\n"])), function (_a) {
    var percentage = _a.percentage, state = _a.state;
    return css(templateObject_3$7 || (templateObject_3$7 = __makeTemplateObject(["\n    transform: rotate(", "turn);\n    background: ", ";\n  "], ["\n    transform: rotate(", "turn);\n    background: ", ";\n  "])), percentage / 2, gauge.state[state].color);
});
var GaugeCover = styled.div(templateObject_5$5 || (templateObject_5$5 = __makeTemplateObject(["\n  width: 75%;\n  height: 150%;\n  background: #ffffff;\n  border-radius: 50%;\n  position: absolute;\n  top: 25%;\n  left: 50%;\n  transform: translateX(-50%);\n\n  /* Text */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-bottom: 25%;\n  box-sizing: border-box;\n"], ["\n  width: 75%;\n  height: 150%;\n  background: #ffffff;\n  border-radius: 50%;\n  position: absolute;\n  top: 25%;\n  left: 50%;\n  transform: translateX(-50%);\n\n  /* Text */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-bottom: 25%;\n  box-sizing: border-box;\n"])));
var templateObject_1$9, templateObject_2$8, templateObject_3$7, templateObject_4$7, templateObject_5$5;

var Gauge = function (_a) {
    var max = _a.max, value = _a.value, props = __rest(_a, ["max", "value"]);
    var gaugeState = function () {
        var percentage = value / max;
        if (percentage < 0.4) {
            return 'low';
        }
        else if (percentage < 0.6) {
            return 'medium';
        }
        else if (percentage < 0.9) {
            return 'high';
        }
        else {
            return 'highest';
        }
    };
    return (React.createElement(Gauge$1, __assign({}, props),
        React.createElement(GaugeBody, null,
            React.createElement(GaugeFill, { "data-testid": 'gauge-fill', state: gaugeState(), percentage: value / max }),
            React.createElement(GaugeCover, null, value))));
};
Gauge.defaultProps = {
    max: 100,
    value: 0
};

var Alert$1 = styled.div(templateObject_2$7 || (templateObject_2$7 = __makeTemplateObject(["\n    position: relative;\n    padding: 1.125rem;\n    display: ", ";\n    grid-gap: 8px;\n    ", ";\n;"], ["\n    position: relative;\n    padding: 1.125rem;\n    display: ", ";\n    grid-gap: 8px;\n    ", ";\n;"])), function (props) { return props.show ? 'grid' : 'none'; }, function (_a) {
    var $variantData = _a.$variantData, theme = _a.theme, icon = _a.icon;
    return css(templateObject_1$8 || (templateObject_1$8 = __makeTemplateObject(["\n      grid-template-columns: ", ";\n      background-color: ", ";\n      color: ", ";\n      font-size: ", ";\n      font-weight: ", ";\n      font-family: ", ";\n      border-radius: ", ";\n    "], ["\n      grid-template-columns: ", ";\n      background-color: ", ";\n      color: ", ";\n      font-size: ", ";\n      font-weight: ", ";\n      font-family: ", ";\n      border-radius: ", ";\n    "])), icon ? '20px 1fr' : '1fr', solveThemeValue(theme.color, $variantData.backgroundColor), $variantData.textColor, theme.font.size.v_14, theme.font.weight.v_500, theme.font.family.regular, theme.radius.regular);
});
var AlertIcon = styled.div(templateObject_3$6 || (templateObject_3$6 = __makeTemplateObject(["\n  width: 20px;\n  img {\n    width: 100%;\n  }\n"], ["\n  width: 20px;\n  img {\n    width: 100%;\n  }\n"])));
var CloseButtonWrapper = styled.div(templateObject_4$6 || (templateObject_4$6 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  padding: 0.5rem;\n  img {\n    width: 100%;\n  }\n"], ["\n  position: absolute;\n  top: 0;\n  right: 0;\n  padding: 0.5rem;\n  img {\n    width: 100%;\n  }\n"])));
var CloseButton = styled('button')(templateObject_5$4 || (templateObject_5$4 = __makeTemplateObject(["\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  width: 100%;\n"], ["\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  width: 100%;\n"])));
var templateObject_1$8, templateObject_2$7, templateObject_3$6, templateObject_4$6, templateObject_5$4;

var Alert = function (_a) {
    var icon = _a.icon, closeButton = _a.closeButton, show = _a.show, onClose = _a.onClose, props = __rest(_a, ["icon", "closeButton", "show", "onClose"]);
    var themeContext = useContext(ThemeContext);
    var variantData = useMemo(function () {
        return solveVariant(themeContext.alert.variant, props.type, 'default', false);
    }, [props.type]);
    var handleCloseClick = function (e) {
        e.preventDefault();
        onClose();
    };
    return (React.createElement(Alert$1, __assign({}, props, { "$variantData": variantData, icon: icon, show: show }),
        icon && (React.createElement(AlertIcon, { "data-testid": 'alert-icon' },
            React.createElement(Icon, { icon: variantData.icon, as: 'i' }))),
        React.createElement("span", null, props.children),
        closeButton && (React.createElement(CloseButtonWrapper, null,
            React.createElement(CloseButton, { onClick: handleCloseClick, "data-testid": 'close-button' },
                React.createElement(IconClose, { as: 'i' }))))));
};
Alert.defaultProps = {
    type: 'info',
    icon: true,
    show: true,
    closeButton: false,
    onClose: function () { }
};

var LogoWrapper = styled.a(templateObject_1$7 || (templateObject_1$7 = __makeTemplateObject(["\n  display: block; \n  img {\n    width: 100%;\n  }\n  cursor: pointer;\n  padding: 0 5px;\n  margin-bottom: 35px;\n"], ["\n  display: block; \n  img {\n    width: 100%;\n  }\n  cursor: pointer;\n  padding: 0 5px;\n  margin-bottom: 35px;\n"])));
var SideBarTitle$1 = styled.h1(templateObject_2$6 || (templateObject_2$6 = __makeTemplateObject(["\n\n  ", ";\n  \n  margin: 0 0 2.8rem 0;\n  text-align: center;\n  letter-spacing: 0;\n  position: relative;\n  padding: 0 0 1.75rem 0;\n  \n  :after {\n    content: ' ';\n    position: absolute;\n    width: 30px;\n    bottom: 0;\n    left: 50%;\n    margin-left: -15px;\n    height: 4px;\n    background: ", ";\n    border-radius: ", ";\n  }\n"], ["\n\n  ", ";\n  \n  margin: 0 0 2.8rem 0;\n  text-align: center;\n  letter-spacing: 0;\n  position: relative;\n  padding: 0 0 1.75rem 0;\n  \n  :after {\n    content: ' ';\n    position: absolute;\n    width: 30px;\n    bottom: 0;\n    left: 50%;\n    margin-left: -15px;\n    height: 4px;\n    background: ", ";\n    border-radius: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return ({
        fontSize: theme.font.size.v_12,
        fontWight: theme.font.weight.v_600,
        fontFamily: theme.font.family.regular
    });
}, function (props) { return solveThemeValue(props.theme.color, props.$variantData.separatorLineColor); }, function (props) { return props.theme.radius.regular; });
var MenuItem$2 = styled.a(templateObject_3$5 || (templateObject_3$5 = __makeTemplateObject(["\n  background-color: ", ";\n \n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 70px;\n  flex-direction: column;\n  padding: 0.8125rem;\n  cursor: pointer;\n  &, & * {\n    color: ", ";\n    text-decoration: none !important;\n  }\n"], ["\n  background-color: ", ";\n \n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 70px;\n  flex-direction: column;\n  padding: 0.8125rem;\n  cursor: pointer;\n  &, & * {\n    color: ", ";\n    text-decoration: none !important;\n  }\n"])), function (_a) {
    var $variantData = _a.$variantData, active = _a.active, theme = _a.theme;
    return active ? solveThemeValue(theme.color, $variantData.backgroundActiveMenu) : null;
}, function (props) { return solveThemeValue(props.theme.color, props.$variantData.textColor); });
var MenuItemText = styled.a(templateObject_4$5 || (templateObject_4$5 = __makeTemplateObject(["\n  ", ";\n  color: white;\n  margin-bottom: 1rem;\n  text-decoration: none;\n  display: grid;\n  grid-template-columns: 8px auto;\n  grid-gap: 2px;\n  & span {\n    margin-top: -0.25rem;\n  }\n  & .menu-item-text__icon {\n    transform: rotate(180deg);\n  }\n"], ["\n  ", ";\n  color: white;\n  margin-bottom: 1rem;\n  text-decoration: none;\n  display: grid;\n  grid-template-columns: 8px auto;\n  grid-gap: 2px;\n  & span {\n    margin-top: -0.25rem;\n  }\n  & .menu-item-text__icon {\n    transform: rotate(180deg);\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return ({
        fontSize: theme.font.size.v_12,
        fontWeight: theme.font.weight.v_600,
        fontFamily: theme.font.family.regular,
        textAlign: 'left'
    });
});
var SubMenuContent = styled.div(templateObject_5$3 || (templateObject_5$3 = __makeTemplateObject(["\n  padding-top: 1.25rem;\n  padding-bottom: 1.25rem;\n  display: flex;\n  flex-direction: column;\n"], ["\n  padding-top: 1.25rem;\n  padding-bottom: 1.25rem;\n  display: flex;\n  flex-direction: column;\n"])));
var SubMenuWrapper = styled.div(templateObject_6$3 || (templateObject_6$3 = __makeTemplateObject(["\n  \n  background: ", ";\n  transition: max-height .4s;\n  overflow: hidden;\n  max-height: ", ";\n  padding-right: 7px;\n  padding-left: 13px;\n"], ["\n  \n  background: ", ";\n  transition: max-height .4s;\n  overflow: hidden;\n  max-height: ", ";\n  padding-right: 7px;\n  padding-left: 13px;\n"])), function (props) { return solveThemeValue(props.theme.color, props.$variantData.backgroundSubMenu); }, function (props) { return props.active ? '400px' : '0px'; });
var MenuLabel$1 = styled.span(templateObject_7$3 || (templateObject_7$3 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return ({
        fontSize: theme.font.size.v_12,
        fontWight: theme.font.weight.bold,
        fontFamily: theme.font.family.regular,
        textAlign: 'center'
    });
});
var MenuIcon$1 = styled.div(templateObject_8$2 || (templateObject_8$2 = __makeTemplateObject(["\n  margin-bottom: 5px;\n"], ["\n  margin-bottom: 5px;\n"])));
var SideBar$1 = styled.div(templateObject_10$1 || (templateObject_10$1 = __makeTemplateObject(["\n  ", "\n  \n  width: 120px;\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  padding: 2.8125rem 0;\n  > * {\n    padding-right: 0.8125rem;\n    padding-left: 0.8125rem;\n  }\n  \n  ", ";\n"], ["\n  ", "\n  \n  width: 120px;\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  padding: 2.8125rem 0;\n  > * {\n    padding-right: 0.8125rem;\n    padding-left: 0.8125rem;\n  }\n  \n  ", ";\n"])), function (_a) {
    var theme = _a.theme, $variantData = _a.$variantData;
    return css(templateObject_9$2 || (templateObject_9$2 = __makeTemplateObject(["\n    color: ", ";\n    background: ", ";\n  "], ["\n    color: ", ";\n    background: ", ";\n  "])), solveThemeValue(theme.color, $variantData.textColor), solveThemeValue(theme.color, $variantData.backgroundColor));
}, UserSelectNone);
var templateObject_1$7, templateObject_2$6, templateObject_3$5, templateObject_4$5, templateObject_5$3, templateObject_6$3, templateObject_7$3, templateObject_8$2, templateObject_9$2, templateObject_10$1;

var Logo = function (props) {
    var themeContext = useContext(ThemeContext);
    var variantData = solveVariant(themeContext.logo.variant, props.variant);
    return React.createElement("img", __assign({ alt: props.alt, src: variantData.image }, props));
};
Logo.defaultProps = {
    alt: 'Condolivre Logo'
};

var SideBar = function (_a) {
    var logoLink = _a.logoLink, children = _a.children, props = __rest(_a, ["logoLink", "children"]);
    var _b = useState(null), activeSubMenu = _b[0], setActiveSubMenu = _b[1];
    var themeContext = useContext(ThemeContext);
    var variantData = useMemo(function () {
        return solveVariant(themeContext.sidebar.variant, props.variant);
    }, [props.variant]);
    children = React.Children.map(children, function (child, index) {
        if (React.isValidElement(child)) {
            return React.cloneElement(child, {
                variant: props.variant,
                variantData: variantData,
                itemIndex: index,
                activeIndex: activeSubMenu,
                updateActiveItem: setActiveSubMenu
            });
        }
        return child;
    });
    return (React.createElement(SideBar$1, __assign({}, props, { "$variantData": variantData }),
        React.createElement(LogoWrapper, { href: logoLink },
            React.createElement(Logo, { width: '100%', variant: props.logoVariant, "data-testid": 'sidebar-logo' })),
        children));
};
SideBar.defaultProps = {
    logoVariant: 'white'
};

var ANIMATION_DELAY = 410;
var SideBarMenuItem = function (_a) {
    var onClick = _a.onClick, onToogle = _a.onToogle, itemIndex = _a.itemIndex, activeIndex = _a.activeIndex, updateActiveItem = _a.updateActiveItem, id = _a.id, active = _a.active, variantData = _a.variantData, children = _a.children, props = __rest(_a, ["onClick", "onToogle", "itemIndex", "activeIndex", "updateActiveItem", "id", "active", "variantData", "children"]);
    var _b = useState(active), localActive = _b[0], setLocalActive = _b[1];
    var _c = useState(false), isSubMenuActive = _c[0], setIsSubMenuActive = _c[1];
    var hasSubMenu = useMemo(function () {
        var subMenu = false;
        React.Children.forEach(children, function (child) {
            if (React.isValidElement(child) && child.props.role === 'submenu') {
                subMenu = true;
            }
        });
        return subMenu;
    }, [children]);
    var isCurrentIndex = activeIndex === itemIndex;
    var toogleItem = function (value) {
        onToogle(value);
        if (!value) {
            setIsSubMenuActive(false);
            setTimeout(function () {
                setLocalActive(false);
                updateActiveItem(null);
            }, ANIMATION_DELAY);
        }
        else {
            setLocalActive(true);
            updateActiveItem(itemIndex);
            if (activeIndex == null || active) {
                setIsSubMenuActive(true);
            }
            else {
                setTimeout(function () {
                    setIsSubMenuActive(true);
                }, ANIMATION_DELAY);
            }
        }
    };
    useEffect(function () {
        if (active !== localActive) {
            isCurrentIndex && updateActiveItem(!active ? null : itemIndex);
        }
    }, [active]);
    useEffect(function () {
        if (localActive && activeIndex !== itemIndex) {
            setTimeout(function () {
                setLocalActive(false);
            }, ANIMATION_DELAY);
            setIsSubMenuActive(false);
        }
    }, [activeIndex]);
    // Handle click and avoid remove click event from prop
    var handleClick = hasSubMenu ? function () {
        if (onClick)
            onClick();
        toogleItem(!isSubMenuActive);
    } : onClick;
    // Nested anchor tag is not allowed
    if (hasSubMenu) {
        props.as = 'div';
    }
    var isActive = activeIndex != null ? localActive : active;
    return (React.createElement(React.Fragment, null,
        React.createElement(MenuItem$2, __assign({}, props, { "$variantData": variantData, onClick: handleClick, "data-testid": id, active: isActive }),
            React.createElement(MenuIcon$1, null,
                React.createElement(Icon, { icon: props.icon, as: 'i' })),
            React.createElement(MenuLabel$1, null, props.label)),
        hasSubMenu && (React.createElement(SubMenuWrapper, { "$variantData": variantData, active: isSubMenuActive, "data-testid": id + "-submenu-wrapper" },
            React.createElement(SubMenuContent, null, children)))));
};
SideBarMenuItem.defaultProps = {
    as: 'a',
    active: false,
    updateActiveItem: function () { },
    onToogle: function () { }
};

var img$3 = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='5.44' height='8.592' viewBox='0 0 5.44 8.592'%3e %3cpath id='angle_right_small' d='M3.468%2c2.964l-.347-.347L.6.1A.383.383%2c0%2c0%2c0%2c.095.1a.383.383%2c0%2c0%2c0%2c0%2c.5L3.247%2c3.753a.383.383%2c0%2c0%2c0%2c.5%2c0L6.9.6A.383.383%2c0%2c0%2c0%2c6.9.1a.383.383%2c0%2c0%2c0-.5%2c0L3.878%2c2.618Z' transform='translate(4.643 0.796) rotate(90)' fill='white' stroke='white' stroke-width='1.5'/%3e%3c/svg%3e";

var SideBarMenuItemText = function (props) {
    return (React.createElement(MenuItemText, __assign({}, props),
        React.createElement("img", { src: img$3, className: 'menu-item-text__icon' }),
        React.createElement("span", null, props.label)));
};
SideBarMenuItemText.defaultProps = {
    role: 'submenu'
};

var SideBarTitle = function (_a) {
    var variantData = _a.variantData, children = _a.children, props = __rest(_a, ["variantData", "children"]);
    return (React.createElement(SideBarTitle$1, __assign({}, props, { "$variantData": variantData }), children));
};

var MenuItem$1 = styled.a.attrs(function (_a) {
    var variant = _a.variant, theme = _a.theme;
    return ({
        variantData: solveVariant(theme.fixedmenu.variant, variant)
    });
})(templateObject_1$6 || (templateObject_1$6 = __makeTemplateObject(["\n  background-color: ", ";\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 70px;\n  min-width: 33%;\n  flex-direction: column;\n  padding: 0.8125rem 0rem;\n  cursor: pointer;\n  &,\n  & * {\n    color: ", ";\n    text-decoration: none !important;\n  }\n"], ["\n  background-color: ", ";\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 70px;\n  min-width: 33%;\n  flex-direction: column;\n  padding: 0.8125rem 0rem;\n  cursor: pointer;\n  &,\n  & * {\n    color: ", ";\n    text-decoration: none !important;\n  }\n"])), function (_a) {
    var variantData = _a.variantData, active = _a.active, theme = _a.theme;
    return active
        ? solveThemeValue(theme.color, variantData.backgroundActiveMenu)
        : null;
}, function (props) {
    return solveThemeValue(props.theme.color, props.variantData.textColor);
});
var MenuLabel = styled.span(templateObject_2$5 || (templateObject_2$5 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return ({
        fontSize: theme.font.size.v_12,
        fontWeight: theme.font.weight.bold,
        fontFamily: theme.font.family.regular,
        textAlign: 'center'
    });
});
var MenuIcon = styled.div(templateObject_3$4 || (templateObject_3$4 = __makeTemplateObject(["\n  margin-bottom: 5px;\n"], ["\n  margin-bottom: 5px;\n"])));
var FixedMenu$1 = styled.div.attrs(function (_a) {
    var variant = _a.variant, theme = _a.theme;
    return ({
        variantData: solveVariant(theme.fixedmenu.variant, variant)
    });
})(templateObject_4$4 || (templateObject_4$4 = __makeTemplateObject(["\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  color: ", ";\n  background: ", ";\n\n  ", ";\n"], ["\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  color: ", ";\n  background: ", ";\n\n  ", ";\n"])), function (props) {
    return solveThemeValue(props.theme.color, props.variantData.textColor);
}, function (props) {
    return solveThemeValue(props.theme.color, props.variantData.backgroundColor);
}, UserSelectNone);
var templateObject_1$6, templateObject_2$5, templateObject_3$4, templateObject_4$4;

var FixedMenu = function (_a) {
    var props = __rest(_a, []);
    var children = forwardPropsToChildren(props.children, {
        variant: props.variant
    });
    return React.createElement(FixedMenu$1, __assign({}, props), children);
};

var MenuItem = function (_a) {
    var props = __rest(_a, []);
    return (React.createElement(MenuItem$1, __assign({}, props),
        React.createElement(MenuIcon, null,
            React.createElement(Icon, { icon: props.icon, as: 'i' })),
        React.createElement(MenuLabel, null, props.label)));
};
MenuItem.defaultProps = {
    as: 'a'
};

var AppBar$1 = styled.div(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject(["\n  \n"], ["\n  \n"])));
var AppBarHeader = styled.div(templateObject_2$4 || (templateObject_2$4 = __makeTemplateObject(["\n  width: 100%;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 50;\n  display: flex;\n  flex-direction: column;\n"], ["\n  width: 100%;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 50;\n  display: flex;\n  flex-direction: column;\n"])));
var AppLogo = styled.div(templateObject_3$3 || (templateObject_3$3 = __makeTemplateObject(["\n  height: 30px;\n  width: 100%;\n  background: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n"], ["\n  height: 30px;\n  width: 100%;\n  background: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n"])), function (props) { return props.$variantData.header.backgroundColor; });
var AppBarContent = styled.div(templateObject_4$3 || (templateObject_4$3 = __makeTemplateObject(["\n  height: 65px;\n  width: 100%;\n  background: ", ";\n  display: grid;\n  align-items: center;\n  box-sizing: border-box;\n  padding-left: 18px;\n  padding-right: 18px;\n  grid-template-columns: auto 1fr 1rem;\n  grid-gap: 16px;\n"], ["\n  height: 65px;\n  width: 100%;\n  background: ", ";\n  display: grid;\n  align-items: center;\n  box-sizing: border-box;\n  padding-left: 18px;\n  padding-right: 18px;\n  grid-template-columns: auto 1fr 1rem;\n  grid-gap: 16px;\n"])), function (props) { return props.$variantData.appBar.backgroundColor; });
var Title = styled(Text)(templateObject_5$2 || (templateObject_5$2 = __makeTemplateObject(["\n  margin-bottom: 0;\n  margin-top: 0;\n  text-align: ", ";\n"], ["\n  margin-bottom: 0;\n  margin-top: 0;\n  text-align: ", ";\n"])), function (props) { return props.hasBackAction ? 'center' : 'left'; });
var AppBarMenu$1 = styled.div(templateObject_6$2 || (templateObject_6$2 = __makeTemplateObject(["\n  display: flex;\n  flex-flow: column;\n  width: 100%;\n  background: ", ";\n  border-bottom: 4px solid ", ";\n  box-shadow: 3px 0px 10px #00000029;\n"], ["\n  display: flex;\n  flex-flow: column;\n  width: 100%;\n  background: ", ";\n  border-bottom: 4px solid ", ";\n  box-shadow: 3px 0px 10px #00000029;\n"])), theme.color.white, function (props) { return props.$variantData.appBar.backgroundColor; });
var AppBarMenuItem$1 = styled.div(templateObject_7$2 || (templateObject_7$2 = __makeTemplateObject(["\n  display: grid;\n  grid-template-columns: 25px 1fr 25px;\n  grid-gap: 26px;\n  width: 100%;\n  height: 3.25rem;\n  padding-left: 30px;\n  padding-right : 16px;\n  cursor: pointer;\n  border-bottom: 1px solid ", ";\n  box-sizing: border-box;\n  \n  &:hover {\n    background: #0052CC;\n    p { color: ", " }\n    \n    .left-icon,\n    .left-icon img {\n      filter: brightness(0) invert(1);\n    }\n  }\n  align-items: center;\n  p {\n    margin-bottom: 0;\n    margin-top: 0;\n  }\n  \n  \n  &:last-child {\n    border-bottom: none;\n  }\n  \n  img {\n    width: 100%;\n  }\n"], ["\n  display: grid;\n  grid-template-columns: 25px 1fr 25px;\n  grid-gap: 26px;\n  width: 100%;\n  height: 3.25rem;\n  padding-left: 30px;\n  padding-right : 16px;\n  cursor: pointer;\n  border-bottom: 1px solid ", ";\n  box-sizing: border-box;\n  \n  &:hover {\n    background: #0052CC;\n    p { color: ", " }\n    \n    .left-icon,\n    .left-icon img {\n      filter: brightness(0) invert(1);\n    }\n  }\n  align-items: center;\n  p {\n    margin-bottom: 0;\n    margin-top: 0;\n  }\n  \n  \n  &:last-child {\n    border-bottom: none;\n  }\n  \n  img {\n    width: 100%;\n  }\n"])), theme.color.gray_300, theme.color.white);
var Backdrop = styled.div(templateObject_8$1 || (templateObject_8$1 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  position: fixed;\n  background: ", ";\n  opacity: .5;\n  z-index: 5;\n"], ["\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  position: fixed;\n  background: ", ";\n  opacity: .5;\n  z-index: 5;\n"])), theme.color.black);
var MenuItemIcon = styled.div(templateObject_9$1 || (templateObject_9$1 = __makeTemplateObject(["\n\n"], ["\n\n"])));
var templateObject_1$5, templateObject_2$4, templateObject_3$3, templateObject_4$3, templateObject_5$2, templateObject_6$2, templateObject_7$2, templateObject_8$1, templateObject_9$1;

var img$2 = "data:image/svg+xml,%3csvg id='icon_voltar_white' xmlns='http://www.w3.org/2000/svg' width='18' height='15.437' viewBox='0 0 18 15.437'%3e %3cg id='Grupo_7923' data-name='Grupo 7923'%3e %3cpath id='Caminho_4629' data-name='Caminho 4629' d='M16.918%2c38.3a1.286%2c1.286%2c0%2c0%2c0-.223-.017H4l.277-.129A2.576%2c2.576%2c0%2c0%2c0%2c5%2c37.636l3.561-3.561a1.333%2c1.333%2c0%2c0%2c0%2c.187-1.706A1.288%2c1.288%2c0%2c0%2c0%2c6.817%2c32.2L.377%2c38.641a1.288%2c1.288%2c0%2c0%2c0%2c0%2c1.821h0L6.817%2c46.9a1.288%2c1.288%2c0%2c0%2c0%2c1.932-.129%2c1.333%2c1.333%2c0%2c0%2c0-.187-1.706L5.007%2c41.5a2.576%2c2.576%2c0%2c0%2c0-.644-.47l-.386-.174H16.624a1.333%2c1.333%2c0%2c0%2c0%2c1.359-1.082A1.288%2c1.288%2c0%2c0%2c0%2c16.918%2c38.3Z' transform='translate(0 -31.842)' fill='white'/%3e %3c/g%3e%3c/svg%3e";

var img$1 = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='19.5' height='15' viewBox='0 0 19.5 15'%3e %3cg id='menu-hamburger' transform='translate(1.5 1.5)'%3e %3cline id='Linha_1558' data-name='Linha 1558' x2='16.5' fill='none' stroke='white' stroke-linecap='round' stroke-width='3'/%3e %3cline id='Linha_1559' data-name='Linha 1559' x2='16.5' transform='translate(0 6)' fill='none' stroke='white' stroke-linecap='round' stroke-width='3'/%3e %3cline id='Linha_1560' data-name='Linha 1560' x2='16.5' transform='translate(0 12)' fill='none' stroke='white' stroke-linecap='round' stroke-width='3'/%3e %3c/g%3e%3c/svg%3e";

var AppBar = function (_a) {
    var title = _a.title, avatar = _a.avatar, backAction = _a.backAction, variant = _a.variant, menu = _a.menu, props = __rest(_a, ["title", "avatar", "backAction", "variant", "menu"]);
    var _b = useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var themeContext = useContext(ThemeContext);
    var variantData = useMemo(function () {
        return solveVariant(themeContext.appBar.variant, variant, 'normal');
    }, [variant]);
    var showAvatar = avatar && !backAction;
    var showMenuActivator = menu && !backAction;
    var toggleMenu = function () {
        setIsOpen(!isOpen);
    };
    menu = menu && forwardPropsToChildren(menu, { variantData: variantData });
    return (React.createElement(React.Fragment, null,
        React.createElement(AppBar$1, __assign({}, props),
            React.createElement(AppBarHeader, null,
                React.createElement(AppLogo, { "$variantData": variantData },
                    React.createElement(Logo, { width: '100px', variant: 'white' })),
                React.createElement(AppBarContent, { "$variantData": variantData },
                    showAvatar && React.createElement(UserBadge, __assign({}, avatar, { id: 'user-badge', showUserInfo: false, size: 'small' })),
                    backAction && React.createElement(Icon, { icon: img$2, id: 'back-action', onClick: backAction }),
                    React.createElement(Title, { size: 'v_16', color: 'white', hasBackAction: backAction != null, weight: 'bold' }, title),
                    showMenuActivator && (React.createElement(Icon, { icon: img$1, id: 'menu-activator', onClick: toggleMenu }))),
                isOpen && menu)),
        isOpen && React.createElement(Backdrop, { onClick: toggleMenu })));
};
AppBar.defaultProps = {
    variant: 'supply'
};

var AppBarMenu = function (_a) {
    var children = _a.children, variantData = _a.variantData, props = __rest(_a, ["children", "variantData"]);
    return (React.createElement(AppBarMenu$1, __assign({}, props, { "$variantData": variantData }), children));
};
AppBarMenu.defaultProps = {
    role: 'menu'
};

var AppBarMenuItem = function (_a) {
    var children = _a.children, leftIcon = _a.leftIcon, rightIcon = _a.rightIcon, props = __rest(_a, ["children", "leftIcon", "rightIcon"]);
    return (React.createElement(AppBarMenuItem$1, __assign({}, props),
        React.createElement(MenuItemIcon, null, leftIcon && React.createElement(Icon, { icon: leftIcon, className: 'left-icon' })),
        React.createElement(Text, { size: 'v_16', color: 'gray_700', weight: 'v_500' }, children),
        rightIcon && (React.createElement(MenuItemIcon, null,
            React.createElement(Icon, { icon: rightIcon })))));
};

var StepContainer = styled.div(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"])));
var StepTitle$1 = styled.div(templateObject_2$3 || (templateObject_2$3 = __makeTemplateObject(["\n  margin-left: 8px;\n  ", ";\n  \n  & > :first-child {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n"], ["\n  margin-left: 8px;\n  ", ";\n  \n  & > :first-child {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n"])), function (_a) {
    var theme = _a.theme, storyline = _a.storyline;
    return ({
        fontFamily: theme.font.family.regular,
        fontSize: theme.font.size.v_16,
        marginRight: !storyline && '0.5rem'
    });
});
var Step$1 = styled.div(templateObject_4$2 || (templateObject_4$2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  flex-basis: fit-content;\n  \n  ", "{\n    position: relative;\n    ", "\n\n\n    ", "\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  flex-basis: fit-content;\n  \n  ", "{\n    position: relative;\n    ", "\n\n\n    ", "\n  }\n"])), StepTitle$1, function (_a) {
    var $markerData = _a.$markerData, $orientation = _a.$orientation, storyline = _a.storyline;
    return $orientation === 'horizontal' && css(templateObject_3$2 || (templateObject_3$2 = __makeTemplateObject(["\n      ", ";\n      min-height: ", ";\n      display: flex;\n   "], ["\n      ", ";\n      min-height: ", ";\n      display: flex;\n   "])), storyline && 'max-width: 50%', $markerData.height);
}, function (_a) {
    var $alignmentData = _a.$alignmentData;
    return $alignmentData && $alignmentData.step;
});
var StepMarkerWrapper = styled.div(templateObject_6$1 || (templateObject_6$1 = __makeTemplateObject(["\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n"])), function (_a) {
    var $orientation = _a.$orientation;
    return $orientation === 'vertical' && css(templateObject_5$1 || (templateObject_5$1 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n  "], ["\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n  "])));
}, function (_a) {
    var $alignmentData = _a.$alignmentData;
    return $alignmentData && $alignmentData.marker;
});
var StoryLineWrapper = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  \n  ", "\n  \n  ", "\n  \n  \n"], ["\n  display: flex;\n  align-items: center;\n  \n  ", "\n  \n  ", "\n  \n  \n"])), function (_a) {
    var $markerData = _a.$markerData, $orientation = _a.$orientation, $hasTitle = _a.$hasTitle;
    return $orientation === 'horizontal' && css(templateObject_7$1 || (templateObject_7$1 = __makeTemplateObject(["\n    flex: 1;\n    height: ", ";\n    padding: ", ";\n  "], ["\n    flex: 1;\n    height: ", ";\n    padding: ", ";\n  "])), $markerData.height, $hasTitle && '0 0.5rem');
}, function (_a) {
    var $markerData = _a.$markerData, $orientation = _a.$orientation;
    return $orientation === 'vertical' && {
        height: "calc(100% - " + $markerData.height + ")"
    };
});
var StepMarker = styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  ", "\n\n  ", "\n"], ["\n  ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  ", "\n\n  ", "\n"])), function (_a) {
    var $markerData = _a.$markerData, color = _a.color, theme = _a.theme, markerTextColor = _a.markerTextColor;
    return ({
        height: $markerData.height,
        width: $markerData.width,
        borderRadius: $markerData.radius,
        background: color !== 'blank' && solveThemeValue(theme.color, color),
        color: solveThemeValue(theme.color, markerTextColor),
        fontSize: theme.font.size.v_14,
        fontFamily: theme.font.family.regular
    });
}, function (_a) {
    var color = _a.color, theme = _a.theme, icon = _a.icon;
    return color === 'blank' && icon == null && {
        border: "3px solid " + theme.color.gray_500,
        boxSizing: 'border-box'
    };
}, function (_a) {
    var icon = _a.icon;
    return icon != null && css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    img {\n      width: 100%;\n      height: 100%;\n    }\n  "], ["\n    img {\n      width: 100%;\n      height: 100%;\n    }\n  "])));
});
var StoryLine = styled.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  \n  // Horizontal\n  ", ";\n  \n  // Vertical\n  ", ";\n  \n  background-color: ", ";\n"], ["\n  \n  // Horizontal\n  ", ";\n  \n  // Vertical\n  ", ";\n  \n  background-color: ", ";\n"])), function (_a) {
    var $orientation = _a.$orientation;
    return $orientation === 'horizontal' && {
        height: '1px',
        width: '100%'
    };
}, function (_a) {
    var $orientation = _a.$orientation;
    return $orientation === 'vertical' && {
        height: '100%',
        width: '1px',
        minHeight: '1.625rem'
    };
}, function (props) { return props.theme.color.gray_400; });
var StepContent = styled.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  ", ";\n  flex-basis: auto;\n  width: 100%;\n  align-self: flex-start;\n  margin-top: 0.5rem;\n  margin-right: 0.5rem;\n  padding-bottom: 0.5rem;\n  margin-left: 8px;\n"], ["\n  ", ";\n  flex-basis: auto;\n  width: 100%;\n  align-self: flex-start;\n  margin-top: 0.5rem;\n  margin-right: 0.5rem;\n  padding-bottom: 0.5rem;\n  margin-left: 8px;\n"])), function (_a) {
    var theme = _a.theme;
    return ({
        fontFamily: theme.font.family.regular,
        fontSize: theme.font.size.v_16
    });
});
styled.div(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  ", ";\n  width: 100%;\n  align-self: flex-start;\n"], ["\n  ", ";\n  width: 100%;\n  align-self: flex-start;\n"])), function (_a) {
    var theme = _a.theme;
    return ({
        fontFamily: theme.font.family.regular,
        fontSize: theme.font.size.v_12
    });
});
var ProgressStep$1 = styled.div(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  display: grid;\n  ", ";\n  ", "\n  ", ";\n"], ["\n  display: grid;\n  ", ";\n  ", "\n  ", ";\n"])), function (props) {
    return props.$orientation === 'horizontal' && {
        'grid-auto-columns': '1fr',
        'grid-auto-flow': 'column'
    };
}, function (props) { return props.$alignmentData && props.$alignmentData.content; }, function (props) { return props.$orientation === 'vertical' && {
    'grid-template-columns': '1fr'
}; });
var templateObject_1$4, templateObject_2$3, templateObject_3$2, templateObject_4$2, templateObject_5$1, templateObject_6$1, templateObject_7$1, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14;

var ProgressStep = function (_a) {
    var showStepNumber = _a.showStepNumber, children = _a.children, orientation = _a.orientation, align = _a.align, props = __rest(_a, ["showStepNumber", "children", "orientation", "align"]);
    var themeContext = useContext(ThemeContext);
    var alignData = useMemo(function () {
        var variant = solveVariant(themeContext.progressStep.alignment, orientation, 'horizontal', false);
        return variant[align] || null;
    }, [align]);
    var len = React.Children.count(children);
    children = React.Children.map(children, function (child, index) {
        if (React.isValidElement(child)) {
            return React.cloneElement(child, {
                key: index,
                orientation: orientation,
                stepIndex: index + 1,
                showStepNumber: showStepNumber,
                alignData: alignData,
                isLastStep: len === index + 1
            });
        }
        return child;
    });
    return (React.createElement(ProgressStep$1, __assign({}, props, { "$orientation": orientation, "$alignmentData": alignData }), children));
};
ProgressStep.defaultProps = {
    orientation: 'horizontal',
    showStepNumber: false,
    align: 'top'
};

var Step = function (_a) {
    var children = _a.children, orientation = _a.orientation, storyline = _a.storyline, isLastStep = _a.isLastStep, alignData = _a.alignData, props = __rest(_a, ["children", "orientation", "storyline", "isLastStep", "alignData"]);
    // Variant Data
    var themeContext = useContext(ThemeContext);
    // Marker Data
    // Calculating once to avoid poor performance
    var markerData = useMemo(function () {
        var sizeVariant = solveVariant(themeContext.progressStep.size, props.size, 'small', false);
        return sizeVariant[props.marker] || sizeVariant.circle || {};
    }, [props.size, props.marker]);
    // Using StepTitle and StepDescription enables the
    // developers to have more flexibility to customize the
    // the title as they like.
    //
    // Extracting theses elements from the children to use in
    // the correct place for this component
    var title = null;
    var description = null;
    React.Children.forEach(children, function (child) {
        if (React.isValidElement(child)) {
            var role = child.props.role;
            child = React.cloneElement(child, { $orientation: orientation, storyline: storyline });
            if (role === 'title') {
                title = child;
            }
            else if (role === 'description') {
                description = child;
            }
        }
    });
    var sharedProps = {
        $hasTitle: title !== null,
        $hasDescription: description !== null,
        $markerData: markerData,
        $orientation: orientation,
        $alignmentData: alignData
    };
    var storyLine = storyline && (!isLastStep || !title) && (React.createElement(StoryLineWrapper, __assign({}, sharedProps),
        React.createElement(StoryLine, __assign({}, sharedProps), "\u00A0")));
    var isVertical = orientation === 'vertical';
    var isHorizontal = orientation === 'horizontal';
    return (React.createElement(StepContainer, null,
        React.createElement(Step$1, __assign({}, props, sharedProps, { "$markerData": markerData }),
            React.createElement(StepMarkerWrapper, __assign({}, sharedProps, { "data-testid": "step-marker-wrapper-" + props.stepIndex }),
                React.createElement(StepMarker, { color: props.color, icon: props.icon, "data-testid": "step-marker-" + props.stepIndex, markerTextColor: props.markerTextColor, "$markerData": markerData },
                    props.showStepNumber ? props.stepIndex : '',
                    props.icon && (React.createElement("img", { src: props.icon, "data-testid": "step-marker-icon-" + props.stepIndex, alt: 'step-icon' }))),
                isVertical && storyLine),
            React.createElement("div", null,
                title,
                isVertical && description),
            isHorizontal && storyLine),
        isHorizontal && description));
};
Step.defaultProps = {
    showStepNumber: false,
    marker: 'circle',
    color: 'blank',
    markerTextColor: 'black',
    size: 'small',
    isLastStep: false,
    storyline: true
};

var StepTitle = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return React.createElement(StepTitle$1, __assign({}, props), children);
};
StepTitle.defaultProps = {
    role: 'title'
};

var StepDescription = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return React.createElement(StepContent, __assign({}, props), children);
};
StepDescription.defaultProps = {
    role: 'description'
};

var ProgressBar$1 = styled.div(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n  display: block;\n  width: 100%;\n"], ["\n  display: block;\n  width: 100%;\n"])));
var InnerBar = styled.div(templateObject_2$2 || (templateObject_2$2 = __makeTemplateObject([""], [""])));
var Bar = styled.div(templateObject_3$1 || (templateObject_3$1 = __makeTemplateObject(["\n  display: block;\n  width: 100%;\n  position: relative;\n  overflow: hidden;\n  ", "\n  border-radius: ", ";\n  ", "{\n    position: absolute;\n    left: 0;\n    top: 0;\n    content: ' ';\n    border-radius: ", ";\n    ", "\n  }\n"], ["\n  display: block;\n  width: 100%;\n  position: relative;\n  overflow: hidden;\n  ", "\n  border-radius: ", ";\n  ", "{\n    position: absolute;\n    left: 0;\n    top: 0;\n    content: ' ';\n    border-radius: ", ";\n    ", "\n  }\n"])), function (_a) {
    var height = _a.height, foregroundColor = _a.foregroundColor;
    return ({
        height: height,
        background: solveThemeValue(theme.color, foregroundColor, foregroundColor)
    });
}, theme.radius.v_5, InnerBar, theme.radius.v_5, function (_a) {
    var height = _a.height, color = _a.color, value = _a.value;
    return ({
        height: height,
        width: value + "%",
        background: solveThemeValue(theme.color, color, color)
    });
});
var ProgressContent = styled.div(templateObject_4$1 || (templateObject_4$1 = __makeTemplateObject(["\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-gap: 20px;\n  margin-top: 8px;\n  > *:first-child {\n    text-align: left;\n  }\n\n  > *:last-child {\n    text-align: right;\n  }\n"], ["\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-gap: 20px;\n  margin-top: 8px;\n  > *:first-child {\n    text-align: left;\n  }\n\n  > *:last-child {\n    text-align: right;\n  }\n"])));
var templateObject_1$3, templateObject_2$2, templateObject_3$1, templateObject_4$1;

var ProgressBar = function (_a) {
    var id = _a.id, color = _a.color, foregroundColor = _a.foregroundColor, value = _a.value, height = _a.height, leftContent = _a.leftContent, rightContent = _a.rightContent, props = __rest(_a, ["id", "color", "foregroundColor", "value", "height", "leftContent", "rightContent"]);
    value = value < 0 ? 0 : Math.min(value, 100);
    return (React.createElement(ProgressBar$1, __assign({}, props, { "data-testid": id }),
        React.createElement(Bar, { value: value, color: color, height: height, foregroundColor: foregroundColor, "data-testid": id + "-bar" },
            React.createElement(InnerBar, { "data-testid": id + "-bar-inner" })),
        React.createElement(ProgressContent, { "data-testid": id + "-content" },
            React.createElement("div", null, leftContent),
            React.createElement("div", null, rightContent))));
};
ProgressBar.defaultProps = {
    height: '8px',
    foregroundColor: 'gray_200',
    color: 'skyblue_600',
    value: 0
};

var DataTable$1 = styled.table(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n  width: 100%;\n  border-spacing: 0;\n  border-collapse: collapse;\n"], ["\n  width: 100%;\n  border-spacing: 0;\n  border-collapse: collapse;\n"])));
var DataTableCell$1 = styled.td(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject(["\n  align-items: center;\n  position: relative;\n  z-index: 1;\n  \n  ", "\n  \n  :first-child {\n    padding-left: ", ";\n  }\n\n  :last-child {\n    padding-right: ", ";\n    border-bottom: 0\n  }\n"], ["\n  align-items: center;\n  position: relative;\n  z-index: 1;\n  \n  ", "\n  \n  :first-child {\n    padding-left: ", ";\n  }\n\n  :last-child {\n    padding-right: ", ";\n    border-bottom: 0\n  }\n"])), function (_a) {
    var $variantData = _a.$variantData, align = _a.align;
    var columnGap = $variantData.columnGap, rowsPadding = $variantData.rowsPadding, rowsGap = $variantData.rowsGap;
    return {
        justifyContent: align && CellTextAlignment[align],
        padding: [
            rowsPadding[0],
            "calc(" + columnGap + " / 2)",
            "calc(" + rowsPadding[2] + " + " + rowsGap + ")",
            "calc(" + columnGap + " / 2)"
        ].join(' ')
    };
}, function (props) { return props.$variantData.rowsPadding[3]; }, function (props) { return "calc(" + props.$variantData.rowsPadding[1] + " + 0.5rem)"; });
var DataTableEmptyRow = styled.tr(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\n  td {\n    padding-bottom: ", ";\n    ", "\n  }\n"], ["\n\n  td {\n    padding-bottom: ", ";\n    ", "\n  }\n"])), function (props) { return props.$variantData.rowsGap; }, function (props) { return !props.margin && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      :first-child {\n        padding-left: 0;\n      }\n\n      &:last-child {\n        padding-right: 0;\n      }\n    "], ["\n      :first-child {\n        padding-left: 0;\n      }\n\n      &:last-child {\n        padding-right: 0;\n      }\n    "]))); });
var DataTableRow$1 = styled.tr(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  ", "\n  position: relative;\n  \n  &:before {\n    content: ' ';\n    width: 100%;\n    position: absolute;\n\n    transition: background-color 0.3s ease;\n    \n    ", "\n  }\n\n  ", "\n  \n  &:after {\n    content: ' ';\n    position: absolute;\n    left: 0;\n    ", "\n  }\n"], ["\n  ", "\n  position: relative;\n  \n  &:before {\n    content: ' ';\n    width: 100%;\n    position: absolute;\n\n    transition: background-color 0.3s ease;\n    \n    ", "\n  }\n\n  ", "\n  \n  &:after {\n    content: ' ';\n    position: absolute;\n    left: 0;\n    ", "\n  }\n"])), function (_a) {
    var theme = _a.theme, $variantData = _a.$variantData, type = _a.type;
    return ({
        fontSize: solveThemeValue(theme.font.size, $variantData[type].fontSize, 'v_16'),
        fontFamily: solveThemeValue(theme.font.family, $variantData[type].fontFamily, 'normal'),
        fontWeight: solveThemeValue(theme.font.weight, $variantData[type].fontWeight, 'normal'),
        color: solveThemeValue(theme.color, $variantData[type].textColor),
        borderBottom: $variantData[type].borderBottom
    });
}, function (_a) {
    var theme = _a.theme, $variantData = _a.$variantData, type = _a.type, disabled = _a.disabled;
    return ({
        height: "calc(100% - " + $variantData.rowsGap + ")",
        borderRadius: solveThemeValue(theme.radius, $variantData[type].radius),
        background: solveThemeValue(theme.color, !disabled ? $variantData[type].backgroundColor : $variantData[type].disabledBackgroundColor),
        boxShadow: solveThemeValue(theme.boxShadow, $variantData[type].boxShadow)
    });
}, function (_a) {
    var type = _a.type, $variantData = _a.$variantData, hover = _a.hover, disabled = _a.disabled;
    return (hover && !disabled) && css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      &:hover { cursor: pointer; }\n      &:hover:before {\n        background: ", ";\n      }\n  "], ["\n      &:hover { cursor: pointer; }\n      &:hover:before {\n        background: ", ";\n      }\n  "])), $variantData[type].hoverBackground);
}, function (_a) {
    var theme = _a.theme, color = _a.color, $variantData = _a.$variantData, type = _a.type;
    var radius = solveThemeValue(theme.radius, $variantData[type].radius);
    return color && {
        width: '8px',
        height: "calc(100% - " + $variantData.rowsGap + ")",
        backgroundColor: solveThemeValue(theme.color, color),
        borderRadius: radius + " 0 0 " + radius
    };
});
var DataArrowAction$1 = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  background: #F8F9FB 0% 0% no-repeat padding-box;\n  width: 28px;\n  position: absolute;\n  right: 0;\n  top: 0;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  ", "\n  \n  img {\n    width: 6px;\n  }\n"], ["\n  background: #F8F9FB 0% 0% no-repeat padding-box;\n  width: 28px;\n  position: absolute;\n  right: 0;\n  top: 0;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  ", "\n  \n  img {\n    width: 6px;\n  }\n"])), function (_a) {
    var theme = _a.theme, $variantData = _a.$variantData;
    var radius = solveThemeValue(theme.radius, $variantData.data.radius);
    return {
        height: "calc(100% - " + $variantData.rowsGap + ")",
        borderRadius: "0 " + radius + " " + radius + " 0"
    };
});
var templateObject_1$2, templateObject_2$1, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;

var DataTable = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var headers = [];
    var rows = [];
    var themeContext = useContext(ThemeContext);
    // Variant Data
    // Calculating once to avoid poor performance
    var variantData = useMemo(function () {
        return solveVariant(themeContext.table.variant, props.variant, 'default', false);
    }, [props.variant]);
    React.Children.forEach(children, function (child, index) {
        if (React.isValidElement(child)) {
            (child.props.type === 'header' ? headers : rows).push(React.cloneElement(child, {
                key: index,
                variantData: variantData
            }));
        }
    });
    return (React.createElement(DataTable$1, __assign({}, props, { "$variantData": variantData }),
        React.createElement("thead", null, headers),
        React.createElement("tbody", null, rows)));
};
DataTable.defaultProps = {
    variant: 'default'
};

var DataTableRow = function (_a) {
    var children = _a.children, variantData = _a.variantData, empty = _a.empty, props = __rest(_a, ["children", "variantData", "empty"]);
    children = forwardPropsToChildren(children, { variantData: variantData });
    return (!empty ? (React.createElement(DataTableRow$1, __assign({}, props, { "$variantData": variantData }), children)) : (React.createElement(DataTableEmptyRow, __assign({}, props, { "$variantData": variantData }), children)));
};
DataTableRow.defaultProps = {
    type: 'data',
    empty: false,
    hover: false,
    margin: true,
    disabled: false
};

var DataTableCell = function (_a) {
    var children = _a.children, variantData = _a.variantData, props = __rest(_a, ["children", "variantData"]);
    // Propagate variantData without affect other components
    children = React.Children.map(children, function (child) {
        if (React.isValidElement(child) && child.props.role === 'arrow-action') {
            return React.cloneElement(child, { variantData: variantData });
        }
        return child;
    });
    return (React.createElement(DataTableCell$1, __assign({}, props, { "$variantData": variantData }), children));
};
DataTableCell.defaultProps = {
    disabled: false,
    type: 'data',
    align: 'left'
};

var img = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='5.44' height='8.592' viewBox='0 0 5.44 8.592'%3e %3cpath id='angle_right_small' d='M3.468.883l-.347.347L.6%2c3.752a.383.383%2c0%2c0%2c1-.506%2c0%2c.383.383%2c0%2c0%2c1%2c0-.5L3.247.095a.383.383%2c0%2c0%2c1%2c.5%2c0L6.9%2c3.246a.383.383%2c0%2c0%2c1%2c0%2c.506.383.383%2c0%2c0%2c1-.5%2c0L3.878%2c1.23Z' transform='translate(4.644 0.796) rotate(90)' fill='%230052CC' stroke='%230052CC' stroke-width='1.5'/%3e%3c/svg%3e";

var DataArrowAction = function (_a) {
    var id = _a.id, onClick = _a.onClick, variantData = _a.variantData, props = __rest(_a, ["id", "onClick", "variantData"]);
    var handleClick = function (e) {
        e.stopPropagation();
        onClick();
    };
    return (React.createElement(DataArrowAction$1, __assign({ "data-testid": id }, props, { onClick: handleClick, "$variantData": variantData }),
        React.createElement(Icon, { icon: img })));
};
DataArrowAction.defaultProps = {
    onClick: function () { },
    role: 'arrow-action'
};

var Spinner$1 = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  position: relative;\n  .sk-circle {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    left: 0;\n    top: 0;\n  }\n\n  .sk-circle:before {\n    content: '';\n    display: block;\n    margin: 0 auto;\n    width: 15%;\n    height: 15%;\n    background-color: ", ";\n    border-radius: 100%;\n    -webkit-animation: sk-circleFadeDelay 1.2s infinite ease-in-out both;\n    animation: sk-circleFadeDelay 1.2s infinite ease-in-out both;\n  }\n  .sk-circle2 {\n    -webkit-transform: rotate(30deg);\n    -ms-transform: rotate(30deg);\n    transform: rotate(30deg);\n  }\n  \n  .sk-circle3 {\n    -webkit-transform: rotate(60deg);\n    -ms-transform: rotate(60deg);\n    transform: rotate(60deg);\n  }\n  \n  .sk-circle4 {\n    -webkit-transform: rotate(90deg);\n    -ms-transform: rotate(90deg);\n    transform: rotate(90deg);\n  }\n  \n  .sk-circle5 {\n    -webkit-transform: rotate(120deg);\n    -ms-transform: rotate(120deg);\n    transform: rotate(120deg);\n  }\n  \n  .sk-circle6 {\n    -webkit-transform: rotate(150deg);\n    -ms-transform: rotate(150deg);\n    transform: rotate(150deg);\n  }\n  \n  .sk-circle7 {\n    -webkit-transform: rotate(180deg);\n    -ms-transform: rotate(180deg);\n    transform: rotate(180deg);\n  }\n  \n  .sk-circle8 {\n    -webkit-transform: rotate(210deg);\n    -ms-transform: rotate(210deg);\n    transform: rotate(210deg);\n  }\n  \n  .sk-circle9 {\n    -webkit-transform: rotate(240deg);\n    -ms-transform: rotate(240deg);\n    transform: rotate(240deg);\n  }\n  \n  .sk-circle10 {\n    -webkit-transform: rotate(270deg);\n    -ms-transform: rotate(270deg);\n    transform: rotate(270deg);\n  }\n  \n  .sk-circle11 {\n    -webkit-transform: rotate(300deg);\n    -ms-transform: rotate(300deg);\n    transform: rotate(300deg);\n  }\n  \n  .sk-circle12 {\n    -webkit-transform: rotate(330deg);\n    -ms-transform: rotate(330deg);\n    transform: rotate(330deg);\n  }\n  \n  .sk-circle2:before {\n    -webkit-animation-delay: -1.1s;\n    animation-delay: -1.1s;\n  }\n  \n  .sk-circle3:before {\n    -webkit-animation-delay: -1s;\n    animation-delay: -1s;\n  }\n  \n  .sk-circle4:before {\n    -webkit-animation-delay: -0.9s;\n    animation-delay: -0.9s;\n  }\n  \n  .sk-circle5:before {\n    -webkit-animation-delay: -0.8s;\n    animation-delay: -0.8s;\n  }\n  \n  .sk-circle6:before {\n    -webkit-animation-delay: -0.7s;\n    animation-delay: -0.7s;\n  }\n  \n  .sk-circle7:before {\n    -webkit-animation-delay: -0.6s;\n    animation-delay: -0.6s;\n  }\n  \n  .sk-circle8:before {\n    -webkit-animation-delay: -0.5s;\n    animation-delay: -0.5s;\n  }\n  \n  .sk-circle9:before {\n    -webkit-animation-delay: -0.4s;\n    animation-delay: -0.4s;\n  }\n  \n  .sk-circle10:before {\n    -webkit-animation-delay: -0.3s;\n    animation-delay: -0.3s;\n  }\n  \n  .sk-circle11:before {\n    -webkit-animation-delay: -0.2s;\n    animation-delay: -0.2s;\n  }\n  .sk-circle12:before {\n    -webkit-animation-delay: -0.1s;\n    animation-delay: -0.1s;\n  }\n\n  @-webkit-keyframes sk-circleFadeDelay {\n    0%, 39%, 100% { opacity: 0; }\n    40% { opacity: 1; }\n  }\n\n  @keyframes sk-circleFadeDelay {\n    0%, 39%, 100% { opacity: 0; }\n    40% { opacity: 1; }\n  }\n"], ["\n  ", ";\n  position: relative;\n  .sk-circle {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    left: 0;\n    top: 0;\n  }\n\n  .sk-circle:before {\n    content: '';\n    display: block;\n    margin: 0 auto;\n    width: 15%;\n    height: 15%;\n    background-color: ", ";\n    border-radius: 100%;\n    -webkit-animation: sk-circleFadeDelay 1.2s infinite ease-in-out both;\n    animation: sk-circleFadeDelay 1.2s infinite ease-in-out both;\n  }\n  .sk-circle2 {\n    -webkit-transform: rotate(30deg);\n    -ms-transform: rotate(30deg);\n    transform: rotate(30deg);\n  }\n  \n  .sk-circle3 {\n    -webkit-transform: rotate(60deg);\n    -ms-transform: rotate(60deg);\n    transform: rotate(60deg);\n  }\n  \n  .sk-circle4 {\n    -webkit-transform: rotate(90deg);\n    -ms-transform: rotate(90deg);\n    transform: rotate(90deg);\n  }\n  \n  .sk-circle5 {\n    -webkit-transform: rotate(120deg);\n    -ms-transform: rotate(120deg);\n    transform: rotate(120deg);\n  }\n  \n  .sk-circle6 {\n    -webkit-transform: rotate(150deg);\n    -ms-transform: rotate(150deg);\n    transform: rotate(150deg);\n  }\n  \n  .sk-circle7 {\n    -webkit-transform: rotate(180deg);\n    -ms-transform: rotate(180deg);\n    transform: rotate(180deg);\n  }\n  \n  .sk-circle8 {\n    -webkit-transform: rotate(210deg);\n    -ms-transform: rotate(210deg);\n    transform: rotate(210deg);\n  }\n  \n  .sk-circle9 {\n    -webkit-transform: rotate(240deg);\n    -ms-transform: rotate(240deg);\n    transform: rotate(240deg);\n  }\n  \n  .sk-circle10 {\n    -webkit-transform: rotate(270deg);\n    -ms-transform: rotate(270deg);\n    transform: rotate(270deg);\n  }\n  \n  .sk-circle11 {\n    -webkit-transform: rotate(300deg);\n    -ms-transform: rotate(300deg);\n    transform: rotate(300deg);\n  }\n  \n  .sk-circle12 {\n    -webkit-transform: rotate(330deg);\n    -ms-transform: rotate(330deg);\n    transform: rotate(330deg);\n  }\n  \n  .sk-circle2:before {\n    -webkit-animation-delay: -1.1s;\n    animation-delay: -1.1s;\n  }\n  \n  .sk-circle3:before {\n    -webkit-animation-delay: -1s;\n    animation-delay: -1s;\n  }\n  \n  .sk-circle4:before {\n    -webkit-animation-delay: -0.9s;\n    animation-delay: -0.9s;\n  }\n  \n  .sk-circle5:before {\n    -webkit-animation-delay: -0.8s;\n    animation-delay: -0.8s;\n  }\n  \n  .sk-circle6:before {\n    -webkit-animation-delay: -0.7s;\n    animation-delay: -0.7s;\n  }\n  \n  .sk-circle7:before {\n    -webkit-animation-delay: -0.6s;\n    animation-delay: -0.6s;\n  }\n  \n  .sk-circle8:before {\n    -webkit-animation-delay: -0.5s;\n    animation-delay: -0.5s;\n  }\n  \n  .sk-circle9:before {\n    -webkit-animation-delay: -0.4s;\n    animation-delay: -0.4s;\n  }\n  \n  .sk-circle10:before {\n    -webkit-animation-delay: -0.3s;\n    animation-delay: -0.3s;\n  }\n  \n  .sk-circle11:before {\n    -webkit-animation-delay: -0.2s;\n    animation-delay: -0.2s;\n  }\n  .sk-circle12:before {\n    -webkit-animation-delay: -0.1s;\n    animation-delay: -0.1s;\n  }\n\n  @-webkit-keyframes sk-circleFadeDelay {\n    0%, 39%, 100% { opacity: 0; }\n    40% { opacity: 1; }\n  }\n\n  @keyframes sk-circleFadeDelay {\n    0%, 39%, 100% { opacity: 0; }\n    40% { opacity: 1; }\n  }\n"])), function (props) { return css(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n    width: ", ";\n    height: ", ";\n  "], ["\n    width: ", ";\n    height: ", ";\n  "])), props.size, props.size); }, function (_a) {
    var theme = _a.theme, color = _a.color;
    return solveThemeValue(theme.color, color);
});
var templateObject_1$1, templateObject_2;

var Spinner = function (props) {
    return (React.createElement(Spinner$1, __assign({ className: "sk-fading-circle" }, props),
        React.createElement("div", { className: "sk-circle1 sk-circle" }),
        React.createElement("div", { className: "sk-circle2 sk-circle" }),
        React.createElement("div", { className: "sk-circle3 sk-circle" }),
        React.createElement("div", { className: "sk-circle4 sk-circle" }),
        React.createElement("div", { className: "sk-circle5 sk-circle" }),
        React.createElement("div", { className: "sk-circle6 sk-circle" }),
        React.createElement("div", { className: "sk-circle7 sk-circle" }),
        React.createElement("div", { className: "sk-circle8 sk-circle" }),
        React.createElement("div", { className: "sk-circle9 sk-circle" }),
        React.createElement("div", { className: "sk-circle10 sk-circle" }),
        React.createElement("div", { className: "sk-circle11 sk-circle" }),
        React.createElement("div", { className: "sk-circle12 sk-circle" })));
};

var StyledTag = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 12px 30px;\n  width: auto;\n  border-radius: 2.8rem;\n  display: unset;\n  background-color: ", ";\n  span {\n    margin-bottom: 0;\n  }\n"], ["\n  padding: 12px 30px;\n  width: auto;\n  border-radius: 2.8rem;\n  display: unset;\n  background-color: ", ";\n  span {\n    margin-bottom: 0;\n  }\n"])), function (props) { return solveThemeValue(theme.color, props.bg); });
var templateObject_1;

var Tag = function (_a) {
    var weight = _a.weight, size = _a.size, color = _a.color, family = _a.family, props = __rest(_a, ["weight", "size", "color", "family"]);
    return (React.createElement(StyledTag, __assign({}, props),
        React.createElement(Text, { weight: weight, size: size, color: color, family: family, as: 'span' }, props.children)));
};
Tag.defaultProps = {
    size: 'v_16',
    color: 'white',
    weight: 'v_500',
    bg: 'blue_300'
};

var _a;
var THEMES = (_a = {},
    _a[DEFAULT_THEME] = themeDefault,
    _a);
var mergeTheme = function (theme1, theme2) {
    return cjs(theme1, theme2);
};
var solveTheme = function (theme) {
    if (typeof theme === 'string') {
        return THEMES[theme] || THEMES[DEFAULT_THEME];
    }
    return mergeTheme(THEMES[DEFAULT_THEME], theme);
};

var GlobalStyles = function (_a) {
    var children = _a.children, theme = _a.theme;
    return (React.createElement(ThemeProvider, { theme: solveTheme(theme) },
        React.createElement(Helmet, null,
            React.createElement("style", { type: "text/css" }, "@import url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro:ital,wght@0,200;0,300;0,400;0,600;0,700;0,900;1,200;1,300;1,400;1,600;1,700;1,900&display=swap'); @import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');")),
        children));
};
GlobalStyles.defaultProps = {
    theme: DEFAULT_THEME
};

export { Alert, AppBar, AppBarMenu, AppBarMenuItem, Box, Button, Cnpj, CnpjInput, Cpf, CpfInput, DataArrowAction, DataTable, DataTableCell, DataTableRow, Dropdown, FixedMenu, Gauge, GlobalStyles, Icon, IconAngleDown, IconClose, IconEmojiError, IconEmojiSuccess, IconEmojiWarning, IconFav, IconInformation, IconLock, IconOrderBy, IconPhone, IconPlace, IconSearch, IconSuccess, IconWhats, InputCheckbox, InputPassword, InputRadio, InputText, InputTextArea, LocalDate, LocalDateInput, Logo, MenuItem, MenuTab, MenuTabItem, NumberPC, NumberPCInput, Phone, PhoneNumberInput, ProgressBar, ProgressStep, Real, RealInput, SideBar, SideBarMenuItem, SideBarMenuItemText, SideBarTitle, Spinner, Step, StepDescription, StepTitle, Switcher, Tab, Tabs, Tag, Text, UserBadge };
//# sourceMappingURL=bundle.es.js.map
